var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect2, _rect3, _g2, _rect4, _rect5, _g3, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorldMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 632,
    height: 462,
    viewBox: "0 0 632 462",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 632,
    height: 462,
    fill: "#2F7175"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.774 226.179H311.702L310.166 223.546L311.702 220.913H314.774L316.266 223.546L314.774 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.024 229.515H305.996L304.46 226.838L305.996 224.204H309.024L310.561 226.838L309.024 229.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.774 232.807H311.702L310.166 230.173L311.702 227.496H314.774L316.266 230.173L314.774 232.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 229.515H317.451L315.915 226.838L317.451 224.204H320.479L322.016 226.838L320.479 229.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 222.888H317.451L315.915 220.254L317.451 217.577H320.479L322.016 220.254L320.479 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.774 219.596H311.702L310.166 216.919L311.702 214.286H314.774L316.266 216.919L314.774 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.024 222.888H305.996L304.46 220.254L305.996 217.577H309.024L310.561 220.254L309.024 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.319 232.807H300.247L298.711 230.173L300.247 227.496H303.319L304.811 230.173L303.319 232.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.024 236.098H305.996L304.46 233.465L305.996 230.832H309.024L310.561 233.465L309.024 236.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.774 239.434H311.702L310.166 236.757L311.702 234.123H314.774L316.266 236.757L314.774 239.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 236.098H317.451L315.915 233.465L317.451 230.832H320.479L322.016 233.465L320.479 236.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 232.807H323.157L321.621 230.173L323.157 227.496H326.229L327.765 230.173L326.229 232.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 226.179H323.157L321.621 223.546L323.157 220.913H326.229L327.765 223.546L326.229 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 219.596H323.157L321.621 216.919L323.157 214.286H326.229L327.765 216.919L326.229 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 216.261H317.451L315.915 213.627L317.451 210.994H320.479L322.016 213.627L320.479 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.774 212.969H311.702L310.166 210.336L311.702 207.658H314.774L316.266 210.336L314.774 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.024 216.261H305.996L304.46 213.627L305.996 210.994H309.024L310.561 213.627L309.024 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.319 219.596H300.247L298.711 216.919L300.247 214.286H303.319L304.811 216.919L303.319 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.319 226.179H300.247L298.711 223.546L300.247 220.913H303.319L304.811 223.546L303.319 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.569 236.098H294.541L293.005 233.465L294.541 230.832H297.569L299.106 233.465L297.569 236.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.319 239.434H300.247L298.711 236.757L300.247 234.123H303.319L304.811 236.757L303.319 239.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.024 242.726H305.996L304.46 240.092L305.996 237.459H309.024L310.561 240.092L309.024 242.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.774 246.017H311.702L310.166 243.384L311.702 240.751H314.774L316.266 243.384L314.774 246.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 242.726H317.451L315.915 240.092L317.451 237.459H320.479L322.016 240.092L320.479 242.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 239.434H323.157L321.621 236.757L323.157 234.123H326.229L327.765 236.757L326.229 239.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 236.098H328.906L327.37 233.465L328.906 230.832H331.934L333.471 233.465L331.934 236.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 229.515H328.906L327.37 226.838L328.906 224.204H331.934L333.471 226.838L331.934 229.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 222.888H328.906L327.37 220.254L328.906 217.577H331.934L333.471 220.254L331.934 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 216.261H328.906L327.37 213.627L328.906 210.994H331.934L333.471 213.627L331.934 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 212.969H323.157L321.621 210.336L323.157 207.658H326.229L327.765 210.336L326.229 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 209.677H317.451L315.915 207L317.451 204.367H320.479L322.016 207L320.479 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.774 206.342H311.702L310.166 203.708L311.702 201.075H314.774L316.266 203.708L314.774 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.024 209.677H305.996L304.46 207L305.996 204.367H309.024L310.561 207L309.024 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.319 212.969H300.247L298.711 210.336L300.247 207.658H303.319L304.811 210.336L303.319 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.569 216.261H294.541L293.005 213.627L294.541 210.994H297.569L299.106 213.627L297.569 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.569 222.888H294.541L293.005 220.254L294.541 217.577H297.569L299.106 220.254L297.569 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.569 229.515H294.541L293.005 226.838L294.541 224.204H297.569L299.106 226.838L297.569 229.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.864 239.434H288.792L287.256 236.757L288.792 234.123H291.864L293.356 236.757L291.864 239.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.569 242.726H294.541L293.005 240.092L294.541 237.459H297.569L299.106 240.092L297.569 242.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.319 246.017H300.247L298.711 243.384L300.247 240.751H303.319L304.811 243.384L303.319 246.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.024 249.353H305.996L304.46 246.719L305.996 244.042H309.024L310.561 246.719L309.024 249.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.774 252.644H311.702L310.166 250.011L311.702 247.378H314.774L316.266 250.011L314.774 252.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 249.353H317.451L315.915 246.719L317.451 244.042H320.479L322.016 246.719L320.479 249.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 246.017H323.157L321.621 243.384L323.157 240.751H326.229L327.765 243.384L326.229 246.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 242.726H328.906L327.37 240.092L328.906 237.459H331.934L333.471 240.092L331.934 242.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 239.434H334.612L333.076 236.757L334.612 234.123H337.684L339.22 236.757L337.684 239.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 232.807H334.612L333.076 230.173L334.612 227.496H337.684L339.22 230.173L337.684 232.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 226.179H334.612L333.076 223.546L334.612 220.913H337.684L339.22 223.546L337.684 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 219.596H334.612L333.076 216.919L334.612 214.286H337.684L339.22 216.919L337.684 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 212.969H334.612L333.076 210.336L334.612 207.658H337.684L339.22 210.336L337.684 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 209.677H328.906L327.37 207L328.906 204.367H331.934L333.471 207L331.934 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 206.342H323.157L321.664 203.708L323.157 201.075H326.229L327.721 203.708L326.229 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 203.006H317.451L315.959 200.417L317.451 197.783H320.479L321.972 200.417L320.479 203.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.774 199.714H311.702L310.166 197.081L311.702 194.448H314.774L316.266 197.081L314.774 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.024 203.05H305.996L304.46 200.417L305.996 197.739H309.024L310.561 200.417L309.024 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.319 206.342H300.247L298.711 203.708L300.247 201.075H303.319L304.811 203.708L303.319 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.569 209.677H294.541L293.005 207L294.541 204.367H297.569L299.106 207L297.569 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.864 212.969H288.792L287.256 210.336L288.792 207.658H291.864L293.356 210.336L291.864 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.864 219.596H288.792L287.256 216.919L288.792 214.286H291.864L293.356 216.919L291.864 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.864 226.179H288.792L287.256 223.546L288.792 220.913H291.864L293.356 223.546L291.864 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.864 232.807H288.792L287.256 230.173L288.792 227.496H291.864L293.356 230.173L291.864 232.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.114 242.726H283.042L281.55 240.092L283.042 237.459H286.114L287.651 240.092L286.114 242.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.864 246.017H288.792L287.256 243.384L288.792 240.751H291.864L293.356 243.384L291.864 246.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.569 249.353H294.541L293.005 246.719L294.541 244.042H297.569L299.106 246.719L297.569 249.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.319 252.644H300.247L298.711 250.011L300.247 247.378H303.319L304.811 250.011L303.319 252.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.024 255.98H305.996L304.46 253.303L305.996 250.669H309.024L310.561 253.303L309.024 255.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.774 259.272H311.702L310.166 256.638L311.702 253.961H314.774L316.266 256.638L314.774 259.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 255.98H317.451L315.915 253.303L317.451 250.669H320.479L322.016 253.303L320.479 255.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 252.644H323.157L321.621 250.011L323.157 247.378H326.229L327.765 250.011L326.229 252.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 249.353H328.906L327.37 246.719L328.906 244.042H331.934L333.471 246.719L331.934 249.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 246.017H334.612L333.076 243.384L334.612 240.751H337.684L339.22 243.384L337.684 246.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 242.726H340.361L338.825 240.092L340.361 237.459H343.389L344.926 240.092L343.389 242.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 236.098H340.361L338.825 233.465L340.361 230.832H343.389L344.926 233.465L343.389 236.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 229.515H340.361L338.825 226.838L340.361 224.204H343.389L344.926 226.838L343.389 229.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 222.888H340.361L338.825 220.254L340.361 217.577H343.389L344.926 220.254L343.389 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 216.261H340.361L338.825 213.627L340.361 210.994H343.389L344.926 213.627L343.389 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 209.677H340.361L338.825 207L340.361 204.367H343.389L344.926 207L343.389 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.508 206.122H334.743L333.383 203.708L334.743 201.294H337.508L338.913 203.708L337.508 206.122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.382 194.536H318.548L318.109 193.789L318.548 193.043H319.382L319.821 193.789L319.382 194.536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.159 192.122H312.272L311.351 190.498L312.272 188.83H314.159L315.125 190.498L314.159 192.122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.981 196.335H306.04L304.548 193.789L306.04 191.244H308.981L310.429 193.789L308.981 196.335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.319 199.714H300.247L298.711 197.081L300.247 194.448H303.319L304.811 197.081L303.319 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.569 203.05H294.541L293.005 200.417L294.541 197.739H297.569L299.106 200.417L297.569 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.864 206.342H288.792L287.256 203.708L288.792 201.075H291.864L293.356 203.708L291.864 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.114 209.677H283.042L281.55 207L283.042 204.367H286.114L287.651 207L286.114 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.114 216.261H283.042L281.55 213.627L283.042 210.994H286.114L287.651 213.627L286.114 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.114 222.888H283.042L281.55 220.254L283.042 217.577H286.114L287.651 220.254L286.114 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.114 229.515H283.042L281.55 226.838L283.042 224.204H286.114L287.651 226.838L286.114 229.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.114 236.098H283.042L281.55 233.465L283.042 230.832H286.114L287.651 233.465L286.114 236.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.409 246.017H277.337L275.801 243.384L277.337 240.751H280.409L281.901 243.384L280.409 246.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.114 249.353H283.042L281.55 246.719L283.042 244.042H286.114L287.651 246.719L286.114 249.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.864 252.644H288.792L287.256 250.011L288.792 247.378H291.864L293.356 250.011L291.864 252.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.569 255.98H294.541L293.005 253.303L294.541 250.669H297.569L299.106 253.303L297.569 255.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.319 259.272H300.247L298.711 256.638L300.247 253.961H303.319L304.811 256.638L303.319 259.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.024 262.563H305.996L304.46 259.93L305.996 257.297H309.024L310.561 259.93L309.024 262.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.94 264.451H312.536L311.833 263.222L312.536 261.993H313.94L314.642 263.222L313.94 264.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 262.563H317.451L315.915 259.93L317.451 257.297H320.479L322.016 259.93L320.479 262.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 259.272H323.157L321.621 256.638L323.157 253.961H326.229L327.765 256.638L326.229 259.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 255.98H328.906L327.37 253.303L328.906 250.669H331.934L333.471 253.303L331.934 255.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 252.644H334.612L333.076 250.011L334.612 247.378H337.684L339.22 250.011L337.684 252.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 249.353H340.361L338.825 246.719L340.361 244.042H343.389L344.926 246.719L343.389 249.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 246.017H346.067L344.531 243.384L346.067 240.751H349.139L350.675 243.384L349.139 246.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 239.434H346.067L344.531 236.757L346.067 234.123H349.139L350.675 236.757L349.139 239.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 232.807H346.067L344.531 230.173L346.067 227.496H349.139L350.675 230.173L349.139 232.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 226.179H346.067L344.531 223.546L346.067 220.913H349.139L350.675 223.546L349.139 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 219.596H346.067L344.531 216.919L346.067 214.286H349.139L350.675 216.919L349.139 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 212.969H346.067L344.531 210.336L346.067 207.658H349.139L350.675 210.336L349.139 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.051 206.21H346.154L344.706 203.708L346.154 201.163H349.051L350.499 203.708L349.051 206.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.556 201.602H341.195L340.493 200.417L341.195 199.188H342.556L343.258 200.417L342.556 201.602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.088 191.2H324.298L323.859 190.498L324.298 189.752H325.088L325.483 190.498L325.088 191.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.072 185.319H312.404L311.57 183.871L312.404 182.422H314.072L314.906 183.871L314.072 185.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.306 195.94H294.804L293.576 193.789L294.804 191.639H297.306L298.535 193.789L297.306 195.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.82 199.714H288.792L287.299 197.081L288.792 194.492H291.82L293.356 197.081L291.82 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.114 203.05H283.042L281.55 200.417L283.042 197.739H286.114L287.651 200.417L286.114 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.794 205.288H277.951L277.029 203.708L277.951 202.128H279.794L280.672 203.708L279.794 205.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.365 212.881H277.381L275.888 210.336L277.381 207.746H280.365L281.813 210.336L280.365 212.881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.409 219.596H277.337L275.801 216.919L277.337 214.286H280.409L281.901 216.919L280.409 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.409 226.179H277.337L275.801 223.546L277.337 220.913H280.409L281.901 223.546L280.409 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.409 232.807H277.337L275.801 230.173L277.337 227.496H280.409L281.901 230.173L280.409 232.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.409 239.434H277.337L275.801 236.757L277.337 234.123H280.409L281.901 236.757L280.409 239.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.659 249.353H271.587L270.095 246.719L271.587 244.042H274.659L276.196 246.719L274.659 249.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.409 252.644H277.337L275.801 250.011L277.337 247.378H280.409L281.901 250.011L280.409 252.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.114 255.98H283.042L281.55 253.303L283.042 250.669H286.114L287.651 253.303L286.114 255.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.864 259.272H288.792L287.256 256.638L288.792 253.961H291.864L293.356 256.638L291.864 259.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.394 262.256H294.673L293.356 259.93L294.673 257.604H297.394L298.754 259.93L297.394 262.256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.222 264.012H301.344L300.905 263.222L301.344 262.476H302.222L302.661 263.222L302.222 264.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.808 270.814H312.667L312.097 269.849L312.667 268.883H313.808L314.379 269.849L313.808 270.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 269.191H317.451L315.915 266.557L317.451 263.88H320.479L322.016 266.557L320.479 269.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 265.899H323.157L321.621 263.222L323.157 260.588H326.229L327.765 263.222L326.229 265.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 262.563H328.906L327.37 259.93L328.906 257.297H331.934L333.471 259.93L331.934 262.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 259.272H334.612L333.076 256.638L334.612 253.961H337.684L339.22 256.638L337.684 259.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 255.98H340.361L338.825 253.303L340.361 250.669H343.389L344.926 253.303L343.389 255.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 252.644H346.067L344.531 250.011L346.067 247.378H349.139L350.675 250.011L349.139 252.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 249.353H351.816L350.28 246.719L351.816 244.042H354.844L356.381 246.719L354.844 249.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 242.726H351.816L350.28 240.092L351.816 237.459H354.844L356.381 240.092L354.844 242.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 236.098H351.816L350.28 233.465L351.816 230.832H354.844L356.381 233.465L354.844 236.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 229.515H351.816L350.28 226.838L351.816 224.204H354.844L356.381 226.838L354.844 229.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 222.888H351.816L350.28 220.254L351.816 217.577H354.844L356.381 220.254L354.844 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 216.261H351.816L350.28 213.627L351.816 210.994H354.844L356.381 213.627L354.844 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 209.677H351.816L350.28 207L351.816 204.367H354.844L356.381 207L354.844 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.819 195.457H340.932L339.966 193.789L340.932 192.122H342.819L343.784 193.789L342.819 195.457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.069 192.122H335.226L334.261 190.498L335.226 188.83H337.069L338.035 190.498L337.069 192.122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.176 184.661H324.21L323.771 183.871L324.21 183.037H325.176L325.614 183.871L325.176 184.661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.382 181.325H318.504L318.066 180.535L318.504 179.789H319.382L319.865 180.535L319.382 181.325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.335 179.131H312.141L311.043 177.243L312.141 175.356H314.335L315.432 177.243L314.335 179.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.482 189.664H294.629L293.181 187.162L294.629 184.704H297.482L298.93 187.162L297.482 189.664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.469 192.473H289.143L288.002 190.498L289.143 188.479H291.469L292.654 190.498L291.469 192.473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.886 194.316H284.271L284.008 193.789L284.271 193.263H284.886L285.193 193.789L284.886 194.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.001 215.119H272.289L271.412 213.627L272.289 212.135H274.001L274.835 213.627L274.001 215.119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.659 222.888H271.587L270.095 220.254L271.587 217.577H274.659L276.196 220.254L274.659 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.659 229.515H271.587L270.095 226.838L271.587 224.204H274.659L276.196 226.838L274.659 229.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.659 236.098H271.587L270.095 233.465L271.587 230.832H274.659L276.196 233.465L274.659 236.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.659 242.726H271.587L270.095 240.092L271.587 237.459H274.659L276.196 240.092L274.659 242.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.725 250.538H267.111L266.803 250.011L267.111 249.484H267.725L267.988 250.011L267.725 250.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.659 255.936H271.631L270.139 253.303L271.631 250.713H274.659L276.152 253.303L274.659 255.936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.409 259.272H277.337L275.801 256.638L277.337 253.961H280.409L281.901 256.638L280.409 259.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.114 262.563H283.042L281.55 259.93L283.042 257.297H286.114L287.651 259.93L286.114 262.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.381 265.065H289.274L288.177 263.222L289.274 261.378H291.381L292.434 263.222L291.381 265.065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.511 278.671H311.965L310.692 276.476L311.965 274.282H314.511L315.783 276.476L314.511 278.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 275.818H317.451L315.915 273.141L317.451 270.507H320.479L322.016 273.141L320.479 275.818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 272.482H323.157L321.621 269.849L323.157 267.216H326.229L327.765 269.849L326.229 272.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 269.191H328.906L327.37 266.557L328.906 263.88H331.934L333.471 266.557L331.934 269.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 265.899H334.612L333.076 263.222L334.612 260.588H337.684L339.22 263.222L337.684 265.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 262.563H340.361L338.825 259.93L340.361 257.297H343.389L344.926 259.93L343.389 262.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 259.272H346.067L344.531 256.638L346.067 253.961H349.139L350.675 256.638L349.139 259.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 255.98H351.816L350.28 253.303L351.816 250.669H354.844L356.381 253.303L354.844 255.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 252.644H357.522L355.986 250.011L357.522 247.378H360.594L362.13 250.011L360.594 252.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 246.017H357.522L355.986 243.384L357.522 240.751H360.594L362.13 243.384L360.594 246.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 239.434H357.522L355.986 236.757L357.522 234.123H360.594L362.13 236.757L360.594 239.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 232.807H357.522L355.986 230.173L357.522 227.496H360.594L362.13 230.173L360.594 232.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 226.179H357.522L355.986 223.546L357.522 220.913H360.594L362.13 223.546L360.594 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 219.596H357.522L355.986 216.919L357.522 214.286H360.594L362.13 216.919L360.594 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 212.969H357.522L355.986 210.336L357.522 207.658H360.594L362.13 210.336L360.594 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.111 205.552H358.004L356.907 203.708L358.004 201.865H360.111L361.208 203.708L360.111 205.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.321 197.52H358.794L358.575 197.081L358.794 196.642H359.321L359.541 197.081L359.321 197.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.142 195.15H352.518L351.728 193.789L352.518 192.385H354.142L354.932 193.789L354.142 195.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.051 192.999H346.154L344.706 190.498L346.154 187.952H349.051L350.499 190.498L349.051 192.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.424 188.128H341.327L340.756 187.162L341.327 186.197H342.424L342.994 187.162L342.424 188.128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.64 186.416H334.656L333.207 183.871L334.656 181.281H337.64L339.088 183.871L337.64 186.416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.32 182.115H329.521L328.599 180.535L329.521 178.999H331.32L332.198 180.535L331.32 182.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.439 178.516H323.947L323.201 177.243L323.947 175.971H325.439L326.141 177.243L325.439 178.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 176.585H317.451L315.915 173.952L317.451 171.274H320.479L322.016 173.952L320.479 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.774 173.293H311.702L310.166 170.616L311.702 167.983H314.774L316.266 170.616L314.774 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.761 176.102H306.259L305.031 173.952L306.259 171.801H308.761L309.99 173.952L308.761 176.102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.924 179.218H300.642L299.501 177.243L300.642 175.268H302.924L304.021 177.243L302.924 179.218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.569 183.212H294.541L293.005 180.535L294.541 177.902H297.569L299.106 180.535L297.569 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.864 186.504H288.792L287.256 183.871L288.792 181.237H291.864L293.356 183.871L291.864 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.114 189.796H283.042L281.55 187.162L283.042 184.529H286.114L287.651 187.162L286.114 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.032 224.643H266.759L266.145 223.546L266.759 222.449H268.032L268.691 223.546L268.032 224.643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.778 232.587H266.013L264.609 230.173L266.013 227.759H268.778L270.183 230.173L268.778 232.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.778 239.171H266.013L264.609 236.757L266.013 234.387H268.778L270.183 236.757L268.778 239.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.778 245.798H266.013L264.609 243.384L266.013 240.97H268.778L270.183 243.384L268.778 245.798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.387 260.369H272.904L272.641 259.93L272.904 259.491H273.387L273.65 259.93L273.387 260.369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.399 264.143H278.346L277.819 263.222L278.346 262.3H279.399L279.926 263.222L279.399 264.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 282.401H317.451L315.915 279.768L317.451 277.134H320.479L322.016 279.768L320.479 282.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 279.109H323.157L321.621 276.476L323.157 273.799H326.229L327.765 276.476L326.229 279.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 275.818H328.906L327.37 273.141L328.906 270.507H331.934L333.471 273.141L331.934 275.818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 272.482H334.612L333.076 269.849L334.612 267.216H337.684L339.22 269.849L337.684 272.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 269.191H340.361L338.825 266.557L340.361 263.88H343.389L344.926 266.557L343.389 269.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 265.899H346.067L344.531 263.222L346.067 260.588H349.139L350.675 263.222L349.139 265.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 262.563H351.816L350.28 259.93L351.816 257.297H354.844L356.381 259.93L354.844 262.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 259.272H357.522L355.986 256.638L357.522 253.961H360.594L362.13 256.638L360.594 259.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 255.98H363.271L361.735 253.303L363.271 250.669H366.299L367.836 253.303L366.299 255.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 249.353H363.271L361.735 246.719L363.271 244.042H366.299L367.836 246.719L366.299 249.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 242.726H363.271L361.735 240.092L363.271 237.459H366.299L367.836 240.092L366.299 242.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 236.098H363.271L361.735 233.465L363.271 230.832H366.299L367.836 233.465L366.299 236.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 229.427H363.271L361.779 226.838L363.271 224.248H366.299L367.792 226.838L366.299 229.427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.29 221.088H364.281L363.798 220.254L364.281 219.377H365.29L365.773 220.254L365.29 221.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 216.261H363.271L361.735 213.627L363.271 210.994H366.299L367.836 213.627L366.299 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 209.677H363.271L361.735 207L363.271 204.367H366.299L367.836 207L366.299 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 203.05H363.271L361.735 200.417L363.271 197.739H366.299L367.836 200.417L366.299 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 196.423H363.271L361.735 193.789L363.271 191.156H366.299L367.836 193.789L366.299 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.55 193.087H357.566L356.073 190.498L357.566 187.864H360.55L362.042 190.498L360.55 193.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 189.796H351.816L350.28 187.162L351.816 184.529H354.844L356.381 187.162L354.844 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 186.504H346.067L344.531 183.871L346.067 181.237H349.139L350.675 183.871L349.139 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.346 183.124H340.405L338.913 180.535L340.405 177.989H343.346L344.838 180.535L343.346 183.124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 179.877H334.612L333.076 177.243L334.612 174.61H337.684L339.22 177.243L337.684 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 176.585H328.906L327.37 173.952L328.906 171.274H331.934L333.471 173.952L331.934 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.141 173.162H323.201L321.752 170.616L323.201 168.071H326.141L327.633 170.616L326.141 173.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 169.958H317.451L315.915 167.324L317.451 164.691H320.479L322.016 167.324L320.479 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.774 166.666H311.702L310.166 164.033L311.702 161.356H314.774L316.266 164.033L314.774 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.024 169.958H305.996L304.46 167.324L305.996 164.691H309.024L310.561 167.324L309.024 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.319 173.293H300.247L298.711 170.616L300.247 167.983H303.319L304.811 170.616L303.319 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.438 176.366H294.629L293.224 173.952L294.629 171.494H297.438L298.842 173.952L297.438 176.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.864 179.877H288.792L287.256 177.243L288.792 174.61H291.864L293.356 177.243L291.864 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.114 183.212H283.042L281.55 180.535L283.042 177.902H286.114L287.651 180.535L286.114 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.348 288.809H317.583L316.178 286.395L317.583 283.981H320.348L321.752 286.395L320.348 288.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 285.737H323.157L321.621 283.059L323.157 280.426H326.229L327.765 283.059L326.229 285.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 282.401H328.906L327.37 279.768L328.906 277.134H331.934L333.471 279.768L331.934 282.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 279.109H334.612L333.076 276.476L334.612 273.799H337.684L339.22 276.476L337.684 279.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 275.818H340.361L338.825 273.141L340.361 270.507H343.389L344.926 273.141L343.389 275.818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 272.482H346.067L344.531 269.849L346.067 267.216H349.139L350.675 269.849L349.139 272.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 269.191H351.816L350.28 266.557L351.816 263.88H354.844L356.381 266.557L354.844 269.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 265.899H357.522L355.986 263.222L357.522 260.588H360.594L362.13 263.222L360.594 265.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 262.563H363.271L361.735 259.93L363.271 257.297H366.299L367.836 259.93L366.299 262.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 259.272H368.977L367.441 256.638L368.977 253.961H372.049L373.585 256.638L372.049 259.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 252.644H368.977L367.441 250.011L368.977 247.378H372.049L373.585 250.011L372.049 252.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 246.017H368.977L367.441 243.384L368.977 240.751H372.049L373.585 243.384L372.049 246.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.566 238.6H369.459L368.406 236.757L369.459 234.957H371.566L372.619 236.757L371.566 238.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.82 230.656H370.206L369.942 230.173L370.206 229.647H370.82L371.083 230.173L370.82 230.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 226.179H368.977L367.484 223.546L368.977 220.913H372.049L373.541 223.546L372.049 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 219.596H368.977L367.441 216.919L368.977 214.286H372.049L373.585 216.919L372.049 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 212.969H368.977L367.441 210.336L368.977 207.658H372.049L373.585 210.336L372.049 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 206.342H368.977L367.441 203.708L368.977 201.075H372.049L373.585 203.708L372.049 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 199.714H368.977L367.441 197.081L368.977 194.448H372.049L373.585 197.081L372.049 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 193.131H368.977L367.441 190.498L368.977 187.821H372.049L373.585 190.498L372.049 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 189.796H363.271L361.735 187.162L363.271 184.529H366.299L367.836 187.162L366.299 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 186.504H357.522L355.986 183.871L357.522 181.237H360.594L362.13 183.871L360.594 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 183.212H351.816L350.28 180.535L351.816 177.902H354.844L356.381 180.535L354.844 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 179.877H346.067L344.531 177.243L346.067 174.61H349.139L350.675 177.243L349.139 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 176.585H340.361L338.825 173.952L340.361 171.274H343.389L344.926 173.952L343.389 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 173.293H334.612L333.076 170.616L334.612 167.983H337.684L339.22 170.616L337.684 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 169.958H328.906L327.37 167.324L328.906 164.691H331.934L333.471 167.324L331.934 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 166.666H323.157L321.621 164.033L323.157 161.356H326.229L327.765 164.033L326.229 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 163.374H317.451L315.915 160.697L317.451 158.064H320.479L322.016 160.697L320.479 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.774 160.039H311.702L310.166 157.406L311.702 154.772H314.774L316.266 157.406L314.774 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.024 163.374H305.996L304.46 160.697L305.996 158.064H309.024L310.561 160.697L309.024 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.319 166.666H300.247L298.711 164.033L300.247 161.356H303.319L304.811 164.033L303.319 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.526 169.87H294.585L293.093 167.324L294.585 164.779H297.526L298.974 167.324L297.526 169.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.017 174.654H284.183L283.744 173.952L284.183 173.206H285.017L285.412 173.952L285.017 174.654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.226 237.239H255.699L255.436 236.757L255.699 236.318H256.226L256.489 236.757L256.226 237.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.953 294.734H317.978L316.968 292.978L317.978 291.267H319.953L320.962 292.978L319.953 294.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 292.32H323.157L321.621 289.687L323.157 287.053H326.229L327.765 289.687L326.229 292.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 289.028H328.906L327.37 286.395L328.906 283.718H331.934L333.471 286.395L331.934 289.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 285.737H334.612L333.076 283.059L334.612 280.426H337.684L339.22 283.059L337.684 285.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 282.401H340.361L338.825 279.768L340.361 277.134H343.389L344.926 279.768L343.389 282.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 279.109H346.067L344.531 276.476L346.067 273.799H349.139L350.675 276.476L349.139 279.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 275.818H351.816L350.28 273.141L351.816 270.507H354.844L356.381 273.141L354.844 275.818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 272.482H357.522L355.986 269.849L357.522 267.216H360.594L362.13 269.849L360.594 272.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 269.191H363.271L361.735 266.557L363.271 263.88H366.299L367.836 266.557L366.299 269.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 265.899H368.977L367.441 263.222L368.977 260.588H372.049L373.585 263.222L372.049 265.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 262.563H374.726L373.19 259.93L374.726 257.297H377.754L379.291 259.93L377.754 262.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 255.98H374.726L373.19 253.303L374.726 250.669H377.754L379.291 253.303L377.754 255.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 249.309H374.726L373.234 246.719L374.726 244.086H377.754L379.247 246.719L377.754 249.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.745 240.97H375.736L375.209 240.092L375.736 239.171H376.745L377.272 240.092L376.745 240.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.623 235.835H374.902L373.541 233.465L374.902 231.095H377.623L378.983 233.465L377.623 235.835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 229.515H374.726L373.19 226.838L374.726 224.204H377.754L379.291 226.838L377.754 229.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 222.888H374.726L373.19 220.254L374.726 217.577H377.754L379.291 220.254L377.754 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 216.261H374.726L373.19 213.627L374.726 210.994H377.754L379.291 213.627L377.754 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 209.677H374.726L373.19 207L374.726 204.367H377.754L379.291 207L377.754 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 203.05H374.726L373.19 200.417L374.726 197.739H377.754L379.291 200.417L377.754 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 196.423H374.726L373.19 193.789L374.726 191.156H377.754L379.291 193.789L377.754 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 189.796H374.726L373.19 187.162L374.726 184.529H377.754L379.291 187.162L377.754 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 186.504H368.977L367.441 183.871L368.977 181.237H372.049L373.585 183.871L372.049 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 183.212H363.271L361.735 180.535L363.271 177.902H366.299L367.836 180.535L366.299 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 179.877H357.522L355.986 177.243L357.522 174.61H360.594L362.13 177.243L360.594 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 176.585H351.816L350.28 173.952L351.816 171.274H354.844L356.381 173.952L354.844 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 173.293H346.067L344.531 170.616L346.067 167.983H349.139L350.675 170.616L349.139 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 169.958H340.361L338.825 167.324L340.361 164.691H343.389L344.926 167.324L343.389 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 166.666H334.612L333.076 164.033L334.612 161.356H337.684L339.22 164.033L337.684 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 163.374H328.906L327.37 160.697L328.906 158.064H331.934L333.471 160.697L331.934 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 160.039H323.157L321.621 157.406L323.157 154.772H326.229L327.765 157.406L326.229 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 156.747H317.451L315.915 154.114L317.451 151.437H320.479L322.016 154.114L320.479 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.774 153.456H311.702L310.166 150.778L311.702 148.145H314.774L316.266 150.778L314.774 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.024 156.747H305.996L304.46 154.114L305.996 151.437H309.024L310.561 154.114L309.024 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.319 160.039H300.247L298.711 157.406L300.247 154.772H303.319L304.811 157.406L303.319 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.569 163.331H294.541L293.005 160.697L294.541 158.108H297.569L299.062 160.697L297.569 163.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.644 166.315H289.011L287.694 164.033L289.011 161.751H291.644L292.961 164.033L291.644 166.315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 298.947H323.157L321.621 296.314L323.157 293.681H326.229L327.765 296.314L326.229 298.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 295.656H328.906L327.37 292.978L328.906 290.345H331.934L333.471 292.978L331.934 295.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 292.32H334.612L333.076 289.687L334.612 287.053H337.684L339.22 289.687L337.684 292.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 289.028H340.361L338.825 286.395L340.361 283.718H343.389L344.926 286.395L343.389 289.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 285.737H346.067L344.531 283.059L346.067 280.426H349.139L350.675 283.059L349.139 285.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 282.401H351.816L350.28 279.768L351.816 277.134H354.844L356.381 279.768L354.844 282.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 279.109H357.522L355.986 276.476L357.522 273.799H360.594L362.13 276.476L360.594 279.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 275.818H363.271L361.735 273.141L363.271 270.507H366.299L367.836 273.141L366.299 275.818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 272.482H368.977L367.441 269.849L368.977 267.216H372.049L373.585 269.849L372.049 272.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 269.191H374.726L373.19 266.557L374.726 263.88H377.754L379.291 266.557L377.754 269.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 265.899H380.432L378.896 263.222L380.432 260.588H383.504L385.04 263.222L383.504 265.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 259.272H380.432L378.896 256.638L380.432 253.961H383.504L385.04 256.638L383.504 259.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 252.644H380.432L378.939 250.011L380.432 247.378H383.504L384.996 250.011L383.504 252.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.372 245.842H380.563L379.115 243.384L380.563 240.926H383.372L384.821 243.384L383.372 245.842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 239.434H380.432L378.896 236.757L380.432 234.123H383.504L385.04 236.757L383.504 239.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 232.807H380.432L378.896 230.173L380.432 227.496H383.504L385.04 230.173L383.504 232.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 226.179H380.432L378.896 223.546L380.432 220.913H383.504L385.04 223.546L383.504 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 219.596H380.432L378.896 216.919L380.432 214.286H383.504L385.04 216.919L383.504 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 212.969H380.432L378.896 210.336L380.432 207.658H383.504L385.04 210.336L383.504 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 206.342H380.432L378.896 203.708L380.432 201.075H383.504L385.04 203.708L383.504 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 199.714H380.432L378.896 197.081L380.432 194.448H383.504L385.04 197.081L383.504 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 193.131H380.432L378.896 190.498L380.432 187.821H383.504L385.04 190.498L383.504 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 186.504H380.432L378.896 183.871L380.432 181.237H383.504L385.04 183.871L383.504 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 183.212H374.726L373.19 180.535L374.726 177.902H377.754L379.291 180.535L377.754 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 179.877H368.977L367.441 177.243L368.977 174.61H372.049L373.585 177.243L372.049 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 176.585H363.271L361.735 173.952L363.271 171.274H366.299L367.836 173.952L366.299 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 173.293H357.522L355.986 170.616L357.522 167.983H360.594L362.13 170.616L360.594 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 169.958H351.816L350.28 167.324L351.816 164.691H354.844L356.381 167.324L354.844 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 166.666H346.067L344.531 164.033L346.067 161.356H349.139L350.675 164.033L349.139 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 163.374H340.361L338.825 160.697L340.361 158.064H343.389L344.926 160.697L343.389 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 160.039H334.612L333.076 157.406L334.612 154.772H337.684L339.22 157.406L337.684 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 156.747H328.906L327.37 154.114L328.906 151.437H331.934L333.471 154.114L331.934 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 153.456H323.157L321.621 150.778L323.157 148.145H326.229L327.765 150.778L326.229 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 150.12H317.451L315.915 147.487L317.451 144.853H320.479L322.016 147.487L320.479 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.642 146.609H311.833L310.385 144.195L311.833 141.737H314.642L316.047 144.195L314.642 146.609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.322 148.935H306.698L305.864 147.487L306.698 146.038H308.322L309.156 147.487L308.322 148.935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.002 151.217H301.519L301.3 150.778L301.519 150.383H302.002L302.266 150.778L302.002 151.217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.569 156.703H294.541L293.005 154.114L294.541 151.481H297.569L299.062 154.114L297.569 156.703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.635 157.932H290.021L289.669 157.406L290.021 156.835H290.635L290.942 157.406L290.635 157.932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.865 307.813H318.066L317.144 306.233L318.066 304.653H319.865L320.787 306.233L319.865 307.813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 305.574H323.157L321.621 302.941L323.157 300.264H326.229L327.765 302.941L326.229 305.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 302.239H328.906L327.37 299.606L328.906 296.972H331.934L333.471 299.606L331.934 302.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 298.947H334.612L333.076 296.314L334.612 293.681H337.684L339.22 296.314L337.684 298.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 295.656H340.361L338.825 292.978L340.361 290.345H343.389L344.926 292.978L343.389 295.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 292.32H346.067L344.531 289.687L346.067 287.053H349.139L350.675 289.687L349.139 292.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 289.028H351.816L350.28 286.395L351.816 283.718H354.844L356.381 286.395L354.844 289.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 285.737H357.522L355.986 283.059L357.522 280.426H360.594L362.13 283.059L360.594 285.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 282.401H363.271L361.735 279.768L363.271 277.134H366.299L367.836 279.768L366.299 282.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 279.109H368.977L367.441 276.476L368.977 273.799H372.049L373.585 276.476L372.049 279.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.667 275.642H374.814L373.409 273.141L374.814 270.683H377.667L379.115 273.141L377.667 275.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.802 271.341H381.134L380.256 269.849L381.134 268.357H382.802L383.679 269.849L382.802 271.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.034 262.212H386.401L385.084 259.93L386.401 257.648H389.034L390.351 259.93L389.034 262.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 255.98H386.181L384.645 253.303L386.181 250.669H389.209L390.746 253.303L389.209 255.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.376 247.861H387.015L386.357 246.719L387.015 245.534H388.376L389.034 246.719L388.376 247.861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 242.726H386.181L384.689 240.092L386.181 237.459H389.209L390.746 240.092L389.209 242.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 236.098H386.181L384.645 233.465L386.181 230.832H389.209L390.746 233.465L389.209 236.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 229.515H386.181L384.645 226.838L386.181 224.204H389.209L390.746 226.838L389.209 229.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 222.888H386.181L384.645 220.254L386.181 217.577H389.209L390.746 220.254L389.209 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 216.261H386.181L384.645 213.627L386.181 210.994H389.209L390.746 213.627L389.209 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 209.677H386.181L384.645 207L386.181 204.367H389.209L390.746 207L389.209 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 203.05H386.181L384.645 200.417L386.181 197.739H389.209L390.746 200.417L389.209 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 196.423H386.181L384.645 193.789L386.181 191.156H389.209L390.746 193.789L389.209 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 189.796H386.181L384.645 187.162L386.181 184.529H389.209L390.746 187.162L389.209 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 183.212H386.181L384.645 180.535L386.181 177.902H389.209L390.746 180.535L389.209 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 179.877H380.432L378.896 177.243L380.432 174.61H383.504L385.04 177.243L383.504 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 176.585H374.726L373.19 173.952L374.726 171.274H377.754L379.291 173.952L377.754 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 173.293H368.977L367.441 170.616L368.977 167.983H372.049L373.585 170.616L372.049 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 169.958H363.271L361.735 167.324L363.271 164.691H366.299L367.836 167.324L366.299 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 166.666H357.522L355.986 164.033L357.522 161.356H360.594L362.13 164.033L360.594 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 163.374H351.816L350.28 160.697L351.816 158.064H354.844L356.381 160.697L354.844 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 160.039H346.067L344.531 157.406L346.067 154.772H349.139L350.675 157.406L349.139 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 156.747H340.361L338.825 154.114L340.361 151.437H343.389L344.926 154.114L343.389 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 153.456H334.612L333.076 150.778L334.612 148.145H337.684L339.22 150.778L337.684 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 150.12H328.906L327.37 147.487L328.906 144.853H331.934L333.471 147.487L331.934 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.702 145.951H323.683L322.63 144.195L323.683 142.396H325.702L326.756 144.195L325.702 145.951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.733 142.22H318.153L317.363 140.859L318.153 139.499H319.733L320.523 140.859L319.733 142.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.203 139.192H312.272L311.307 137.568L312.272 135.9H314.203L315.125 137.568L314.203 139.192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.569 150.12H294.541L293.005 147.487L294.541 144.853H297.569L299.106 147.487L297.569 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.864 153.456H288.792L287.256 150.778L288.792 148.145H291.864L293.356 150.778L291.864 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.348 315.23H317.583L316.222 312.86L317.583 310.49H320.348L321.708 312.86L320.348 315.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 312.202H323.157L321.621 309.524L323.157 306.891H326.229L327.765 309.524L326.229 312.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 308.866H328.906L327.37 306.233L328.906 303.599H331.934L333.471 306.233L331.934 308.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 305.574H334.612L333.076 302.941L334.612 300.264H337.684L339.22 302.941L337.684 305.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 302.239H340.361L338.825 299.606L340.361 296.972H343.389L344.926 299.606L343.389 302.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 298.947H346.067L344.531 296.314L346.067 293.681H349.139L350.675 296.314L349.139 298.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 295.656H351.816L350.28 292.978L351.816 290.345H354.844L356.381 292.978L354.844 295.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 292.32H357.522L355.986 289.687L357.522 287.053H360.594L362.13 289.687L360.594 292.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 289.028H363.271L361.735 286.395L363.271 283.718H366.299L367.836 286.395L366.299 289.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.005 285.693H369.021L367.528 283.059L369.021 280.47H372.005L373.541 283.059L372.005 285.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.169 251.284H392.677L391.974 250.011L392.677 248.738H394.169L394.915 250.011L394.169 251.284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 239.434H391.887L390.394 236.757L391.887 234.123H394.959L396.495 236.757L394.959 239.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 232.807H391.887L390.394 230.173L391.887 227.496H394.959L396.495 230.173L394.959 232.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 226.179H391.887L390.394 223.546L391.887 220.913H394.959L396.495 223.546L394.959 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 219.552H391.887L390.394 216.919L391.887 214.286H394.959L396.451 216.919L394.959 219.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.862 211.038H393.028L392.589 210.336L393.028 209.589H393.862L394.257 210.336L393.862 211.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 206.342H391.887L390.394 203.708L391.887 201.075H394.959L396.495 203.708L394.959 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 199.714H391.887L390.394 197.081L391.887 194.448H394.959L396.495 197.081L394.959 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 193.131H391.887L390.394 190.498L391.887 187.821H394.959L396.495 190.498L394.959 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 186.504H391.887L390.394 183.871L391.887 181.237H394.959L396.495 183.871L394.959 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 179.877H391.887L390.394 177.243L391.887 174.61H394.959L396.495 177.243L394.959 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 176.585H386.181L384.645 173.952L386.181 171.274H389.209L390.746 173.952L389.209 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 173.293H380.432L378.896 170.616L380.432 167.983H383.504L385.04 170.616L383.504 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 169.958H374.726L373.19 167.324L374.726 164.691H377.754L379.291 167.324L377.754 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 166.666H368.977L367.441 164.033L368.977 161.356H372.049L373.585 164.033L372.049 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 163.374H363.271L361.735 160.697L363.271 158.064H366.299L367.836 160.697L366.299 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 160.039H357.522L355.986 157.406L357.522 154.772H360.594L362.13 157.406L360.594 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 156.747H351.816L350.28 154.114L351.816 151.437H354.844L356.381 154.114L354.844 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 153.456H346.067L344.531 150.778L346.067 148.145H349.139L350.675 150.778L349.139 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 150.12H340.361L338.825 147.487L340.361 144.853H343.389L344.926 147.487L343.389 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 146.828H334.612L333.076 144.195L334.612 141.518H337.684L339.22 144.195L337.684 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 140.201H323.157L321.664 137.568L323.157 134.934H326.229L327.721 137.568L326.229 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 136.866H317.451L315.959 134.232L317.451 131.643H320.479L321.972 134.232L320.479 136.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.774 133.574H311.702L310.166 130.941L311.702 128.307H314.774L316.266 130.941L314.774 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.059 135.198H306.962L306.435 134.232L306.962 133.311H308.059L308.586 134.232L308.059 135.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.955 142.483H295.112L294.19 140.859L295.112 139.279H296.955L297.877 140.859L296.955 142.483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.162 145.643H289.494L288.616 144.195L289.494 142.703H291.162L291.996 144.195L291.162 145.643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.895 149.725H283.306L282.033 147.487L283.306 145.248H285.895L287.168 147.487L285.895 149.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.487 151.876H278.258L277.644 150.778L278.258 149.725H279.487L280.102 150.778L279.487 151.876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 318.785H323.157L321.621 316.152L323.157 313.518H326.229L327.765 316.152L326.229 318.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 315.493H328.906L327.37 312.86L328.906 310.183H331.934L333.471 312.86L331.934 315.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 312.202H334.612L333.076 309.524L334.612 306.891H337.684L339.22 309.524L337.684 312.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 308.866H340.361L338.825 306.233L340.361 303.599H343.389L344.926 306.233L343.389 308.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 305.574H346.067L344.531 302.941L346.067 300.264H349.139L350.675 302.941L349.139 305.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 302.239H351.816L350.28 299.606L351.816 296.972H354.844L356.381 299.606L354.844 302.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 298.947H357.522L355.986 296.314L357.522 293.681H360.594L362.13 296.314L360.594 298.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 295.656H363.271L361.735 292.978L363.271 290.345H366.299L367.836 292.978L366.299 295.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.005 292.32H369.021L367.484 289.687L369.021 287.097H372.005L373.541 289.687L372.005 292.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.621 236.054H397.68L396.188 233.465L397.68 230.876H400.621L402.113 233.465L400.621 236.054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 229.515H397.636L396.1 226.838L397.636 224.204H400.664L402.201 226.838L400.664 229.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.621 222.8H397.68L396.188 220.254L397.68 217.665H400.621L402.113 220.254L400.621 222.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.401 215.778H397.899L396.671 213.627L397.899 211.477H400.401L401.63 213.627L400.401 215.778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 209.677H397.636L396.1 207L397.636 204.367H400.664L402.201 207L400.664 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 203.05H397.636L396.1 200.417L397.636 197.739H400.664L402.201 200.417L400.664 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 196.423H397.636L396.1 193.789L397.636 191.156H400.664L402.201 193.789L400.664 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 189.796H397.636L396.1 187.162L397.636 184.529H400.664L402.201 187.162L400.664 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 183.212H397.636L396.1 180.535L397.636 177.902H400.664L402.201 180.535L400.664 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 176.585H397.636L396.1 173.952L397.636 171.274H400.664L402.201 173.952L400.664 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 173.293H391.887L390.394 170.616L391.887 167.983H394.959L396.495 170.616L394.959 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 169.958H386.181L384.645 167.324L386.181 164.691H389.209L390.746 167.324L389.209 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 166.666H380.432L378.896 164.033L380.432 161.356H383.504L385.04 164.033L383.504 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 163.374H374.726L373.19 160.697L374.726 158.064H377.754L379.291 160.697L377.754 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 160.039H368.977L367.441 157.406L368.977 154.772H372.049L373.585 157.406L372.049 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 156.747H363.271L361.735 154.114L363.271 151.437H366.299L367.836 154.114L366.299 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 153.456H357.522L355.986 150.778L357.522 148.145H360.594L362.13 150.778L360.594 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 150.12H351.816L350.28 147.487L351.816 144.853H354.844L356.381 147.487L354.844 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 146.828H346.067L344.531 144.195L346.067 141.518H349.139L350.675 144.195L349.139 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 143.493H340.361L338.825 140.859L340.361 138.226H343.389L344.926 140.859L343.389 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.596 140.069H334.699L333.251 137.568L334.699 135.066H337.596L339.044 137.568L337.596 140.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.706 134.759H330.135L329.828 134.232L330.135 133.749H330.706L331.013 134.232L330.706 134.759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 133.574H323.157L321.621 130.941L323.157 128.307H326.229L327.765 130.941L326.229 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 130.282H317.451L315.915 127.649L317.451 124.972H320.479L322.016 127.649L320.479 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.774 126.991H311.702L310.166 124.313L311.702 121.68H314.774L316.266 124.313L314.774 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.805 129.887H306.216L304.899 127.649L306.216 125.411H308.805L310.078 127.649L308.805 129.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.82 140.157H288.792L287.299 137.568L288.792 134.934H291.82L293.356 137.568L291.82 140.157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.874 280.733H226.733L226.206 279.768L226.733 278.802H227.874L228.444 279.768L227.874 280.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.185 325.368H323.201L321.708 322.779L323.201 320.189H326.185L327.677 322.779L326.185 325.368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 322.121H328.906L327.37 319.443L328.906 316.81H331.934L333.471 319.443L331.934 322.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 318.785H334.612L333.076 316.152L334.612 313.518H337.684L339.22 316.152L337.684 318.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 315.493H340.361L338.825 312.86L340.361 310.183H343.389L344.926 312.86L343.389 315.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 312.202H346.067L344.531 309.524L346.067 306.891H349.139L350.675 309.524L349.139 312.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 308.866H351.816L350.28 306.233L351.816 303.599H354.844L356.381 306.233L354.844 308.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 305.574H357.522L355.986 302.941L357.522 300.264H360.594L362.13 302.941L360.594 305.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 302.239H363.271L361.735 299.606L363.271 296.972H366.299L367.836 299.606L366.299 302.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 298.947H368.977L367.441 296.314L368.977 293.681H372.049L373.585 296.314L372.049 298.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.282 232.543H403.517L402.113 230.173L403.517 227.759H406.282L407.643 230.173L406.282 232.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.238 225.916H403.517L402.157 223.546L403.517 221.176H406.238L407.599 223.546L406.238 225.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.107 219.069H403.649L402.42 216.919L403.649 214.812H406.107L407.336 216.919L406.107 219.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 212.969H403.342L401.849 210.336L403.342 207.658H406.414L407.95 210.336L406.414 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 206.342H403.342L401.849 203.708L403.342 201.075H406.414L407.95 203.708L406.414 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 199.714H403.342L401.849 197.081L403.342 194.448H406.414L407.95 197.081L406.414 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 193.131H403.342L401.849 190.498L403.342 187.821H406.414L407.95 190.498L406.414 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 186.504H403.342L401.849 183.871L403.342 181.237H406.414L407.95 183.871L406.414 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 179.877H403.342L401.849 177.243L403.342 174.61H406.414L407.95 177.243L406.414 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 173.293H403.342L401.849 170.616L403.342 167.983H406.414L407.95 170.616L406.414 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 169.958H397.636L396.1 167.324L397.636 164.691H400.664L402.201 167.324L400.664 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 166.666H391.887L390.394 164.033L391.887 161.356H394.959L396.495 164.033L394.959 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 163.374H386.181L384.645 160.697L386.181 158.064H389.209L390.746 160.697L389.209 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 160.039H380.432L378.896 157.406L380.432 154.772H383.504L385.04 157.406L383.504 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 156.747H374.726L373.19 154.114L374.726 151.437H377.754L379.291 154.114L377.754 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 153.456H368.977L367.441 150.778L368.977 148.145H372.049L373.585 150.778L372.049 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 150.12H363.271L361.735 147.487L363.271 144.853H366.299L367.836 147.487L366.299 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 146.828H357.522L355.986 144.195L357.522 141.518H360.594L362.13 144.195L360.594 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 143.493H351.816L350.28 140.859L351.816 138.226H354.844L356.381 140.859L354.844 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 140.201H346.067L344.531 137.568L346.067 134.934H349.139L350.675 137.568L349.139 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 136.909H340.361L338.825 134.232L340.361 131.599H343.389L344.926 134.232L343.389 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 126.991H323.157L321.621 124.313L323.157 121.68H326.229L327.765 124.313L326.229 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 123.655H317.451L315.915 121.022L317.451 118.388H320.479L322.016 121.022L320.479 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.335 119.661H312.097L310.999 117.73L312.097 115.799H314.335L315.476 117.73L314.335 119.661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.796 121.548H307.225L306.918 121.022L307.225 120.495H307.796L308.103 121.022L307.796 121.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.635 131.467H290.021L289.713 130.941L290.021 130.414H290.635L290.898 130.941L290.635 131.467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.384 282.401H214.312L212.776 279.768L214.312 277.134H217.384L218.921 279.768L217.384 282.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09 285.737H220.062L218.526 283.059L220.062 280.426H223.09L224.626 283.059L223.09 285.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.839 289.028H225.767L224.275 286.395L225.767 283.718H228.839L230.376 286.395L228.839 289.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.878 331.469H323.464L322.279 329.362L323.464 327.299H325.878L327.107 329.362L325.878 331.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 328.704H328.906L327.37 326.071L328.906 323.437H331.934L333.471 326.071L331.934 328.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 325.412H334.612L333.076 322.779L334.612 320.102H337.684L339.22 322.779L337.684 325.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 322.121H340.361L338.825 319.443L340.361 316.81H343.389L344.926 319.443L343.389 322.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 318.785H346.067L344.531 316.152L346.067 313.518H349.139L350.675 316.152L349.139 318.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 315.493H351.816L350.28 312.86L351.816 310.183H354.844L356.381 312.86L354.844 315.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 312.202H357.522L355.986 309.524L357.522 306.891H360.594L362.13 309.524L360.594 312.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 308.866H363.271L361.735 306.233L363.271 303.599H366.299L367.836 306.233L366.299 308.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 305.531H369.021L367.484 302.941L369.021 300.308H372.049L373.541 302.941L372.049 305.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.066 221.001H410.188L409.706 220.254L410.188 219.464H411.066L411.505 220.254L411.066 221.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 216.261H409.091L407.555 213.627L409.091 210.994H412.119L413.656 213.627L412.119 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 209.677H409.091L407.555 207L409.091 204.367H412.119L413.656 207L412.119 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 203.05H409.091L407.555 200.417L409.091 197.739H412.119L413.656 200.417L412.119 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 196.423H409.091L407.555 193.789L409.091 191.156H412.119L413.656 193.789L412.119 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 189.796H409.091L407.555 187.162L409.091 184.529H412.119L413.656 187.162L412.119 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 183.212H409.091L407.555 180.535L409.091 177.902H412.119L413.656 180.535L412.119 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 176.585H409.091L407.555 173.952L409.091 171.274H412.119L413.656 173.952L412.119 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 169.958H409.091L407.555 167.324L409.091 164.691H412.119L413.656 167.324L412.119 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 166.666H403.342L401.849 164.033L403.342 161.356H406.414L407.95 164.033L406.414 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 163.374H397.636L396.1 160.697L397.636 158.064H400.664L402.201 160.697L400.664 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 160.039H391.887L390.394 157.406L391.887 154.772H394.959L396.495 157.406L394.959 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 156.747H386.181L384.645 154.114L386.181 151.437H389.209L390.746 154.114L389.209 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 153.456H380.432L378.896 150.778L380.432 148.145H383.504L385.04 150.778L383.504 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 150.12H374.726L373.19 147.487L374.726 144.853H377.754L379.291 147.487L377.754 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 146.828H368.977L367.441 144.195L368.977 141.518H372.049L373.585 144.195L372.049 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 143.493H363.271L361.735 140.859L363.271 138.226H366.299L367.836 140.859L366.299 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 140.201H357.522L355.986 137.568L357.522 134.934H360.594L362.13 137.568L360.594 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 136.909H351.816L350.28 134.232L351.816 131.599H354.844L356.381 134.232L354.844 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.095 133.53H346.111L344.574 130.941L346.111 128.351H349.095L350.587 130.941L349.095 133.53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 130.238H340.361L338.869 127.649L340.361 125.016H343.389L344.882 127.649L343.389 130.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 126.991H334.612L333.076 124.313L334.612 121.68H337.684L339.22 124.313L337.684 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.276 122.514H329.564L328.687 121.022L329.564 119.529H331.276L332.154 121.022L331.276 122.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 120.363H323.157L321.621 117.73L323.157 115.053H326.229L327.765 117.73L326.229 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.392 116.94H317.495L316.047 114.394L317.495 111.893H320.392L321.84 114.394L320.392 116.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.635 285.737H208.607L207.071 283.059L208.607 280.426H211.635L213.171 283.059L211.635 285.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.384 289.028H214.312L212.776 286.395L214.312 283.718H217.384L218.921 286.395L217.384 289.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09 292.32H220.062L218.526 289.687L220.062 287.053H223.09L224.626 289.687L223.09 292.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.708 295.48H225.899L224.451 292.978L225.899 290.521H228.708L230.156 292.978L228.708 295.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.219 336.955H324.122L323.596 335.989L324.122 335.068H325.219L325.79 335.989L325.219 336.955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 335.331H328.906L327.37 332.698L328.906 330.021H331.934L333.471 332.698L331.934 335.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 332.039H334.612L333.076 329.362L334.612 326.729H337.684L339.22 329.362L337.684 332.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 328.704H340.361L338.825 326.071L340.361 323.437H343.389L344.926 326.071L343.389 328.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 325.412H346.067L344.531 322.779L346.067 320.102H349.139L350.675 322.779L349.139 325.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 322.121H351.816L350.28 319.443L351.816 316.81H354.844L356.381 319.443L354.844 322.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 318.785H357.522L355.986 316.152L357.522 313.518H360.594L362.13 316.152L360.594 318.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.036 314.967H363.578L362.349 312.86L363.578 310.709H366.036L367.221 312.86L366.036 314.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.952 310.271H370.074L369.635 309.524L370.074 308.778H370.952L371.391 309.524L370.952 310.271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.99 301.844H386.401L385.084 299.606L386.401 297.367H388.99L390.307 299.606L388.99 301.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 219.552H414.841L413.304 216.919L414.841 214.286H417.869L419.405 216.919L417.869 219.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 212.969H414.797L413.304 210.336L414.797 207.658H417.869L419.405 210.336L417.869 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 206.342H414.797L413.304 203.708L414.797 201.075H417.869L419.405 203.708L417.869 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 199.714H414.797L413.304 197.081L414.797 194.448H417.869L419.405 197.081L417.869 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 193.131H414.797L413.304 190.498L414.797 187.821H417.869L419.405 190.498L417.869 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 186.504H414.797L413.304 183.871L414.797 181.237H417.869L419.405 183.871L417.869 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 179.877H414.797L413.304 177.243L414.797 174.61H417.869L419.405 177.243L417.869 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 173.293H414.797L413.304 170.616L414.797 167.983H417.869L419.405 170.616L417.869 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 166.666H414.797L413.304 164.033L414.797 161.356H417.869L419.405 164.033L417.869 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 163.374H409.091L407.555 160.697L409.091 158.064H412.119L413.656 160.697L412.119 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 160.039H403.342L401.849 157.406L403.342 154.772H406.414L407.95 157.406L406.414 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 156.747H397.636L396.1 154.114L397.636 151.437H400.664L402.201 154.114L400.664 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 153.456H391.887L390.394 150.778L391.887 148.145H394.959L396.495 150.778L394.959 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 150.12H386.181L384.645 147.487L386.181 144.853H389.209L390.746 147.487L389.209 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 146.828H380.432L378.896 144.195L380.432 141.518H383.504L385.04 144.195L383.504 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 143.493H374.726L373.19 140.859L374.726 138.226H377.754L379.291 140.859L377.754 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 140.201H368.977L367.441 137.568L368.977 134.934H372.049L373.585 137.568L372.049 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 136.909H363.271L361.735 134.232L363.271 131.599H366.299L367.836 134.232L366.299 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 133.574H357.522L355.986 130.941L357.522 128.307H360.594L362.13 130.941L360.594 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 130.282H351.816L350.28 127.649L351.816 124.972H354.844L356.381 127.649L354.844 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 126.991H346.067L344.531 124.313L346.067 121.68H349.139L350.675 124.313L349.139 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 123.655H340.361L338.825 121.022L340.361 118.388H343.389L344.926 121.022L343.389 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.894 119.047H335.358L334.612 117.73L335.358 116.369H336.894L337.684 117.73L336.894 119.047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 117.072H328.906L327.37 114.394L328.906 111.761H331.934L333.471 114.394L331.934 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 113.736H323.157L321.621 111.103L323.157 108.469H326.229L327.765 111.103L326.229 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.372 278.627H208.87L207.641 276.476L208.87 274.326H211.372L212.601 276.476L211.372 278.627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.929 289.028H202.857L201.321 286.395L202.857 283.718H205.929L207.466 286.395L205.929 289.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.635 292.32H208.607L207.071 289.687L208.607 287.053H211.635L213.171 289.687L211.635 292.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.384 295.656H214.312L212.776 292.978L214.312 290.345H217.384L218.921 292.978L217.384 295.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09 298.947H220.062L218.526 296.314L220.062 293.681H223.09L224.626 296.314L223.09 298.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 341.958H328.906L327.37 339.281L328.906 336.648H331.934L333.471 339.281L331.934 341.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 338.623H334.612L333.076 335.989L334.612 333.356H337.684L339.22 335.989L337.684 338.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 335.331H340.361L338.825 332.698L340.361 330.021H343.389L344.926 332.698L343.389 335.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 332.039H346.067L344.531 329.362L346.067 326.729H349.139L350.675 329.362L349.139 332.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 328.704H351.816L350.28 326.071L351.816 323.437H354.844L356.381 326.071L354.844 328.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 325.412H357.522L355.986 322.779L357.522 320.102H360.594L362.13 322.779L360.594 325.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.027 319.882H364.544L364.324 319.443L364.544 319.048H365.027L365.246 319.443L365.027 319.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 312.202H380.432L378.896 309.524L380.432 306.891H383.504L385.04 309.524L383.504 312.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 308.866H386.181L384.645 306.233L386.181 303.599H389.209L390.746 306.233L389.209 308.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.048 221.966H421.073L420.063 220.254L421.073 218.499H423.048L424.057 220.254L423.048 221.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.618 216.261H420.546L419.01 213.627L420.546 210.994H423.618L425.111 213.627L423.618 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.618 209.677H420.546L419.01 207L420.546 204.367H423.618L425.111 207L423.618 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.618 203.05H420.546L419.01 200.417L420.546 197.739H423.618L425.111 200.417L423.618 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.618 196.423H420.546L419.01 193.789L420.546 191.156H423.618L425.111 193.789L423.618 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.618 189.796H420.546L419.01 187.162L420.546 184.529H423.618L425.111 187.162L423.618 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.618 183.212H420.546L419.01 180.535L420.546 177.902H423.618L425.111 180.535L423.618 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.618 176.585H420.546L419.01 173.952L420.546 171.274H423.618L425.111 173.952L423.618 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.618 169.958H420.546L419.01 167.324L420.546 164.691H423.618L425.111 167.324L423.618 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.618 163.374H420.546L419.01 160.697L420.546 158.064H423.618L425.111 160.697L423.618 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 160.039H414.797L413.304 157.406L414.797 154.772H417.869L419.405 157.406L417.869 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 156.747H409.091L407.555 154.114L409.091 151.437H412.119L413.656 154.114L412.119 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 153.456H403.342L401.849 150.778L403.342 148.145H406.414L407.95 150.778L406.414 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 150.12H397.636L396.1 147.487L397.636 144.853H400.664L402.201 147.487L400.664 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 146.828H391.887L390.394 144.195L391.887 141.518H394.959L396.495 144.195L394.959 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 143.493H386.181L384.645 140.859L386.181 138.226H389.209L390.746 140.859L389.209 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 140.201H380.432L378.896 137.568L380.432 134.934H383.504L385.04 137.568L383.504 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 136.909H374.726L373.19 134.232L374.726 131.599H377.754L379.291 134.232L377.754 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 133.574H368.977L367.441 130.941L368.977 128.307H372.049L373.585 130.941L372.049 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 130.282H363.271L361.735 127.649L363.271 124.972H366.299L367.836 127.649L366.299 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.594 126.991H357.522L355.986 124.313L357.522 121.68H360.594L362.13 124.313L360.594 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 123.655H351.816L350.28 121.022L351.816 118.388H354.844L356.381 121.022L354.844 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 120.363H346.067L344.531 117.73L346.067 115.053H349.139L350.675 117.73L349.139 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 117.072H340.361L338.825 114.394L340.361 111.761H343.389L344.926 114.394L343.389 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.64 113.736H334.656L333.119 111.103L334.656 108.469H337.64L339.176 111.103L337.64 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.934 110.444H328.906L327.37 107.811L328.906 105.134H331.934L333.471 107.811L331.934 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.878 106.494H323.508L322.367 104.476L323.508 102.457H325.878L327.019 104.476L325.878 106.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.315 274.764H203.472L202.55 273.141L203.472 271.561H205.315L206.237 273.141L205.315 274.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.929 282.401H202.857L201.321 279.768L202.857 277.134H205.929L207.466 279.768L205.929 282.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18 292.32H197.152L195.616 289.687L197.152 287.053H200.18L201.716 289.687L200.18 292.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.929 295.656H202.857L201.321 292.978L202.857 290.345H205.929L207.466 292.978L205.929 295.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.635 298.947H208.607L207.071 296.314L208.607 293.681H211.635L213.171 296.314L211.635 298.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.384 302.239H214.312L212.776 299.606L214.312 296.972H217.384L218.921 299.606L217.384 302.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.827 305.092H220.325L219.052 302.941L220.325 300.747H222.827L224.099 302.941L222.827 305.092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.759 348.191H329.082L327.765 345.908L329.082 343.626H331.759L333.076 345.908L331.759 348.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 345.25H334.612L333.076 342.617L334.612 339.983H337.684L339.22 342.617L337.684 345.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 341.958H340.361L338.825 339.281L340.361 336.648H343.389L344.926 339.281L343.389 341.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 338.623H346.067L344.531 335.989L346.067 333.356H349.139L350.675 335.989L349.139 338.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 335.331H351.816L350.28 332.698L351.816 330.021H354.844L356.381 332.698L354.844 335.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.321 329.845H358.794L358.487 329.362L358.794 328.879H359.321L359.628 329.362L359.321 329.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.833 320.453H375.648L375.077 319.443L375.648 318.478H376.833L377.403 319.443L376.833 320.453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 318.785H380.432L378.896 316.152L380.432 313.518H383.504L385.04 316.152L383.504 318.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.122 315.318H386.269L384.864 312.86L386.269 310.358H389.122L390.57 312.86L389.122 315.318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.236 226.048H426.339L424.891 223.546L426.339 221.044H429.236L430.684 223.546L429.236 226.048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 219.596H426.252L424.759 216.919L426.252 214.286H429.324L430.86 216.919L429.324 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 212.969H426.252L424.759 210.336L426.252 207.658H429.324L430.86 210.336L429.324 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 206.342H426.252L424.759 203.708L426.252 201.075H429.324L430.86 203.708L429.324 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 199.714H426.252L424.759 197.081L426.252 194.448H429.324L430.86 197.081L429.324 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 193.131H426.252L424.759 190.498L426.252 187.821H429.324L430.86 190.498L429.324 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 186.504H426.252L424.759 183.871L426.252 181.237H429.324L430.86 183.871L429.324 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 179.877H426.252L424.759 177.243L426.252 174.61H429.324L430.86 177.243L429.324 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 173.293H426.252L424.759 170.616L426.252 167.983H429.324L430.86 170.616L429.324 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 166.666H426.252L424.759 164.033L426.252 161.356H429.324L430.86 164.033L429.324 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 160.039H426.252L424.759 157.406L426.252 154.772H429.324L430.86 157.406L429.324 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.618 156.747H420.546L419.01 154.114L420.546 151.437H423.618L425.111 154.114L423.618 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 153.456H414.797L413.304 150.778L414.797 148.145H417.869L419.405 150.778L417.869 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 150.12H409.091L407.555 147.487L409.091 144.853H412.119L413.656 147.487L412.119 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 146.828H403.342L401.849 144.195L403.342 141.518H406.414L407.95 144.195L406.414 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 143.493H397.636L396.1 140.859L397.636 138.226H400.664L402.201 140.859L400.664 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 140.201H391.887L390.394 137.568L391.887 134.934H394.959L396.495 137.568L394.959 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 136.909H386.181L384.645 134.232L386.181 131.599H389.209L390.746 134.232L389.209 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 133.574H380.432L378.896 130.941L380.432 128.307H383.504L385.04 130.941L383.504 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 130.282H374.726L373.19 127.649L374.726 124.972H377.754L379.291 127.649L377.754 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 126.991H368.977L367.441 124.313L368.977 121.68H372.049L373.585 124.313L372.049 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.299 123.655H363.271L361.735 121.022L363.271 118.388H366.299L367.836 121.022L366.299 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.243 119.793H357.873L356.644 117.73L357.873 115.623H360.243L361.472 117.73L360.243 119.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 117.072H351.816L350.28 114.394L351.816 111.761H354.844L356.381 114.394L354.844 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 113.736H346.067L344.531 111.103L346.067 108.469H349.139L350.675 111.103L349.139 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 110.444H340.361L338.825 107.811L340.361 105.134H343.389L344.926 107.811L343.389 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.684 107.153H334.612L333.076 104.476L334.612 101.842H337.684L339.22 104.476L337.684 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.759 103.51H329.082L327.721 101.184L329.082 98.8578H331.759L333.119 101.184L331.759 103.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.44 116.633H271.851L270.578 114.394L271.851 112.2H274.44L275.713 114.394L274.44 116.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.778 120.1H266.013L264.653 117.73L266.013 115.316H268.778L270.183 117.73L268.778 120.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.136 166.578H197.196L195.703 164.033L197.196 161.443H200.136L201.628 164.033L200.136 166.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.653 264.933H197.678L196.669 263.222L197.678 261.51H199.653L200.663 263.222L199.653 264.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.136 272.394H197.196L195.703 269.849L197.196 267.303H200.136L201.628 269.849L200.136 272.394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18 279.109H197.152L195.616 276.476L197.152 273.799H200.18L201.716 276.476L200.18 279.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18 285.737H197.152L195.616 283.059L197.152 280.426H200.18L201.716 283.059L200.18 285.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.474 295.656H191.402L189.866 292.978L191.402 290.345H194.474L196.011 292.978L194.474 295.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18 298.947H197.152L195.616 296.314L197.152 293.681H200.18L201.716 296.314L200.18 298.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.929 302.239H202.857L201.321 299.606L202.857 296.972H205.929L207.466 299.606L205.929 302.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.635 305.574H208.607L207.071 302.941L208.607 300.264H211.635L213.171 302.941L211.635 305.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.384 308.866H214.312L212.776 306.233L214.312 303.599H217.384L218.921 306.233L217.384 308.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.949 310.139H221.247L220.896 309.524L221.247 308.954H221.949L222.256 309.524L221.949 310.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.982 350.648H335.314L334.48 349.2L335.314 347.796H336.982L337.816 349.2L336.982 350.648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.082 347.971H340.668L339.483 345.908L340.668 343.846H343.082L344.267 345.908L343.082 347.971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.095 345.162H346.111L344.618 342.617L346.111 340.027H349.095L350.587 342.617L349.095 345.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.616 339.764H353.045L352.782 339.281L353.045 338.842H353.616L353.879 339.281L353.616 339.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.789 327.036H375.692L375.121 326.071L375.692 325.105H376.789L377.359 326.071L376.789 327.036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 325.412H380.432L378.896 322.779L380.432 320.102H383.504L385.04 322.779L383.504 325.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.639 321.111H386.752L385.786 319.443L386.752 317.819H388.639L389.604 319.443L388.639 321.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.976 240.882H433.054L432.572 240.092L433.054 239.258H433.976L434.459 240.092L433.976 240.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.986 235.967H432.089L430.641 233.465L432.089 230.963H434.986L436.434 233.465L434.986 235.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 229.515H432.001L430.465 226.838L432.001 224.204H435.073L436.566 226.838L435.073 229.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 222.888H432.001L430.465 220.254L432.001 217.577H435.073L436.566 220.254L435.073 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 216.261H432.001L430.465 213.627L432.001 210.994H435.073L436.566 213.627L435.073 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 209.677H432.001L430.465 207L432.001 204.367H435.073L436.566 207L435.073 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 203.05H432.001L430.465 200.417L432.001 197.739H435.073L436.566 200.417L435.073 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 196.423H432.001L430.465 193.789L432.001 191.156H435.073L436.566 193.789L435.073 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 189.796H432.001L430.465 187.162L432.001 184.529H435.073L436.566 187.162L435.073 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 183.212H432.001L430.465 180.535L432.001 177.902H435.073L436.566 180.535L435.073 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 176.585H432.001L430.465 173.952L432.001 171.274H435.073L436.566 173.952L435.073 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 169.958H432.001L430.465 167.324L432.001 164.691H435.073L436.566 167.324L435.073 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 163.374H432.001L430.465 160.697L432.001 158.064H435.073L436.566 160.697L435.073 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 156.747H432.001L430.465 154.114L432.001 151.437H435.073L436.566 154.114L435.073 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 153.456H426.252L424.759 150.778L426.252 148.145H429.324L430.86 150.778L429.324 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.618 150.12H420.546L419.01 147.487L420.546 144.853H423.618L425.111 147.487L423.618 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 146.828H414.797L413.304 144.195L414.797 141.518H417.869L419.405 144.195L417.869 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 143.493H409.091L407.555 140.859L409.091 138.226H412.119L413.656 140.859L412.119 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 140.201H403.342L401.849 137.568L403.342 134.934H406.414L407.95 137.568L406.414 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 136.909H397.636L396.1 134.232L397.636 131.599H400.664L402.201 134.232L400.664 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 133.574H391.887L390.394 130.941L391.887 128.307H394.959L396.495 130.941L394.959 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 130.282H386.181L384.645 127.649L386.181 124.972H389.209L390.746 127.649L389.209 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 126.991H380.432L378.896 124.313L380.432 121.68H383.504L385.04 124.313L383.504 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 123.655H374.726L373.19 121.022L374.726 118.388H377.754L379.291 121.022L377.754 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.049 120.363H368.977L367.441 117.73L368.977 115.053H372.049L373.585 117.73L372.049 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.212 116.896H363.359L361.954 114.394L363.359 111.937H366.212L367.66 114.394L366.212 116.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 110.444H351.816L350.28 107.811L351.816 105.178H354.844L356.381 107.811L354.844 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.139 107.153H346.067L344.531 104.476L346.067 101.842H349.139L350.675 104.476L349.139 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.389 103.817H340.361L338.825 101.184L340.361 98.5506H343.389L344.926 101.184L343.389 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.464 100.174H334.831L333.514 97.8922L334.831 95.5661H337.464L338.781 97.8922L337.464 100.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.734 113.385H266.101L264.784 111.103L266.101 108.821H268.734L270.051 111.103L268.734 113.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.161 117.028H260.176L258.684 114.394L260.176 111.805H263.161L264.697 114.394L263.161 117.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.299 156.44H191.578L190.217 154.114L191.578 151.744H194.299L195.659 154.114L194.299 156.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.036 162.628H191.841L190.744 160.697L191.841 158.81H194.036L195.133 160.697L194.036 162.628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.772 261.334H192.104L191.314 259.93L192.104 258.526H193.772L194.562 259.93L193.772 261.334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.474 269.191H191.402L189.866 266.557L191.402 263.88H194.474L196.011 266.557L194.474 269.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.474 275.818H191.402L189.866 273.141L191.402 270.507H194.474L196.011 273.141L194.474 275.818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.474 282.401H191.402L189.866 279.768L191.402 277.134H194.474L196.011 279.768L194.474 282.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.474 289.028H191.402L189.866 286.395L191.402 283.718H194.474L196.011 286.395L194.474 289.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 298.947H185.697L184.161 296.314L185.697 293.681H188.725L190.261 296.314L188.725 298.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.474 302.239H191.402L189.866 299.606L191.402 296.972H194.474L196.011 299.606L194.474 302.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18 305.574H197.152L195.616 302.941L197.152 300.264H200.18L201.716 302.941L200.18 305.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.929 308.866H202.857L201.321 306.233L202.857 303.599H205.929L207.466 306.233L205.929 308.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.635 312.202H208.607L207.071 309.524L208.607 306.891H211.635L213.171 309.524L211.635 312.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.384 315.493H214.312L212.776 312.86L214.312 310.183H217.384L218.921 312.86L217.384 315.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.67 330.547H381.309L380.607 329.362L381.309 328.221H382.67L383.328 329.362L382.67 330.547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.901 251.108H438.628L437.97 250.011L438.628 248.914H439.901L440.516 250.011L439.901 251.108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 246.017H437.751L436.214 243.384L437.751 240.751H440.779L442.315 243.384L440.779 246.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 239.434H437.707L436.214 236.757L437.707 234.123H440.779L442.315 236.757L440.779 239.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 232.807H437.707L436.214 230.173L437.707 227.496H440.779L442.315 230.173L440.779 232.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 226.179H437.707L436.214 223.546L437.707 220.913H440.779L442.315 223.546L440.779 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 219.596H437.707L436.214 216.919L437.707 214.286H440.779L442.315 216.919L440.779 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 212.969H437.707L436.214 210.336L437.707 207.658H440.779L442.315 210.336L440.779 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 206.342H437.707L436.214 203.708L437.707 201.075H440.779L442.315 203.708L440.779 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 199.714H437.707L436.214 197.081L437.707 194.448H440.779L442.315 197.081L440.779 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 193.131H437.707L436.214 190.498L437.707 187.821H440.779L442.315 190.498L440.779 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 186.504H437.707L436.214 183.871L437.707 181.237H440.779L442.315 183.871L440.779 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 179.877H437.707L436.214 177.243L437.707 174.61H440.779L442.315 177.243L440.779 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 173.293H437.707L436.214 170.616L437.707 167.983H440.779L442.315 170.616L440.779 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 166.666H437.707L436.214 164.033L437.707 161.356H440.779L442.315 164.033L440.779 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 160.039H437.707L436.214 157.406L437.707 154.772H440.779L442.315 157.406L440.779 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 153.456H437.707L436.214 150.778L437.707 148.145H440.779L442.315 150.778L440.779 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 150.12H432.001L430.465 147.487L432.001 144.853H435.073L436.566 147.487L435.073 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 146.828H426.252L424.759 144.195L426.252 141.518H429.324L430.86 144.195L429.324 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.618 143.493H420.546L419.01 140.859L420.546 138.226H423.618L425.111 140.859L423.618 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 140.201H414.797L413.304 137.568L414.797 134.934H417.869L419.405 137.568L417.869 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 136.909H409.091L407.555 134.232L409.091 131.599H412.119L413.656 134.232L412.119 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 133.574H403.342L401.849 130.941L403.342 128.307H406.414L407.95 130.941L406.414 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 130.282H397.636L396.1 127.649L397.636 124.972H400.664L402.201 127.649L400.664 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 126.991H391.887L390.394 124.313L391.887 121.68H394.959L396.495 124.313L394.959 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 123.655H386.181L384.645 121.022L386.181 118.388H389.209L390.746 121.022L389.209 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 120.363H380.432L378.896 117.73L380.432 115.053H383.504L385.04 117.73L383.504 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.754 117.072H374.726L373.19 114.394L374.726 111.761H377.754L379.291 114.394L377.754 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.005 113.692H369.021L367.528 111.103L369.021 108.513H372.005L373.497 111.103L372.005 113.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.212 110.269H363.359L361.911 107.811L363.359 105.309H366.212L367.66 107.811L366.212 110.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.506 107.021H357.609L356.161 104.476L357.609 101.974H360.506L361.954 104.476L360.506 107.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.537 103.291H352.123L350.894 101.184L352.123 99.0333H354.537L355.766 101.184L354.537 103.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.832 99.9989H346.374L345.145 97.8922L346.374 95.7417H348.832L350.061 97.8922L348.832 99.9989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.775 96.1367H340.976L340.054 94.5567L340.976 92.9767H342.775L343.697 94.5567L342.775 96.1367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.414 109.084H260.922L260.22 107.811L260.922 106.538H262.414L263.161 107.811L262.414 109.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.256 132.082H220.939L220.281 130.941L220.939 129.799H222.256L222.914 130.941L222.256 132.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.948 149.286H191.929L190.876 147.487L191.929 145.687H193.948L195.001 147.487L193.948 149.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 153.456H185.697L184.161 150.778L185.697 148.145H188.725L190.261 150.778L188.725 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.067 158.898H186.355L185.521 157.406L186.355 155.913H188.067L188.901 157.406L188.067 158.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.759 257.56H186.662L186.136 256.638L186.662 255.673H187.759L188.286 256.638L187.759 257.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 265.899H185.697L184.161 263.222L185.697 260.588H188.725L190.261 263.222L188.725 265.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 272.482H185.697L184.161 269.849L185.697 267.216H188.725L190.261 269.849L188.725 272.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 279.109H185.697L184.161 276.476L185.697 273.799H188.725L190.261 276.476L188.725 279.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 285.737H185.697L184.161 283.059L185.697 280.426H188.725L190.261 283.059L188.725 285.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 292.32H185.697L184.161 289.687L185.697 287.053H188.725L190.261 289.687L188.725 292.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 302.239H179.947L178.411 299.606L179.947 296.972H183.019L184.556 299.606L183.019 302.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 305.574H185.697L184.161 302.941L185.697 300.264H188.725L190.261 302.941L188.725 305.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.474 308.866H191.402L189.866 306.233L191.402 303.599H194.474L196.011 306.233L194.474 308.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18 312.202H197.152L195.616 309.524L197.152 306.891H200.18L201.716 309.524L200.18 312.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.929 315.493H202.857L201.321 312.86L202.857 310.183H205.929L207.466 312.86L205.929 315.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.635 318.785H208.607L207.071 316.152L208.607 313.518H211.635L213.171 316.152L211.635 318.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.384 322.121H214.312L212.776 319.443L214.312 316.81H217.384L218.921 319.443L217.384 322.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.089 255.234H443.851L442.754 253.303L443.851 251.372H446.089L447.231 253.303L446.089 255.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 249.353H443.456L441.92 246.719L443.456 244.042H446.528L448.021 246.719L446.528 249.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 242.726H443.456L441.92 240.092L443.456 237.459H446.528L448.021 240.092L446.528 242.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 236.098H443.456L441.92 233.465L443.456 230.832H446.528L448.021 233.465L446.528 236.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 229.515H443.456L441.92 226.838L443.456 224.204H446.528L448.021 226.838L446.528 229.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 222.888H443.456L441.92 220.254L443.456 217.577H446.528L448.021 220.254L446.528 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 216.261H443.456L441.92 213.627L443.456 210.994H446.528L448.021 213.627L446.528 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 209.677H443.456L441.92 207L443.456 204.367H446.528L448.021 207L446.528 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 203.05H443.456L441.92 200.417L443.456 197.739H446.528L448.021 200.417L446.528 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 196.423H443.456L441.92 193.789L443.456 191.156H446.528L448.021 193.789L446.528 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 189.796H443.456L441.92 187.162L443.456 184.529H446.528L448.021 187.162L446.528 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 183.212H443.456L441.92 180.535L443.456 177.902H446.528L448.021 180.535L446.528 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 176.585H443.456L441.92 173.952L443.456 171.274H446.528L448.021 173.952L446.528 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 169.958H443.456L441.92 167.324L443.456 164.691H446.528L448.021 167.324L446.528 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 163.374H443.456L441.92 160.697L443.456 158.064H446.528L448.021 160.697L446.528 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 156.747H443.456L441.92 154.114L443.456 151.437H446.528L448.021 154.114L446.528 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 150.12H443.456L441.92 147.487L443.456 144.853H446.528L448.021 147.487L446.528 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 146.828H437.707L436.214 144.195L437.707 141.518H440.779L442.315 144.195L440.779 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 143.493H432.001L430.465 140.859L432.001 138.226H435.073L436.566 140.859L435.073 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 140.201H426.252L424.759 137.568L426.252 134.934H429.324L430.86 137.568L429.324 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.618 136.909H420.546L419.01 134.232L420.546 131.599H423.618L425.111 134.232L423.618 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 133.574H414.797L413.304 130.941L414.797 128.307H417.869L419.405 130.941L417.869 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 130.282H409.091L407.555 127.649L409.091 124.972H412.119L413.656 127.649L412.119 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 126.991H403.342L401.849 124.313L403.342 121.68H406.414L407.95 124.313L406.414 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 123.655H397.636L396.1 121.022L397.636 118.388H400.664L402.201 121.022L400.664 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 120.363H391.887L390.394 117.73L391.887 115.053H394.959L396.495 117.73L394.959 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 117.072H386.181L384.645 114.394L386.181 111.761H389.209L390.746 114.394L389.209 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.504 113.736H380.432L378.896 111.103L380.432 108.469H383.504L385.04 111.103L383.504 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.228 109.479H375.253L374.287 107.811L375.253 106.099H377.228L378.193 107.811L377.228 109.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.829 106.758H369.196L367.923 104.476L369.196 102.237H371.829L373.146 104.476L371.829 106.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 80.6878H323.157L321.664 78.0106L323.157 75.3772H326.229L327.721 78.0106L326.229 80.6878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.909 76.3428H318.022L317.056 74.7189L318.022 73.095H319.909L320.874 74.7189L319.909 76.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.896 72.5683H312.579L311.921 71.4272L312.579 70.2861H313.896L314.554 71.4272L313.896 72.5683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.654 121.636H226.952L226.645 121.022L226.952 120.451H227.654L228.006 121.022L227.654 121.636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09 126.991H220.062L218.526 124.313L220.062 121.68H223.09L224.626 124.313L223.09 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.209 129.975H214.488L213.127 127.649L214.488 125.279H217.209L218.569 127.649L217.209 129.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 146.828H185.697L184.161 144.195L185.697 141.518H188.725L190.261 144.195L188.725 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 150.12H179.947L178.411 147.487L179.947 144.853H183.019L184.556 147.487L183.019 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 156.747H179.947L178.411 154.114L179.947 151.437H183.019L184.556 154.114L183.019 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.976 163.331H179.991L178.455 160.697L179.991 158.108H182.976L184.512 160.697L182.976 163.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.8 169.607H180.167L178.85 167.324L180.167 165.042H182.8L184.073 167.324L182.8 169.607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.932 255.804H180.035L178.587 253.303L180.035 250.801H182.932L184.38 253.303L182.932 255.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 262.563H179.947L178.411 259.93L179.947 257.297H183.019L184.556 259.93L183.019 262.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 269.191H179.947L178.411 266.557L179.947 263.88H183.019L184.556 266.557L183.019 269.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 275.818H179.947L178.411 273.141L179.947 270.507H183.019L184.556 273.141L183.019 275.818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 282.401H179.947L178.411 279.768L179.947 277.134H183.019L184.556 279.768L183.019 282.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 289.028H179.947L178.411 286.395L179.947 283.718H183.019L184.556 286.395L183.019 289.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 295.656H179.947L178.411 292.978L179.947 290.345H183.019L184.556 292.978L183.019 295.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 305.574H174.242L172.706 302.941L174.242 300.264H177.27L178.806 302.941L177.27 305.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 308.866H179.947L178.411 306.233L179.947 303.599H183.019L184.556 306.233L183.019 308.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 312.202H185.697L184.161 309.524L185.697 306.891H188.725L190.261 309.524L188.725 312.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.474 315.493H191.402L189.866 312.86L191.402 310.183H194.474L196.011 312.86L194.474 315.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18 318.785H197.152L195.616 316.152L197.152 313.518H200.18L201.716 316.152L200.18 318.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.929 322.121H202.857L201.321 319.443L202.857 316.81H205.929L207.466 319.443L205.929 322.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.635 325.412H208.607L207.071 322.779L208.607 320.146H211.635L213.171 322.779L211.635 325.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.795 258.482H449.644L448.547 256.638L449.644 254.751H451.795L452.892 256.638L451.795 258.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.014 239.039H449.381L448.108 236.757L449.381 234.518H452.014L453.331 236.757L452.014 239.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 232.807H449.162L447.669 230.173L449.162 227.496H452.234L453.77 230.173L452.234 232.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 226.179H449.162L447.669 223.546L449.162 220.913H452.234L453.77 223.546L452.234 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 219.596H449.162L447.669 216.919L449.162 214.286H452.234L453.77 216.919L452.234 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 212.969H449.162L447.669 210.336L449.162 207.658H452.234L453.77 210.336L452.234 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 206.342H449.162L447.669 203.708L449.162 201.075H452.234L453.77 203.708L452.234 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 199.714H449.162L447.669 197.081L449.162 194.448H452.234L453.77 197.081L452.234 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 193.131H449.162L447.669 190.498L449.162 187.821H452.234L453.77 190.498L452.234 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 186.504H449.162L447.669 183.871L449.162 181.237H452.234L453.77 183.871L452.234 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 179.877H449.162L447.669 177.243L449.162 174.61H452.234L453.77 177.243L452.234 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 173.293H449.162L447.669 170.616L449.162 167.983H452.234L453.77 170.616L452.234 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 166.666H449.162L447.669 164.033L449.162 161.356H452.234L453.77 164.033L452.234 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 160.039H449.162L447.669 157.406L449.162 154.772H452.234L453.77 157.406L452.234 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 153.456H449.162L447.669 150.778L449.162 148.145H452.234L453.77 150.778L452.234 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 146.828H449.162L447.669 144.195L449.162 141.518H452.234L453.77 144.195L452.234 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 143.493H443.456L441.92 140.859L443.456 138.226H446.528L448.021 140.859L446.528 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 140.201H437.707L436.214 137.568L437.707 134.934H440.779L442.315 137.568L440.779 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 136.909H432.001L430.465 134.232L432.001 131.599H435.073L436.566 134.232L435.073 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 133.574H426.252L424.759 130.941L426.252 128.307H429.324L430.86 130.941L429.324 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.618 130.282H420.546L419.01 127.649L420.546 124.972H423.618L425.111 127.649L423.618 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 126.991H414.797L413.304 124.313L414.797 121.68H417.869L419.405 124.313L417.869 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 123.655H409.091L407.555 121.022L409.091 118.388H412.119L413.656 121.022L412.119 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 120.363H403.342L401.849 117.73L403.342 115.053H406.414L407.95 117.73L406.414 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 117.072H397.636L396.1 114.394L397.636 111.761H400.664L402.201 114.394L400.664 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 113.736H391.887L390.394 111.103L391.887 108.469H394.959L396.495 111.103L394.959 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.209 110.444H386.181L384.645 107.811L386.181 105.134H389.209L390.746 107.811L389.209 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.021 106.275H380.958L379.905 104.476L380.958 102.72H383.021L384.031 104.476L383.021 106.275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.455 78.5372H335.841L335.533 78.0106L335.841 77.5278H336.455L336.762 78.0106L336.455 78.5372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.013 75.7722H329.784L329.169 74.7189L329.784 73.6656H331.013L331.671 74.7189L331.013 75.7722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.229 74.0606H323.157L321.621 71.4272L323.157 68.75H326.229L327.765 71.4272L326.229 74.0606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.479 70.7689H317.451L315.915 68.0917L317.451 65.4583H320.479L322.016 68.0917L320.479 70.7689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.774 67.4333H311.702L310.166 64.8L311.702 62.1667H314.774L316.266 64.8L314.774 67.4333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.239 95.5222H261.142L260.571 94.5567L261.142 93.5911H262.239L262.766 94.5567L262.239 95.5222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.884 99.4722H255.041L254.076 97.8922L255.041 96.2683H256.884L257.806 97.8922L256.884 99.4722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.749 103.817H248.721L247.185 101.184L248.721 98.5506H251.749L253.242 101.184L251.749 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 107.153H242.972L241.436 104.476L242.972 101.842H246L247.536 104.476L246 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.294 110.444H237.222L235.73 107.811L237.222 105.178H240.294L241.787 107.811L240.294 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.457 113.561H231.648L230.2 111.103L231.648 108.645H234.457L235.862 111.103L234.457 113.561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.664 116.764H225.943L224.582 114.394L225.943 112.024H228.664L230.068 114.394L228.664 116.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09 120.363H220.062L218.526 117.73L220.062 115.053H223.09L224.626 117.73L223.09 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.384 123.655H214.312L212.776 121.022L214.312 118.388H217.384L218.921 121.022L217.384 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.284 126.332H208.958L207.817 124.313L208.958 122.338H211.284L212.425 124.313L211.284 126.332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.681 140.113H185.741L184.248 137.568L185.741 135.022H188.681L190.173 137.568L188.681 140.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 143.493H179.947L178.411 140.859L179.947 138.226H183.019L184.556 140.859L183.019 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 146.828H174.242L172.706 144.195L174.242 141.518H177.27L178.806 144.195L177.27 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 153.456H174.242L172.706 150.778L174.242 148.145H177.27L178.806 150.778L177.27 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 160.039H174.242L172.706 157.406L174.242 154.772H177.27L178.806 157.406L177.27 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 166.666H174.242L172.706 164.033L174.242 161.356H177.27L178.806 164.033L177.27 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.743 172.328H174.768L173.803 170.616L174.768 168.948H176.743L177.709 170.616L176.743 172.328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.007 252.206H174.505L173.232 250.011L174.505 247.817H177.007L178.279 250.011L177.007 252.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 259.272H174.242L172.706 256.638L174.242 253.961H177.27L178.806 256.638L177.27 259.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 265.899H174.242L172.706 263.222L174.242 260.588H177.27L178.806 263.222L177.27 265.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 272.482H174.242L172.706 269.849L174.242 267.216H177.27L178.806 269.849L177.27 272.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 279.109H174.242L172.706 276.476L174.242 273.799H177.27L178.806 276.476L177.27 279.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 285.737H174.242L172.706 283.059L174.242 280.426H177.27L178.806 283.059L177.27 285.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 292.32H174.242L172.706 289.687L174.242 287.053H177.27L178.806 289.687L177.27 292.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 298.947H174.242L172.706 296.314L174.242 293.681H177.27L178.806 296.314L177.27 298.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 308.866H168.492L166.956 306.233L168.492 303.599H171.564L173.101 306.233L171.564 308.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 312.202H174.242L172.706 309.524L174.242 306.891H177.27L178.806 309.524L177.27 312.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 315.493H179.947L178.411 312.86L179.947 310.183H183.019L184.556 312.86L183.019 315.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 318.785H185.697L184.161 316.152L185.697 313.518H188.725L190.261 316.152L188.725 318.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.474 322.121H191.402L189.866 319.443L191.402 316.81H194.474L196.011 319.443L194.474 322.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18 325.412H197.152L195.616 322.779L197.152 320.102H200.18L201.716 322.779L200.18 325.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.929 328.704H202.857L201.321 326.071L202.857 323.437H205.929L207.466 326.071L205.929 328.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.974 234.387H455.921L455.394 233.465L455.921 232.543H456.974L457.501 233.465L456.974 234.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 229.515H454.911L453.375 226.838L454.911 224.204H457.983L459.476 226.838L457.983 229.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 222.888H454.911L453.375 220.254L454.911 217.577H457.983L459.476 220.254L457.983 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 216.261H454.911L453.375 213.627L454.911 210.994H457.983L459.476 213.627L457.983 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 209.677H454.911L453.375 207L454.911 204.367H457.983L459.476 207L457.983 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 203.05H454.911L453.375 200.417L454.911 197.739H457.983L459.476 200.417L457.983 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 196.423H454.911L453.375 193.789L454.911 191.156H457.983L459.476 193.789L457.983 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 189.796H454.911L453.375 187.162L454.911 184.529H457.983L459.476 187.162L457.983 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 183.212H454.911L453.375 180.535L454.911 177.902H457.983L459.476 180.535L457.983 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 176.585H454.911L453.375 173.952L454.911 171.274H457.983L459.476 173.952L457.983 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 169.958H454.911L453.375 167.324L454.911 164.691H457.983L459.476 167.324L457.983 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 163.374H454.911L453.375 160.697L454.911 158.064H457.983L459.476 160.697L457.983 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 156.747H454.911L453.375 154.114L454.911 151.437H457.983L459.476 154.114L457.983 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 150.12H454.911L453.375 147.487L454.911 144.853H457.983L459.476 147.487L457.983 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 143.493H454.911L453.375 140.859L454.911 138.226H457.983L459.476 140.859L457.983 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 140.201H449.162L447.669 137.568L449.162 134.934H452.234L453.77 137.568L452.234 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 136.909H443.456L441.92 134.232L443.456 131.599H446.528L448.021 134.232L446.528 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 133.574H437.707L436.214 130.941L437.707 128.307H440.779L442.315 130.941L440.779 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 130.282H432.001L430.465 127.649L432.001 124.972H435.073L436.566 127.649L435.073 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 126.991H426.252L424.759 124.313L426.252 121.68H429.324L430.86 124.313L429.324 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.618 123.655H420.546L419.01 121.022L420.546 118.388H423.618L425.111 121.022L423.618 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 120.363H414.797L413.304 117.73L414.797 115.053H417.869L419.405 117.73L417.869 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 117.072H409.091L407.555 114.394L409.091 111.761H412.119L413.656 114.394L412.119 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 113.736H403.342L401.849 111.103L403.342 108.469H406.414L407.95 111.103L406.414 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 110.444H397.636L396.1 107.811L397.636 105.134H400.664L402.201 107.811L400.664 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.959 107.153H391.887L390.394 104.476L391.887 101.842H394.959L396.495 104.476L394.959 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.156 102.018H387.234L386.752 101.184L387.234 100.35H388.156L388.639 101.184L388.156 102.018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.718 72.3928H335.577L335.051 71.4272L335.577 70.4617H336.718L337.245 71.4272L336.718 72.3928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.452 69.8911H329.389L328.379 68.0917L329.389 66.3361H331.452L332.461 68.0917L331.452 69.8911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.439 66.1167H323.903L323.157 64.8L323.903 63.4833H325.439L326.229 64.8L325.439 66.1167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.294 62.035H318.636L318.329 61.5083L318.636 60.9378H319.294L319.602 61.5083L319.294 62.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.161 90.5189H260.22L258.728 87.9733L260.22 85.3839H263.161L264.609 87.9733L263.161 90.5189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.972 93.0205H254.953L253.944 91.265L254.953 89.5094H256.972L257.982 91.265L256.972 93.0205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.398 96.6195H249.028L247.843 94.5567L249.028 92.4939H251.398L252.627 94.5567L251.398 96.6195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 100.526H242.972L241.436 97.8922L242.972 95.215H246L247.536 97.8922L246 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.294 103.817H237.222L235.73 101.184L237.222 98.5506H240.294L241.831 101.184L240.294 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.545 107.153H231.517L229.981 104.476L231.517 101.842H234.545L236.081 104.476L234.545 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.839 110.444H225.767L224.275 107.811L225.767 105.134H228.839L230.376 107.811L228.839 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09 113.736H220.062L218.526 111.103L220.062 108.469H223.09L224.626 111.103L223.09 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.384 117.072H214.312L212.776 114.394L214.312 111.761H217.384L218.921 114.394L217.384 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.372 119.881H208.87L207.641 117.73L208.87 115.579H211.372L212.601 117.73L211.372 119.881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.452 131.379H186.969L186.706 130.941L186.969 130.502H187.452L187.716 130.941L187.452 131.379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.8 136.514H180.167L178.85 134.232L180.167 131.994H182.8L184.073 134.232L182.8 136.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 140.201H174.242L172.706 137.568L174.242 134.934H177.27L178.806 137.568L177.27 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 143.493H168.492L166.956 140.859L168.492 138.226H171.564L173.101 140.859L171.564 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 150.12H168.492L166.956 147.487L168.492 144.853H171.564L173.101 147.487L171.564 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 156.747H168.492L166.956 154.114L168.492 151.437H171.564L173.101 154.114L171.564 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 163.374H168.492L166.956 160.697L168.492 158.064H171.564L173.101 160.697L171.564 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 169.958H168.492L166.956 167.324L168.492 164.691H171.564L173.101 167.324L171.564 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.731 175.181H169.326L168.58 173.952L169.326 172.679H170.731L171.477 173.952L170.731 175.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.336 181.062H169.721L169.414 180.535L169.721 180.052H170.336L170.643 180.535L170.336 181.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.906 235.001H169.151L168.273 233.465L169.151 231.929H170.906L171.784 233.465L170.906 235.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.467 247.422H169.589L169.194 246.719L169.589 245.973H170.467L170.862 246.719L170.467 247.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 255.98H168.492L166.956 253.303L168.492 250.669H171.564L173.101 253.303L171.564 255.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 262.563H168.492L166.956 259.93L168.492 257.297H171.564L173.101 259.93L171.564 262.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 269.191H168.492L166.956 266.557L168.492 263.88H171.564L173.101 266.557L171.564 269.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 275.818H168.492L166.956 273.141L168.492 270.507H171.564L173.101 273.141L171.564 275.818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 282.401H168.492L166.956 279.768L168.492 277.134H171.564L173.101 279.768L171.564 282.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 289.028H168.492L166.956 286.395L168.492 283.718H171.564L173.101 286.395L171.564 289.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 295.656H168.492L166.956 292.978L168.492 290.345H171.564L173.101 292.978L171.564 295.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 302.239H168.492L166.956 299.606L168.492 296.972H171.564L173.101 299.606L171.564 302.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 312.202H162.787L161.251 309.524L162.787 306.891H165.815L167.351 309.524L165.815 312.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 315.493H168.492L166.956 312.86L168.492 310.183H171.564L173.101 312.86L171.564 315.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 318.785H174.242L172.706 316.152L174.242 313.518H177.27L178.806 316.152L177.27 318.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 322.121H179.947L178.411 319.443L179.947 316.81H183.019L184.556 319.443L183.019 322.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 325.412H185.697L184.161 322.779L185.697 320.102H188.725L190.261 322.779L188.725 325.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.474 328.704H191.402L189.866 326.071L191.402 323.437H194.474L196.011 326.071L194.474 328.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18 332.039H197.152L195.616 329.362L197.152 326.729H200.18L201.716 329.362L200.18 332.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.929 335.331H202.857L201.321 332.698L202.857 330.021H205.929L207.466 332.698L205.929 335.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 226.179H460.661L459.124 223.546L460.661 220.913H463.689L465.225 223.546L463.689 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 219.596H460.661L459.124 216.919L460.661 214.286H463.689L465.225 216.919L463.689 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 212.969H460.661L459.124 210.336L460.661 207.658H463.689L465.225 210.336L463.689 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 206.342H460.661L459.124 203.708L460.661 201.075H463.689L465.225 203.708L463.689 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 199.714H460.661L459.124 197.081L460.661 194.448H463.689L465.225 197.081L463.689 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 193.131H460.661L459.124 190.498L460.661 187.821H463.689L465.225 190.498L463.689 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 186.504H460.661L459.124 183.871L460.661 181.237H463.689L465.225 183.871L463.689 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 179.877H460.661L459.124 177.243L460.661 174.61H463.689L465.225 177.243L463.689 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 173.293H460.661L459.124 170.616L460.661 167.983H463.689L465.225 170.616L463.689 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 166.666H460.661L459.124 164.033L460.661 161.356H463.689L465.225 164.033L463.689 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 160.039H460.661L459.124 157.406L460.661 154.772H463.689L465.225 157.406L463.689 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 153.456H460.661L459.124 150.778L460.661 148.145H463.689L465.225 150.778L463.689 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 146.828H460.661L459.124 144.195L460.661 141.518H463.689L465.225 144.195L463.689 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 140.201H460.661L459.124 137.568L460.661 134.934H463.689L465.225 137.568L463.689 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 136.909H454.911L453.375 134.232L454.911 131.599H457.983L459.476 134.232L457.983 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 133.574H449.162L447.669 130.941L449.162 128.307H452.234L453.77 130.941L452.234 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 130.282H443.456L441.92 127.649L443.456 124.972H446.528L448.021 127.649L446.528 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 126.991H437.707L436.214 124.313L437.707 121.68H440.779L442.315 124.313L440.779 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 123.655H432.001L430.465 121.022L432.001 118.388H435.073L436.566 121.022L435.073 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 120.363H426.252L424.759 117.73L426.252 115.053H429.324L430.86 117.73L429.324 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.618 117.072H420.546L419.01 114.394L420.546 111.761H423.618L425.111 114.394L423.618 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 113.736H414.797L413.304 111.103L414.797 108.469H417.869L419.405 111.103L417.869 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 110.444H409.091L407.555 107.811L409.091 105.134H412.119L413.656 107.811L412.119 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.414 107.153H403.342L401.849 104.476L403.342 101.842H406.414L407.95 104.476L406.414 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.664 103.817H397.636L396.1 101.184L397.636 98.5506H400.664L402.201 101.184L400.664 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.818 98.5944H393.028L392.633 97.8922L393.028 97.19H393.818L394.257 97.8922L393.818 98.5944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.99 96.8389H386.401L385.084 94.5567L386.401 92.3183H388.99L390.307 94.5567L388.99 96.8389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.451 92.055H381.485L381.046 91.265L381.485 90.4311H382.451L382.889 91.265L382.451 92.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.421 66.9944H334.875L333.602 64.8L334.875 62.6056H337.421L338.693 64.8L337.421 66.9944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.715 63.7467H329.126L327.809 61.5083L329.126 59.27H331.715L332.988 61.5083L331.715 63.7467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.725 78.5811H267.067L266.759 78.0105L267.067 77.44H267.725L268.076 78.0105L267.725 78.5811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.204 83.9356H260.176L258.64 81.3461L260.176 78.7128H263.204L264.697 81.3461L263.204 83.9356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.499 87.2711H254.427L252.891 84.6378L254.427 82.0044H257.499L258.991 84.6378L257.499 87.2711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.749 90.6067H248.677L247.185 87.9733L248.677 85.2961H251.749L253.286 87.9733L251.749 90.6067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 93.8983H242.972L241.436 91.265L242.972 88.6317H246L247.536 91.265L246 93.8983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.294 97.2339H237.222L235.73 94.5567L237.222 91.9233H240.294L241.831 94.5567L240.294 97.2339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.545 100.526H231.517L229.981 97.8922L231.517 95.215H234.545L236.081 97.8922L234.545 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.839 103.817H225.767L224.275 101.184L225.767 98.5506H228.839L230.376 101.184L228.839 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09 107.153H220.062L218.526 104.476L220.062 101.842H223.09L224.626 104.476L223.09 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.384 110.444H214.312L212.776 107.811L214.312 105.134H217.384L218.921 107.811L217.384 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.635 113.736H208.607L207.071 111.103L208.607 108.469H211.635L213.171 111.103L211.635 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.094 133.223H174.417L173.101 130.941L174.417 128.658H177.094L178.411 130.941L177.094 133.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 136.909H168.492L166.956 134.232L168.492 131.599H171.564L173.101 134.232L171.564 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 140.201H162.787L161.251 137.568L162.787 134.934H165.815L167.351 137.568L165.815 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 146.828H162.787L161.251 144.195L162.787 141.518H165.815L167.351 144.195L165.815 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 153.456H162.787L161.251 150.778L162.787 148.145H165.815L167.351 150.778L165.815 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 160.039H162.787L161.251 157.406L162.787 154.772H165.815L167.351 157.406L165.815 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 166.666H162.787L161.251 164.033L162.787 161.356H165.815L167.351 164.033L165.815 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 173.293H162.787L161.251 170.616L162.787 167.983H165.815L167.351 170.616L165.815 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 179.877H162.787L161.251 177.243L162.787 174.61H165.815L167.351 177.243L165.815 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.762 224.336H163.84L163.401 223.546L163.84 222.756H164.762L165.201 223.546L164.762 224.336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.639 232.499H162.962L161.602 230.173L162.962 227.803H165.639L167 230.173L165.639 232.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 252.644H162.787L161.251 250.011L162.787 247.378H165.815L167.351 250.011L165.815 252.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 259.272H162.787L161.251 256.638L162.787 253.961H165.815L167.351 256.638L165.815 259.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 265.899H162.787L161.251 263.222L162.787 260.588H165.815L167.351 263.222L165.815 265.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 272.482H162.787L161.251 269.849L162.787 267.216H165.815L167.351 269.849L165.815 272.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 279.109H162.787L161.251 276.476L162.787 273.799H165.815L167.351 276.476L165.815 279.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 285.737H162.787L161.251 283.059L162.787 280.426H165.815L167.351 283.059L165.815 285.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 292.32H162.787L161.251 289.687L162.787 287.053H165.815L167.351 289.687L165.815 292.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 298.947H162.787L161.251 296.314L162.787 293.681H165.815L167.351 296.314L165.815 298.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 305.574H162.787L161.251 302.941L162.787 300.264H165.815L167.351 302.941L165.815 305.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.639 318.434H162.962L161.646 316.152L162.962 313.869H165.639L166.956 316.152L165.639 318.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 322.121H168.492L166.956 319.443L168.492 316.81H171.564L173.101 319.443L171.564 322.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 325.412H174.242L172.706 322.779L174.242 320.102H177.27L178.806 322.779L177.27 325.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 328.704H179.947L178.411 326.071L179.947 323.437H183.019L184.556 326.071L183.019 328.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 332.039H185.697L184.161 329.362L185.697 326.729H188.725L190.261 329.362L188.725 332.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.474 335.331H191.402L189.866 332.698L191.402 330.021H194.474L196.011 332.698L194.474 335.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18 338.623H197.152L195.616 335.989L197.152 333.356H200.18L201.716 335.989L200.18 338.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.052 340.422H203.735L203.077 339.281L203.735 338.14H205.052L205.71 339.281L205.052 340.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.824 228.506H466.937L466.015 226.838L466.937 225.214H468.824L469.789 226.838L468.824 228.506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 222.888H466.366L464.83 220.254L466.366 217.577H469.438L470.931 220.254L469.438 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 216.261H466.366L464.83 213.627L466.366 210.994H469.438L470.931 213.627L469.438 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 209.677H466.366L464.83 207L466.366 204.367H469.438L470.931 207L469.438 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 203.05H466.366L464.83 200.417L466.366 197.739H469.438L470.931 200.417L469.438 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 196.423H466.366L464.83 193.789L466.366 191.156H469.438L470.931 193.789L469.438 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 189.796H466.366L464.83 187.162L466.366 184.529H469.438L470.931 187.162L469.438 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 183.212H466.366L464.83 180.535L466.366 177.902H469.438L470.931 180.535L469.438 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 176.585H466.366L464.83 173.952L466.366 171.274H469.438L470.931 173.952L469.438 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 169.958H466.366L464.83 167.324L466.366 164.691H469.438L470.931 167.324L469.438 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 163.374H466.366L464.83 160.697L466.366 158.064H469.438L470.931 160.697L469.438 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 156.747H466.366L464.83 154.114L466.366 151.437H469.438L470.931 154.114L469.438 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 150.12H466.366L464.83 147.487L466.366 144.853H469.438L470.931 147.487L469.438 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 143.493H466.366L464.83 140.859L466.366 138.226H469.438L470.931 140.859L469.438 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 136.909H466.366L464.83 134.232L466.366 131.599H469.438L470.931 134.232L469.438 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 133.574H460.661L459.124 130.941L460.661 128.307H463.689L465.225 130.941L463.689 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 130.282H454.911L453.375 127.649L454.911 124.972H457.983L459.476 127.649L457.983 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 126.991H449.162L447.669 124.313L449.162 121.68H452.234L453.77 124.313L452.234 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 123.655H443.456L441.92 121.022L443.456 118.388H446.528L448.021 121.022L446.528 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 120.363H437.707L436.214 117.73L437.707 115.053H440.779L442.315 117.73L440.779 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 117.072H432.001L430.465 114.394L432.001 111.761H435.073L436.566 114.394L435.073 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 113.736H426.252L424.759 111.103L426.252 108.469H429.324L430.86 111.103L429.324 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.618 110.444H420.546L419.01 107.811L420.546 105.134H423.618L425.111 107.811L423.618 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.869 107.153H414.797L413.304 104.476L414.797 101.842H417.869L419.405 104.476L417.869 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.119 103.817H409.091L407.555 101.184L409.091 98.5506H412.119L413.656 101.184L412.119 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.58 99.0772H404.176L403.473 97.8922L404.176 96.6633H405.58L406.282 97.8922L405.58 99.0772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.727 89.685H386.708L385.654 87.9733L386.708 86.2178H388.727L389.736 87.9733L388.727 89.685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.954 65.4145H347.252L346.901 64.8L347.252 64.1856H347.954L348.305 64.8L347.954 65.4145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.214 63.8344H340.537L339.176 61.5083L340.537 59.1383H343.214L344.574 61.5083L343.214 63.8344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.499 58.7872H335.797L335.446 58.1728L335.797 57.5583H336.499L336.85 58.1728L336.499 58.7872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.857 72.2172H266.935L266.496 71.4272L266.935 70.6372H267.857L268.339 71.4272L267.857 72.2172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.204 77.3522H260.132L258.64 74.7189L260.132 72.0856H263.204L264.741 74.7189L263.204 77.3522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.499 80.6878H254.427L252.891 78.0106L254.427 75.3772H257.499L258.991 78.0106L257.499 80.6878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.749 83.9794H248.677L247.185 81.3461L248.677 78.7128H251.749L253.286 81.3461L251.749 83.9794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 87.2711H242.972L241.436 84.6378L242.972 82.0044H246L247.536 84.6378L246 87.2711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.294 90.6067H237.222L235.73 87.9733L237.222 85.2961H240.294L241.831 87.9733L240.294 90.6067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.545 93.8983H231.517L229.981 91.265L231.517 88.6317H234.545L236.081 91.265L234.545 93.8983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.839 97.2339H225.767L224.275 94.5567L225.767 91.9233H228.839L230.376 94.5567L228.839 97.2339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09 100.526H220.062L218.526 97.8922L220.062 95.215H223.09L224.626 97.8922L223.09 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.384 103.817H214.312L212.776 101.184L214.312 98.5506H217.384L218.921 101.184L217.384 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.064 106.143H209.177L208.212 104.476L209.177 102.852H211.064L212.03 104.476L211.064 106.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.584 118.344H186.838L186.487 117.73L186.838 117.116H187.584L187.935 117.73L187.584 118.344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 123.655H179.947L178.411 121.022L179.947 118.388H183.019L184.556 121.022L183.019 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.348 125.323H175.163L174.593 124.313L175.163 123.348H176.348L176.919 124.313L176.348 125.323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 130.282H168.492L166.956 127.649L168.492 124.972H171.564L173.101 127.649L171.564 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 133.574H162.787L161.251 130.941L162.787 128.307H165.815L167.351 130.941L165.815 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.627 142.703H157.52L156.423 140.859L157.52 139.016H159.627L160.724 140.859L159.627 142.703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.022 149.988H157.125L155.677 147.487L157.125 144.985H160.022L161.47 147.487L160.022 149.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 156.747H157.037L155.501 154.114L157.037 151.437H160.109L161.646 154.114L160.109 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 163.374H157.037L155.501 160.697L157.037 158.064H160.109L161.646 160.697L160.109 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 169.958H157.037L155.501 167.324L157.037 164.691H160.109L161.646 167.324L160.109 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 176.585H157.037L155.501 173.952L157.037 171.274H160.109L161.646 173.952L160.109 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 183.212H157.037L155.501 180.535L157.037 177.902H160.109L161.646 180.535L160.109 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.066 189.752H157.081L155.589 187.162L157.081 184.617H160.066L161.514 187.162L160.066 189.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.837 194.228H158.31L158.047 193.789L158.31 193.351H158.837L159.1 193.789L158.837 194.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.144 221.22H158.003L157.432 220.254L158.003 219.245H159.144L159.714 220.254L159.144 221.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.968 227.584H158.134L157.739 226.838L158.134 226.136H158.968L159.407 226.838L158.968 227.584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.407 234.957H157.739L156.862 233.465L157.739 232.017H159.407L160.285 233.465L159.407 234.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.022 249.221H157.125L155.677 246.719L157.125 244.174H160.022L161.47 246.719L160.022 249.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 255.98H157.037L155.501 253.303L157.037 250.669H160.109L161.646 253.303L160.109 255.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 262.563H157.037L155.501 259.93L157.037 257.297H160.109L161.646 259.93L160.109 262.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 269.191H157.037L155.501 266.557L157.037 263.88H160.109L161.646 266.557L160.109 269.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 275.818H157.037L155.501 273.141L157.037 270.507H160.109L161.646 273.141L160.109 275.818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 282.401H157.037L155.501 279.768L157.037 277.134H160.109L161.646 279.768L160.109 282.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 289.028H157.037L155.501 286.395L157.037 283.718H160.109L161.646 286.395L160.109 289.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 295.656H157.037L155.501 292.978L157.037 290.345H160.109L161.646 292.978L160.109 295.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 302.239H157.037L155.501 299.606L157.037 296.972H160.109L161.646 299.606L160.109 302.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 308.866H157.037L155.501 306.233L157.037 303.599H160.109L161.646 306.233L160.109 308.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.552 324.929H163.05L161.821 322.779L163.05 320.628H165.552L166.781 322.779L165.552 324.929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 328.704H168.492L166.956 326.071L168.492 323.437H171.564L173.101 326.071L171.564 328.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 332.039H174.242L172.706 329.362L174.242 326.729H177.27L178.806 329.362L177.27 332.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 335.331H179.947L178.411 332.698L179.947 330.021H183.019L184.556 332.698L183.019 335.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 338.623H185.697L184.161 335.989L185.697 333.356H188.725L190.261 335.989L188.725 338.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.474 341.958H191.402L189.866 339.281L191.402 336.648H194.474L196.011 339.281L194.474 341.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18 345.206H197.152L195.659 342.617L197.152 339.983H200.18L201.672 342.617L200.18 345.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.881 238.995H472.335L471.062 236.757L472.335 234.562H474.881L476.153 236.757L474.881 238.995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 232.807H472.116L470.579 230.173L472.116 227.496H475.144L476.68 230.173L475.144 232.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 226.179H472.116L470.579 223.546L472.116 220.913H475.144L476.68 223.546L475.144 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 219.596H472.116L470.579 216.919L472.116 214.286H475.144L476.68 216.919L475.144 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 212.969H472.116L470.579 210.336L472.116 207.658H475.144L476.68 210.336L475.144 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 206.342H472.116L470.579 203.708L472.116 201.075H475.144L476.68 203.708L475.144 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 199.714H472.116L470.579 197.081L472.116 194.448H475.144L476.68 197.081L475.144 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 193.131H472.116L470.579 190.498L472.116 187.821H475.144L476.68 190.498L475.144 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 186.504H472.116L470.579 183.871L472.116 181.237H475.144L476.68 183.871L475.144 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 179.877H472.116L470.579 177.243L472.116 174.61H475.144L476.68 177.243L475.144 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 173.293H472.116L470.579 170.616L472.116 167.983H475.144L476.68 170.616L475.144 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 166.666H472.116L470.579 164.033L472.116 161.356H475.144L476.68 164.033L475.144 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 160.039H472.116L470.579 157.406L472.116 154.772H475.144L476.68 157.406L475.144 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 153.456H472.116L470.579 150.778L472.116 148.145H475.144L476.68 150.778L475.144 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 146.828H472.116L470.579 144.195L472.116 141.518H475.144L476.68 144.195L475.144 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 140.201H472.116L470.579 137.568L472.116 134.934H475.144L476.68 137.568L475.144 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 133.574H472.116L470.579 130.941L472.116 128.307H475.144L476.68 130.941L475.144 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 130.282H466.366L464.83 127.649L466.366 124.972H469.438L470.931 127.649L469.438 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 126.991H460.661L459.124 124.313L460.661 121.68H463.689L465.225 124.313L463.689 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 123.655H454.911L453.375 121.022L454.911 118.388H457.983L459.476 121.022L457.983 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 120.363H449.162L447.669 117.73L449.162 115.053H452.234L453.77 117.73L452.234 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 117.072H443.456L441.92 114.394L443.456 111.761H446.528L448.021 114.394L446.528 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 113.736H437.707L436.214 111.103L437.707 108.469H440.779L442.315 111.103L440.779 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 110.444H432.001L430.465 107.811L432.001 105.134H435.073L436.566 107.811L435.073 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 107.153H426.252L424.759 104.476L426.252 101.842H429.324L430.86 104.476L429.324 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.531 103.686H420.634L419.186 101.184L420.634 98.6822H423.531L424.935 101.184L423.531 103.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.825 100.438H414.884L413.392 97.8922L414.884 95.3467H417.825L419.273 97.8922L417.825 100.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.988 96.9706H409.223L407.862 94.5567L409.223 92.1867H411.988L413.392 94.5567L411.988 96.9706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.739 86.8761H392.15L390.833 84.6378L392.15 82.3994H394.739L396.012 84.6378L394.739 86.8761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.937 81.785H387.454L387.191 81.3461L387.454 80.9072H387.937L388.2 81.3461L387.937 81.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.572 64.01H271.675L270.227 61.5083L271.675 58.9628H274.572L276.064 61.5083L274.572 64.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.822 67.3017H265.969L264.521 64.8L265.969 62.2983H268.822L270.271 64.8L268.822 67.3017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.204 70.7689H260.132L258.64 68.0917L260.132 65.4583H263.204L264.741 68.0917L263.204 70.7689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.499 74.0606H254.427L252.891 71.4272L254.427 68.75H257.499L258.991 71.4272L257.499 74.0606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.749 77.3522H248.677L247.185 74.7189L248.677 72.0856H251.749L253.286 74.7189L251.749 77.3522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 80.6878H242.972L241.436 78.0106L242.972 75.3772H246L247.536 78.0106L246 80.6878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.294 83.9794H237.222L235.73 81.3461L237.222 78.7128H240.294L241.831 81.3461L240.294 83.9794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.545 87.2711H231.517L229.981 84.6378L231.517 82.0044H234.545L236.081 84.6378L234.545 87.2711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.839 90.6067H225.767L224.275 87.9733L225.767 85.2961H228.839L230.376 87.9733L228.839 90.6067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09 93.8983H220.062L218.526 91.265L220.062 88.6317H223.09L224.626 91.265L223.09 93.8983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.384 97.2339H214.312L212.776 94.5567L214.312 91.9233H217.384L218.921 94.5567L217.384 97.2339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.503 100.262H208.738L207.378 97.8922L208.738 95.4783H211.503L212.864 97.8922L211.503 100.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.816 109.259H192.061L191.227 107.811L192.061 106.319H193.816L194.65 107.811L193.816 109.259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 113.736H185.697L184.161 111.103L185.697 108.469H188.725L190.261 111.103L188.725 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 117.072H179.947L178.411 114.394L179.947 111.761H183.019L184.556 114.394L183.019 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 120.363H174.242L172.706 117.73L174.242 115.097H177.27L178.806 117.73L177.27 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 126.947H162.787L161.294 124.313L162.787 121.724H165.815L167.307 124.313L165.815 126.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.833 145.907H151.858L150.849 144.195L151.858 142.439H153.833L154.843 144.195L153.833 145.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.316 153.324H151.376L149.927 150.778L151.376 148.277H154.316L155.764 150.778L154.316 153.324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36 160.039H151.332L149.796 157.406L151.332 154.772H154.36L155.896 157.406L154.36 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36 166.666H151.332L149.796 164.033L151.332 161.356H154.36L155.896 164.033L154.36 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36 173.293H151.332L149.796 170.616L151.332 167.983H154.36L155.896 170.616L154.36 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36 179.877H151.332L149.796 177.243L151.332 174.61H154.36L155.896 177.243L154.36 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36 186.504H151.332L149.796 183.871L151.332 181.237H154.36L155.896 183.871L154.36 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36 193.131H151.332L149.796 190.498L151.332 187.821H154.36L155.896 190.498L154.36 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.097 199.232H151.595L150.366 197.081L151.595 194.931H154.097L155.326 197.081L154.097 199.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.482 224.643H152.209L151.595 223.546L152.209 222.449H153.482L154.097 223.546L153.482 224.643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.394 231.095H152.297L151.771 230.173L152.297 229.208H153.394L153.921 230.173L153.394 231.095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.053 252.118H151.639L150.41 250.011L151.639 247.904H154.053L155.282 250.011L154.053 252.118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36 259.272H151.332L149.796 256.638L151.332 253.961H154.36L155.896 256.638L154.36 259.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36 265.899H151.332L149.796 263.222L151.332 260.588H154.36L155.896 263.222L154.36 265.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36 272.482H151.332L149.796 269.849L151.332 267.216H154.36L155.896 269.849L154.36 272.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36 279.109H151.332L149.796 276.476L151.332 273.799H154.36L155.896 276.476L154.36 279.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36 285.737H151.332L149.796 283.059L151.332 280.426H154.36L155.896 283.059L154.36 285.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36 292.32H151.332L149.796 289.687L151.332 287.053H154.36L155.896 289.687L154.36 292.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36 298.903H151.332L149.839 296.314L151.332 293.681H154.36L155.852 296.314L154.36 298.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.746 304.477H151.946L151.024 302.941L151.946 301.361H153.746L154.623 302.941L153.746 304.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.42 331.337H163.138L162.041 329.362L163.138 327.387H165.42L166.561 329.362L165.42 331.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 335.331H168.492L166.956 332.698L168.492 330.021H171.564L173.101 332.698L171.564 335.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 338.623H174.242L172.706 335.989L174.242 333.356H177.27L178.806 335.989L177.27 338.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 341.958H179.947L178.411 339.281L179.947 336.648H183.019L184.556 339.281L183.019 341.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 345.25H185.697L184.161 342.617L185.697 339.983H188.725L190.261 342.617L188.725 345.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.474 348.542H191.402L189.91 345.908L191.402 343.275H194.474L195.967 345.908L194.474 348.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.454 268.444H478.26L477.163 266.557L478.26 264.67H480.454L481.552 266.557L480.454 268.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.279 261.51H478.436L477.514 259.93L478.436 258.35H480.279L481.157 259.93L480.279 261.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.63 242.287H478.084L476.812 240.092L478.084 237.854H480.63L481.903 240.092L480.63 242.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 236.098H477.821L476.285 233.465L477.821 230.832H480.893L482.386 233.465L480.893 236.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 229.515H477.821L476.285 226.838L477.821 224.204H480.893L482.386 226.838L480.893 229.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 222.888H477.821L476.285 220.254L477.821 217.577H480.893L482.386 220.254L480.893 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 216.261H477.821L476.285 213.627L477.821 210.994H480.893L482.386 213.627L480.893 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 209.677H477.821L476.285 207L477.821 204.367H480.893L482.386 207L480.893 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 203.05H477.821L476.285 200.417L477.821 197.739H480.893L482.386 200.417L480.893 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 196.423H477.821L476.285 193.789L477.821 191.156H480.893L482.386 193.789L480.893 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 189.796H477.821L476.285 187.162L477.821 184.529H480.893L482.386 187.162L480.893 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 183.212H477.821L476.285 180.535L477.821 177.902H480.893L482.386 180.535L480.893 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 176.585H477.821L476.285 173.952L477.821 171.274H480.893L482.386 173.952L480.893 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 169.958H477.821L476.285 167.324L477.821 164.691H480.893L482.386 167.324L480.893 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 163.374H477.821L476.285 160.697L477.821 158.064H480.893L482.386 160.697L480.893 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 156.747H477.821L476.285 154.114L477.821 151.437H480.893L482.386 154.114L480.893 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 150.12H477.821L476.285 147.487L477.821 144.853H480.893L482.386 147.487L480.893 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 143.493H477.821L476.285 140.859L477.821 138.226H480.893L482.386 140.859L480.893 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 136.909H477.821L476.285 134.232L477.821 131.599H480.893L482.386 134.232L480.893 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 130.282H477.821L476.285 127.649L477.821 124.972H480.893L482.386 127.649L480.893 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 126.991H472.116L470.579 124.313L472.116 121.68H475.144L476.68 124.313L475.144 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 123.655H466.366L464.83 121.022L466.366 118.388H469.438L470.931 121.022L469.438 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 120.363H460.661L459.124 117.73L460.661 115.053H463.689L465.225 117.73L463.689 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 117.072H454.911L453.375 114.394L454.911 111.761H457.983L459.476 114.394L457.983 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 113.736H449.162L447.669 111.103L449.162 108.469H452.234L453.77 111.103L452.234 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 110.444H443.456L441.92 107.811L443.456 105.134H446.528L448.021 107.811L446.528 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 107.153H437.707L436.214 104.476L437.707 101.842H440.779L442.315 104.476L440.779 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.073 103.817H432.001L430.465 101.184L432.001 98.5506H435.073L436.566 101.184L435.073 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.324 100.526H426.252L424.759 97.8922L426.252 95.215H429.324L430.86 97.8922L429.324 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.916 96.005H421.248L420.414 94.5567L421.248 93.1522H422.916L423.706 94.5567L422.916 96.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.728 91.8794H415.982L415.631 91.265L415.982 90.6067H416.728L417.079 91.265L416.728 91.8794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.226 83.1456H398.119L397.066 81.3461L398.119 79.5028H400.226L401.235 81.3461L400.226 83.1456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.427 59.9722H266.408L265.355 58.1728L266.408 56.4172H268.427L269.437 58.1728L268.427 59.9722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.204 64.1417H260.132L258.64 61.5083L260.132 58.8311H263.204L264.741 61.5083L263.204 64.1417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.499 67.4333H254.427L252.891 64.8L254.427 62.1667H257.499L258.991 64.8L257.499 67.4333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.749 70.7689H248.677L247.185 68.0917L248.677 65.4583H251.749L253.286 68.0917L251.749 70.7689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 74.0606H242.972L241.436 71.4272L242.972 68.75H246L247.536 71.4272L246 74.0606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.294 77.3522H237.222L235.73 74.7189L237.222 72.0856H240.294L241.831 74.7189L240.294 77.3522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.545 80.6878H231.517L229.981 78.0106L231.517 75.3772H234.545L236.081 78.0106L234.545 80.6878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.839 83.9794H225.767L224.275 81.3461L225.767 78.7128H228.839L230.376 81.3461L228.839 83.9794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09 87.2711H220.062L218.526 84.6378L220.062 82.0044H223.09L224.626 84.6378L223.09 87.2711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.384 90.6067H214.312L212.776 87.9733L214.312 85.2961H217.384L218.921 87.9733L217.384 90.6067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.635 93.8544H208.607L207.114 91.265L208.607 88.6317H211.635L213.127 91.265L211.635 93.8544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.744 95.1272H204.042L203.735 94.5567L204.042 93.9861H204.744L205.052 94.5567L204.744 95.1272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.154 106.099H186.267L185.346 104.476L186.267 102.852H188.154L189.076 104.476L188.154 106.099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 110.444H179.947L178.411 107.811L179.947 105.134H183.019L184.556 107.811L183.019 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 113.736H174.242L172.706 111.103L174.242 108.469H177.27L178.806 111.103L177.27 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.521 117.028H168.492L167 114.394L168.492 111.805H171.521L173.057 114.394L171.521 117.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.63 118.301H163.972L163.621 117.73L163.972 117.116H164.63L164.981 117.73L164.63 118.301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.276 122.251H157.871L157.169 121.022L157.871 119.793H159.276L159.978 121.022L159.276 122.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.557 141.649H146.636L146.197 140.859L146.636 140.069H147.557L148.04 140.859L147.557 141.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.654 150.12H145.582L144.046 147.487L145.582 144.853H148.654L150.147 147.487L148.654 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.654 156.747H145.582L144.046 154.114L145.582 151.437H148.654L150.147 154.114L148.654 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.654 163.374H145.582L144.046 160.697L145.582 158.064H148.654L150.147 160.697L148.654 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.654 169.958H145.582L144.046 167.324L145.582 164.691H148.654L150.147 167.324L148.654 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.654 176.585H145.582L144.046 173.952L145.582 171.274H148.654L150.147 173.952L148.654 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.654 183.212H145.582L144.046 180.535L145.582 177.902H148.654L150.147 180.535L148.654 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.654 189.796H145.582L144.046 187.162L145.582 184.529H148.654L150.147 187.162L148.654 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.654 196.423H145.582L144.046 193.789L145.582 191.156H148.654L150.147 193.789L148.654 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.611 202.962H145.626L144.134 200.417L145.626 197.827H148.611L150.103 200.417L148.611 202.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.601 207.878H146.636L146.109 207L146.636 206.166H147.601L148.084 207L147.601 207.878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.391 215.866H145.846L144.529 213.627L145.846 211.389H148.391L149.664 213.627L148.391 215.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.513 227.54H146.723L146.284 226.838L146.723 226.136H147.513L147.908 226.838L147.513 227.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.567 255.848H145.67L144.222 253.303L145.67 250.801H148.567L150.015 253.303L148.567 255.848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.557 260.676H146.679L146.241 259.93L146.679 259.184H147.557L147.996 259.93L147.557 260.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.04 268.137H146.197L145.275 266.557L146.197 264.933H148.04L148.962 266.557L148.04 268.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.654 275.818H145.582L144.046 273.141L145.582 270.507H148.654L150.147 273.141L148.654 275.818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.611 282.401H145.582L144.09 279.768L145.582 277.134H148.611L150.147 279.768L148.611 282.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.733 287.404H146.504L145.933 286.395L146.504 285.342H147.733L148.303 286.395L147.733 287.404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.435 295.304H145.758L144.441 292.978L145.758 290.696H148.435L149.796 292.978L148.435 295.304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.157 337.482H163.445L162.567 335.989L163.445 334.497H165.157L166.034 335.989L165.157 337.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 341.958H168.492L166.956 339.281L168.492 336.648H171.564L173.101 339.281L171.564 341.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 345.25H174.242L172.706 342.617L174.242 339.983H177.27L178.806 342.617L177.27 345.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 348.542H179.947L178.411 345.908L179.947 343.275H183.019L184.556 345.908L183.019 348.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 351.877H185.697L184.161 349.2L185.697 346.567H188.725L190.261 349.2L188.725 351.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.728 353.896H192.148L191.358 352.536L192.148 351.175H193.728L194.518 352.536L193.728 353.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.072 278.188H484.097L483.088 276.476L484.097 274.721H486.072L487.082 276.476L486.072 278.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.511 272.351H483.658L482.21 269.849L483.658 267.347H486.511L487.959 269.849L486.511 272.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.546 264.056H484.624L484.141 263.222L484.624 262.432H485.546L486.028 263.222L485.546 264.056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.555 259.14H483.614L482.166 256.638L483.614 254.093H486.555L488.003 256.638L486.555 259.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.546 250.801H484.624L484.141 250.011L484.624 249.221H485.546L485.984 250.011L485.546 250.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.511 245.886H483.614L482.21 243.384L483.614 240.882H486.511L487.959 243.384L486.511 245.886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 239.434H483.571L482.034 236.757L483.571 234.123H486.599L488.135 236.757L486.599 239.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 232.807H483.571L482.034 230.173L483.571 227.496H486.599L488.135 230.173L486.599 232.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 226.179H483.571L482.034 223.546L483.571 220.913H486.599L488.135 223.546L486.599 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 219.596H483.571L482.034 216.919L483.571 214.286H486.599L488.135 216.919L486.599 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 212.969H483.571L482.034 210.336L483.571 207.658H486.599L488.135 210.336L486.599 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 206.342H483.571L482.034 203.708L483.571 201.075H486.599L488.135 203.708L486.599 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 199.714H483.571L482.034 197.081L483.571 194.448H486.599L488.135 197.081L486.599 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 193.131H483.571L482.034 190.498L483.571 187.821H486.599L488.135 190.498L486.599 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 186.504H483.571L482.034 183.871L483.571 181.237H486.599L488.135 183.871L486.599 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 179.877H483.571L482.034 177.243L483.571 174.61H486.599L488.135 177.243L486.599 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 173.293H483.571L482.034 170.616L483.571 167.983H486.599L488.135 170.616L486.599 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 166.666H483.571L482.034 164.033L483.571 161.356H486.599L488.135 164.033L486.599 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 160.039H483.571L482.034 157.406L483.571 154.772H486.599L488.135 157.406L486.599 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 153.456H483.571L482.034 150.778L483.571 148.145H486.599L488.135 150.778L486.599 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 146.828H483.571L482.034 144.195L483.571 141.518H486.599L488.135 144.195L486.599 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 140.201H483.571L482.034 137.568L483.571 134.934H486.599L488.135 137.568L486.599 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 133.574H483.571L482.034 130.941L483.571 128.307H486.599L488.135 130.941L486.599 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 126.991H483.571L482.034 124.313L483.571 121.68H486.599L488.135 124.313L486.599 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 123.655H477.821L476.285 121.022L477.821 118.388H480.893L482.386 121.022L480.893 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 120.363H472.116L470.579 117.73L472.116 115.053H475.144L476.68 117.73L475.144 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 117.072H466.366L464.83 114.394L466.366 111.761H469.438L470.931 114.394L469.438 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 113.736H460.661L459.124 111.103L460.661 108.469H463.689L465.225 111.103L463.689 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 110.444H454.911L453.375 107.811L454.911 105.134H457.983L459.476 107.811L457.983 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 107.153H449.162L447.669 104.476L449.162 101.842H452.234L453.77 104.476L452.234 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 103.817H443.456L441.92 101.184L443.456 98.5506H446.528L448.021 101.184L446.528 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 100.526H437.707L436.214 97.8922L437.707 95.215H440.779L442.315 97.8922L440.779 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.986 97.1461H432.045L430.553 94.5567L432.045 92.0111H434.986L436.478 94.5567L434.986 97.1461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.534 92.4939H427.086L426.339 91.265L427.086 90.0361H428.534L429.236 91.265L428.534 92.4939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.238 80.3367H403.561L402.201 78.0106L403.561 75.7283H406.238L407.555 78.0106L406.238 80.3367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.427 53.3889H266.364L265.311 51.5894L266.364 49.7461H268.427L269.481 51.5894L268.427 53.3889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.073 57.295H260.308L258.903 54.8811L260.308 52.4672H263.073L264.433 54.8811L263.073 57.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.621 59.3578H255.261L254.602 58.1728L255.261 56.9878H256.621L257.323 58.1728L256.621 59.3578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.749 64.1417H248.677L247.185 61.5083L248.677 58.8311H251.749L253.286 61.5083L251.749 64.1417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 67.4333H242.972L241.436 64.8L242.972 62.1667H246L247.536 64.8L246 67.4333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.294 70.7689H237.222L235.73 68.0917L237.222 65.4583H240.294L241.831 68.0917L240.294 70.7689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.545 74.0606H231.517L229.981 71.4272L231.517 68.75H234.545L236.081 71.4272L234.545 74.0606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.839 77.3522H225.767L224.275 74.7189L225.767 72.0856H228.839L230.376 74.7189L228.839 77.3522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09 80.6878H220.062L218.526 78.0106L220.062 75.3772H223.09L224.626 78.0106L223.09 80.6878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.384 83.9794H214.312L212.776 81.3461L214.312 78.7128H217.384L218.921 81.3461L217.384 83.9794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.635 87.2711H208.607L207.071 84.6378L208.607 82.0044H211.635L213.171 84.6378L211.635 87.2711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.964 88.9389H203.823L203.252 87.9733L203.823 86.9639H204.964L205.534 87.9733L204.964 88.9389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 103.817H179.947L178.411 101.184L179.947 98.5506H183.019L184.556 101.184L183.019 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.182 106.977H174.329L172.881 104.476L174.329 101.974H177.182L178.631 104.476L177.182 106.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.009 119.749H151.683L150.498 117.73L151.683 115.711H154.009L155.194 117.73L154.009 119.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.027 125.454H140.754L140.096 124.313L140.754 123.216H142.027L142.686 124.313L142.027 125.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.852 138.358H140.93L140.447 137.568L140.93 136.734H141.852L142.334 137.568L141.852 138.358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.905 146.828H139.877L138.341 144.195L139.877 141.518H142.905L144.441 144.195L142.905 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.905 153.456H139.877L138.341 150.778L139.877 148.145H142.905L144.441 150.778L142.905 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.905 160.039H139.877L138.341 157.406L139.877 154.772H142.905L144.441 157.406L142.905 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.905 166.666H139.877L138.341 164.033L139.877 161.356H142.905L144.441 164.033L142.905 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.905 173.293H139.877L138.341 170.616L139.877 167.983H142.905L144.441 170.616L142.905 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.905 179.877H139.877L138.341 177.243L139.877 174.61H142.905L144.441 177.243L142.905 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.905 186.504H139.877L138.341 183.871L139.877 181.237H142.905L144.441 183.871L142.905 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.905 193.131H139.877L138.341 190.498L139.877 187.821H142.905L144.441 190.498L142.905 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.905 199.714H139.877L138.341 197.081L139.877 194.448H142.905L144.441 197.081L142.905 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.905 206.342H139.877L138.341 203.708L139.877 201.075H142.905L144.441 203.708L142.905 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.939 211.301H140.798L140.228 210.336L140.798 209.326H141.939L142.554 210.336L141.939 211.301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.729 225.872H140.052L138.736 223.546L140.052 221.264H142.729L144.046 223.546L142.729 225.872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.72 243.998H141.018L140.667 243.384L141.018 242.769H141.72L142.071 243.384L141.72 243.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.852 250.801H140.93L140.447 250.011L140.93 249.177H141.852L142.334 250.011L141.852 250.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.027 257.692H140.754L140.14 256.638L140.754 255.541H142.027L142.642 256.638L142.027 257.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.639 344.943H162.918L161.558 342.617L162.918 340.247H165.639L167 342.617L165.639 344.943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 348.542H168.492L166.956 345.908L168.492 343.275H171.564L173.101 345.908L171.564 348.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 351.877H174.242L172.706 349.2L174.242 346.567H177.27L178.806 349.2L177.27 351.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 355.169H179.947L178.411 352.536L179.947 349.902H183.019L184.556 352.536L183.019 355.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 358.461H185.697L184.161 355.827L185.697 353.194H188.725L190.261 355.827L188.725 358.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.261 282.269H489.364L487.916 279.768L489.364 277.266H492.261L493.665 279.768L492.261 282.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.217 275.598H489.408L488.003 273.141L489.408 270.727H492.217L493.621 273.141L492.217 275.598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.471 267.654H490.154L489.496 266.557L490.154 265.416H491.471L492.129 266.557L491.471 267.654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.558 261.247H490.066L489.32 259.93L490.066 258.613H491.558L492.304 259.93L491.558 261.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 249.353H489.276L487.74 246.719L489.276 244.042H492.348L493.884 246.719L492.348 249.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 242.726H489.276L487.74 240.092L489.276 237.459H492.348L493.884 240.092L492.348 242.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 236.098H489.276L487.74 233.465L489.276 230.832H492.348L493.884 233.465L492.348 236.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 229.515H489.276L487.74 226.838L489.276 224.204H492.348L493.884 226.838L492.348 229.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 222.888H489.276L487.74 220.254L489.276 217.577H492.348L493.884 220.254L492.348 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 216.261H489.276L487.74 213.627L489.276 210.994H492.348L493.884 213.627L492.348 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 209.677H489.276L487.74 207L489.276 204.367H492.348L493.884 207L492.348 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 203.05H489.276L487.74 200.417L489.276 197.739H492.348L493.884 200.417L492.348 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 196.423H489.276L487.74 193.789L489.276 191.156H492.348L493.884 193.789L492.348 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 189.796H489.276L487.74 187.162L489.276 184.529H492.348L493.884 187.162L492.348 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 183.212H489.276L487.74 180.535L489.276 177.902H492.348L493.884 180.535L492.348 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 176.585H489.276L487.74 173.952L489.276 171.274H492.348L493.884 173.952L492.348 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 169.958H489.276L487.74 167.324L489.276 164.691H492.348L493.884 167.324L492.348 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 163.374H489.276L487.74 160.697L489.276 158.064H492.348L493.884 160.697L492.348 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 156.747H489.276L487.74 154.114L489.276 151.437H492.348L493.884 154.114L492.348 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 150.12H489.276L487.74 147.487L489.276 144.853H492.348L493.884 147.487L492.348 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 143.493H489.276L487.74 140.859L489.276 138.226H492.348L493.884 140.859L492.348 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 136.909H489.276L487.74 134.232L489.276 131.599H492.348L493.884 134.232L492.348 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 130.282H489.276L487.74 127.649L489.276 124.972H492.348L493.884 127.649L492.348 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 123.655H489.276L487.74 121.022L489.276 118.388H492.348L493.884 121.022L492.348 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 120.363H483.571L482.034 117.73L483.571 115.053H486.599L488.135 117.73L486.599 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 117.072H477.821L476.285 114.394L477.821 111.761H480.893L482.386 114.394L480.893 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 113.736H472.116L470.579 111.103L472.116 108.469H475.144L476.68 111.103L475.144 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 110.444H466.366L464.83 107.811L466.366 105.134H469.438L470.931 107.811L469.438 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 107.153H460.661L459.124 104.476L460.661 101.842H463.689L465.225 104.476L463.689 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 103.817H454.911L453.375 101.184L454.911 98.5506H457.983L459.476 101.184L457.983 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 100.526H449.162L447.669 97.8922L449.162 95.215H452.234L453.77 97.8922L452.234 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 97.2339H443.456L441.92 94.5567L443.456 91.9233H446.528L448.021 94.5567L446.528 97.2339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.779 93.8983H437.707L436.214 91.265L437.707 88.6317H440.779L442.315 91.265L440.779 93.8983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.634 89.8606H432.44L431.343 87.9733L432.44 86.0422H434.634L435.732 87.9733L434.634 89.8606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.993 65.7656H392.852L392.326 64.8L392.852 63.8344H393.993L394.564 64.8L393.993 65.7656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.411 54.135H254.471L252.978 51.5894L254.471 49H257.411L258.903 51.5894L257.411 54.135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.662 57.3828H248.765L247.317 54.8811L248.765 52.3794H251.662L253.11 54.8811L251.662 57.3828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 60.85H242.972L241.436 58.1728L242.972 55.5394H246L247.536 58.1728L246 60.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.294 64.1417H237.222L235.73 61.5083L237.222 58.8311H240.294L241.831 61.5083L240.294 64.1417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.545 67.4333H231.517L229.981 64.8L231.517 62.1667H234.545L236.081 64.8L234.545 67.4333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.839 70.7689H225.767L224.275 68.0917L225.767 65.4583H228.839L230.376 68.0917L228.839 70.7689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09 74.0606H220.062L218.526 71.4272L220.062 68.75H223.09L224.626 71.4272L223.09 74.0606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.384 77.3522H214.312L212.776 74.7189L214.312 72.0856H217.384L218.921 74.7189L217.384 77.3522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.635 80.6878H208.607L207.071 78.0106L208.607 75.3772H211.635L213.171 78.0106L211.635 80.6878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.886 83.8917H202.901L201.453 81.3461L202.901 78.7567H205.886L207.334 81.3461L205.886 83.8917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.361 96.0928H180.606L179.684 94.5567L180.606 93.0206H182.361L183.283 94.5567L182.361 96.0928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 100.526H174.242L172.706 97.8922L174.242 95.215H177.27L178.806 97.8922L177.27 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.169 103.159H168.887L167.746 101.184L168.887 99.2089H171.169L172.311 101.184L171.169 103.159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 110.444H157.037L155.501 107.811L157.037 105.134H160.109L161.646 107.811L160.109 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.316 113.604H151.376L149.927 111.103L151.376 108.601H154.316L155.764 111.103L154.316 113.604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.654 117.072H145.582L144.046 114.394L145.582 111.761H148.654L150.147 114.394L148.654 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.905 120.363H139.877L138.341 117.73L139.877 115.053H142.905L144.441 117.73L142.905 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 123.655H134.127L132.591 121.022L134.127 118.388H137.199L138.692 121.022L137.199 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.112 130.194H134.171L132.723 127.649L134.171 125.103H137.112L138.604 127.649L137.112 130.194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.024 136.602H134.303L132.942 134.232L134.303 131.906H137.024L138.341 134.232L137.024 136.602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 143.493H134.127L132.591 140.859L134.127 138.226H137.199L138.692 140.859L137.199 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 150.12H134.127L132.591 147.487L134.127 144.853H137.199L138.692 147.487L137.199 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 156.747H134.127L132.591 154.114L134.127 151.437H137.199L138.692 154.114L137.199 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 163.374H134.127L132.591 160.697L134.127 158.064H137.199L138.692 160.697L137.199 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 169.958H134.127L132.591 167.324L134.127 164.691H137.199L138.692 167.324L137.199 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 176.585H134.127L132.591 173.952L134.127 171.274H137.199L138.692 173.952L137.199 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 183.212H134.127L132.591 180.535L134.127 177.902H137.199L138.692 180.535L137.199 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 189.796H134.127L132.591 187.162L134.127 184.529H137.199L138.692 187.162L137.199 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 196.423H134.127L132.591 193.789L134.127 191.156H137.199L138.692 193.789L137.199 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 203.05H134.127L132.591 200.417L134.127 197.739H137.199L138.692 200.417L137.199 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.112 209.546H134.171L132.723 207L134.171 204.454H137.112L138.604 207L137.112 209.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 242.726H134.127L132.591 240.092L134.127 237.459H137.199L138.692 240.092L137.199 242.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 249.353H134.127L132.591 246.719L134.127 244.042H137.199L138.692 246.719L137.199 249.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.883 253.742H135.4L135.181 253.303L135.4 252.908H135.883L136.146 253.303L135.883 253.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 351.877H162.787L161.251 349.2L162.787 346.567H165.815L167.351 349.2L165.815 351.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 355.169H168.492L166.956 352.536L168.492 349.902H171.564L173.101 352.536L171.564 355.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 358.461H174.242L172.706 355.827L174.242 353.194H177.27L178.806 355.827L177.27 358.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 361.752H179.947L178.455 359.163L179.947 356.529H183.019L184.512 359.163L183.019 361.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.308 284.376H495.772L495.026 283.059L495.772 281.787H497.308L498.054 283.059L497.308 284.376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.966 252.425H495.113L493.709 250.011L495.113 247.553H497.966L499.371 250.011L497.966 252.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 246.017H495.026L493.489 243.384L495.026 240.751H498.054L499.59 243.384L498.054 246.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 239.434H495.026L493.489 236.757L495.026 234.123H498.054L499.59 236.757L498.054 239.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.132 231.183H495.947L495.377 230.173L495.947 229.164H497.132L497.703 230.173L497.132 231.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 226.179H495.026L493.489 223.546L495.026 220.913H498.054L499.59 223.546L498.054 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 219.596H495.026L493.489 216.919L495.026 214.286H498.054L499.59 216.919L498.054 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 212.969H495.026L493.489 210.336L495.026 207.658H498.054L499.59 210.336L498.054 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 206.342H495.026L493.489 203.708L495.026 201.075H498.054L499.59 203.708L498.054 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 199.714H495.026L493.489 197.081L495.026 194.448H498.054L499.59 197.081L498.054 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 193.131H495.026L493.489 190.498L495.026 187.821H498.054L499.59 190.498L498.054 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 186.504H495.026L493.489 183.871L495.026 181.237H498.054L499.59 183.871L498.054 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 179.877H495.026L493.489 177.243L495.026 174.61H498.054L499.59 177.243L498.054 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 173.293H495.026L493.489 170.616L495.026 167.983H498.054L499.59 170.616L498.054 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 166.666H495.026L493.489 164.033L495.026 161.356H498.054L499.59 164.033L498.054 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 160.039H495.026L493.489 157.406L495.026 154.772H498.054L499.59 157.406L498.054 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 153.456H495.026L493.489 150.778L495.026 148.145H498.054L499.59 150.778L498.054 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 146.828H495.026L493.489 144.195L495.026 141.518H498.054L499.59 144.195L498.054 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 140.201H495.026L493.489 137.568L495.026 134.934H498.054L499.59 137.568L498.054 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 133.574H495.026L493.489 130.941L495.026 128.307H498.054L499.59 130.941L498.054 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 126.991H495.026L493.489 124.313L495.026 121.68H498.054L499.59 124.313L498.054 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 120.363H495.026L493.489 117.73L495.026 115.053H498.054L499.59 117.73L498.054 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 117.072H489.276L487.74 114.394L489.276 111.761H492.348L493.884 114.394L492.348 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 113.736H483.571L482.034 111.103L483.571 108.469H486.599L488.135 111.103L486.599 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 110.444H477.821L476.285 107.811L477.821 105.134H480.893L482.386 107.811L480.893 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 107.153H472.116L470.579 104.476L472.116 101.842H475.144L476.68 104.476L475.144 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 103.817H466.366L464.83 101.184L466.366 98.5506H469.438L470.931 101.184L469.438 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 100.526H460.661L459.124 97.8922L460.661 95.215H463.689L465.225 97.8922L463.689 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 97.2339H454.911L453.375 94.5567L454.911 91.9233H457.983L459.476 94.5567L457.983 97.2339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 93.8983H449.162L447.669 91.265L449.162 88.6317H452.234L453.77 91.265L452.234 93.8983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.528 90.6067H443.456L441.92 87.9733L443.456 85.2961H446.528L448.021 87.9733L446.528 90.6067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.735 87.2272H437.751L436.302 84.6378L437.751 82.0922H440.735L442.227 84.6378L440.735 87.2272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 54.135H243.016L241.523 51.5894L243.016 49H246L247.448 51.5894L246 54.135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.294 57.5144H237.222L235.73 54.8811L237.222 52.2478H240.294L241.831 54.8811L240.294 57.5144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.545 60.85H231.517L229.981 58.1728L231.517 55.5394H234.545L236.081 58.1728L234.545 60.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.839 64.1417H225.767L224.275 61.5083L225.767 58.8311H228.839L230.376 61.5083L228.839 64.1417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.09 67.4333H220.062L218.526 64.8L220.062 62.1667H223.09L224.626 64.8L223.09 67.4333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.384 70.7689H214.312L212.776 68.0917L214.312 65.4583H217.384L218.921 68.0917L217.384 70.7689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.635 74.0606H208.607L207.071 71.4272L208.607 68.75H211.635L213.171 71.4272L211.635 74.0606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.929 77.3522H202.857L201.321 74.7189L202.857 72.0856H205.929L207.466 74.7189L205.929 77.3522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18 80.6878H197.152L195.616 78.0106L197.152 75.3772H200.18L201.716 78.0106L200.18 80.6878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.509 82.3556H192.368L191.797 81.3461L192.368 80.3367H193.509L194.079 81.3461L193.509 82.3556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.041 91.7478H175.471L175.163 91.265L175.471 90.7383H176.041L176.348 91.265L176.041 91.7478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 97.2339H168.492L166.956 94.5567L168.492 91.9233H171.564L173.101 94.5567L171.564 97.2339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 100.526H162.787L161.251 97.8922L162.787 95.215H165.815L167.351 97.8922L165.815 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.758 103.247H157.388L156.159 101.184L157.388 99.1211H159.758L160.987 101.184L159.758 103.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.702 106.012H151.946L151.068 104.476L151.946 102.983H153.702L154.623 104.476L153.702 106.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.654 110.444H145.582L144.046 107.811L145.582 105.134H148.654L150.147 107.811L148.654 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.905 113.736H139.877L138.341 111.103L139.877 108.469H142.905L144.441 111.103L142.905 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 117.072H134.127L132.591 114.394L134.127 111.761H137.199L138.692 114.394L137.199 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 120.363H128.422L126.886 117.73L128.422 115.053H131.45L132.986 117.73L131.45 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 126.991H128.422L126.886 124.313L128.422 121.68H131.45L132.986 124.313L131.45 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 133.574H128.422L126.886 130.941L128.422 128.307H131.45L132.986 130.941L131.45 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 140.201H128.422L126.886 137.568L128.422 134.934H131.45L132.986 137.568L131.45 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 146.828H128.422L126.886 144.195L128.422 141.518H131.45L132.986 144.195L131.45 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 153.456H128.422L126.886 150.778L128.422 148.145H131.45L132.986 150.778L131.45 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 160.039H128.422L126.886 157.406L128.422 154.772H131.45L132.986 157.406L131.45 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 166.666H128.422L126.886 164.033L128.422 161.356H131.45L132.986 164.033L131.45 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 173.293H128.422L126.886 170.616L128.422 167.983H131.45L132.986 170.616L131.45 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 179.877H128.422L126.886 177.243L128.422 174.61H131.45L132.986 177.243L131.45 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 186.504H128.422L126.886 183.871L128.422 181.237H131.45L132.986 183.871L131.45 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 193.131H128.422L126.886 190.498L128.422 187.821H131.45L132.986 190.498L131.45 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 199.714H128.422L126.886 197.081L128.422 194.448H131.45L132.986 197.081L131.45 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 206.342H128.422L126.886 203.708L128.422 201.075H131.45L132.986 203.708L131.45 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.967 212.091H128.904L127.851 210.336L128.904 208.536H130.967L131.977 210.336L130.967 212.091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 232.807H128.422L126.886 230.173L128.422 227.496H131.45L132.986 230.173L131.45 232.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.318 239.171H128.553L127.149 236.757L128.553 234.387H131.318L132.679 236.757L131.318 239.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 246.017H128.422L126.886 243.384L128.422 240.751H131.45L132.986 243.384L131.45 246.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.771 358.373H162.831L161.382 355.827L162.831 353.282H165.771L167.219 355.827L165.771 358.373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 361.796H168.492L166.956 359.163L168.492 356.486H171.564L173.101 359.163L171.564 361.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 365.088H174.242L172.706 362.454L174.242 359.821H177.27L178.806 362.454L177.27 365.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.922 366.492H181.044L180.606 365.746L181.044 365H181.922L182.361 365.746L181.922 366.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.716 288.941H500.819L499.327 286.395L500.819 283.849H503.716L505.208 286.395L503.716 288.941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.321 278.984H497.214L496.161 277.141L497.214 275.341H499.321L500.374 277.141L499.321 278.984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.574 247.29H501.916L501.609 246.719L501.916 246.149H502.574L502.926 246.719L502.574 247.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.794 241.014H501.741L501.17 240.092L501.741 239.127H502.794L503.364 240.092L502.794 241.014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.408 235.44H501.126L499.985 233.465L501.126 231.49H503.408L504.549 233.465L503.408 235.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.716 229.383H500.819L499.371 226.838L500.819 224.336H503.716L505.164 226.838L503.716 229.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 222.888H500.731L499.195 220.254L500.731 217.577H503.803L505.339 220.254L503.803 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 216.261H500.731L499.195 213.627L500.731 210.994H503.803L505.339 213.627L503.803 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 209.677H500.731L499.195 207L500.731 204.367H503.803L505.339 207L503.803 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 203.05H500.731L499.195 200.417L500.731 197.739H503.803L505.339 200.417L503.803 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 196.423H500.731L499.195 193.789L500.731 191.156H503.803L505.339 193.789L503.803 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 189.796H500.731L499.195 187.162L500.731 184.529H503.803L505.339 187.162L503.803 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 183.212H500.731L499.195 180.535L500.731 177.902H503.803L505.339 180.535L503.803 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 176.585H500.731L499.195 173.952L500.731 171.274H503.803L505.339 173.952L503.803 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 169.958H500.731L499.195 167.324L500.731 164.691H503.803L505.339 167.324L503.803 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 163.374H500.731L499.195 160.697L500.731 158.064H503.803L505.339 160.697L503.803 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 156.747H500.731L499.195 154.114L500.731 151.437H503.803L505.339 154.114L503.803 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 150.12H500.731L499.195 147.487L500.731 144.853H503.803L505.339 147.487L503.803 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 143.493H500.731L499.195 140.859L500.731 138.226H503.803L505.339 140.859L503.803 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 136.909H500.731L499.195 134.232L500.731 131.599H503.803L505.339 134.232L503.803 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 130.282H500.731L499.195 127.649L500.731 124.972H503.803L505.339 127.649L503.803 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 123.655H500.731L499.195 121.022L500.731 118.388H503.803L505.339 121.022L503.803 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 117.072H500.731L499.195 114.394L500.731 111.761H503.803L505.339 114.394L503.803 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 113.736H495.026L493.489 111.103L495.026 108.469H498.054L499.59 111.103L498.054 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 110.444H489.276L487.74 107.811L489.276 105.134H492.348L493.884 107.811L492.348 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 107.153H483.571L482.034 104.476L483.571 101.842H486.599L488.135 104.476L486.599 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 103.817H477.821L476.285 101.184L477.821 98.5506H480.893L482.386 101.184L480.893 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 100.526H472.116L470.579 97.8922L472.116 95.215H475.144L476.68 97.8922L475.144 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 97.2339H466.366L464.83 94.5567L466.366 91.9233H469.438L470.931 94.5567L469.438 97.2339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 93.8983H460.661L459.124 91.265L460.661 88.6317H463.689L465.225 91.265L463.689 93.8983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.983 90.6067H454.911L453.375 87.9733L454.911 85.2961H457.983L459.476 87.9733L457.983 90.6067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.234 87.2711H449.162L447.669 84.6378L449.162 82.0044H452.234L453.77 84.6378L452.234 87.2711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.782 82.7067H444.158L443.368 81.3461L444.158 79.9417H445.782L446.572 81.3461L445.782 82.7067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.282 53.6961H231.824L230.595 51.5894L231.824 49.4389H234.282L235.511 51.5894L234.282 53.6961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.532 56.9878H226.118L224.889 54.8811L226.118 52.7744H228.532L229.717 54.8811L228.532 56.9878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.739 60.2356H220.413L219.228 58.1728L220.413 56.1539H222.739L223.924 58.1728L222.739 60.2356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.384 64.1417H214.312L212.776 61.5083L214.312 58.8311H217.384L218.921 61.5083L217.384 64.1417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.635 67.4333H208.607L207.071 64.8L208.607 62.1667H211.635L213.171 64.8L211.635 67.4333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.929 70.7689H202.857L201.321 68.0917L202.857 65.4583H205.929L207.466 68.0917L205.929 70.7689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18 74.0606H197.152L195.616 71.4272L197.152 68.75H200.18L201.716 71.4272L200.18 74.0606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.641 75.9478H192.236L191.534 74.7189L192.236 73.5339H193.641L194.343 74.7189L193.641 75.9478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.637 80.5122H185.784L184.336 78.0106L185.784 75.5528H188.637L190.086 78.0106L188.637 80.5122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.771 93.8106H162.831L161.382 91.265L162.831 88.7194H165.771L167.219 91.265L165.771 93.8106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 97.2339H157.037L155.501 94.5567L157.037 91.9233H160.109L161.646 94.5567L160.109 97.2339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36 100.526H151.332L149.796 97.8922L151.332 95.215H154.36L155.896 97.8922L154.36 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.654 103.817H145.582L144.09 101.184L145.582 98.5506H148.654L150.147 101.184L148.654 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.773 106.846H140.008L138.648 104.476L140.008 102.106H142.773L144.134 104.476L142.773 106.846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 110.444H134.127L132.591 107.811L134.127 105.134H137.199L138.692 107.811L137.199 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 113.736H128.422L126.886 111.103L128.422 108.469H131.45L132.986 111.103L131.45 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.744 117.072H122.672L121.136 114.394L122.672 111.761H125.744L127.237 114.394L125.744 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.744 123.655H122.672L121.136 121.022L122.672 118.388H125.744L127.237 121.022L125.744 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.744 130.282H122.672L121.136 127.649L122.672 124.972H125.744L127.237 127.649L125.744 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.744 136.909H122.672L121.136 134.232L122.672 131.599H125.744L127.237 134.232L125.744 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.744 143.493H122.672L121.136 140.859L122.672 138.226H125.744L127.237 140.859L125.744 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.744 150.12H122.672L121.136 147.487L122.672 144.853H125.744L127.237 147.487L125.744 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.744 156.747H122.672L121.136 154.114L122.672 151.437H125.744L127.237 154.114L125.744 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.744 163.374H122.672L121.136 160.697L122.672 158.064H125.744L127.237 160.697L125.744 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.744 169.958H122.672L121.136 167.324L122.672 164.691H125.744L127.237 167.324L125.744 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.744 176.585H122.672L121.136 173.952L122.672 171.274H125.744L127.237 173.952L125.744 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.744 183.212H122.672L121.136 180.535L122.672 177.902H125.744L127.237 180.535L125.744 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.744 189.796H122.672L121.136 187.162L122.672 184.529H125.744L127.237 187.162L125.744 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.744 196.423H122.672L121.136 193.789L122.672 191.156H125.744L127.237 193.789L125.744 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.744 203.05H122.672L121.136 200.417L122.672 197.739H125.744L127.237 200.417L125.744 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.657 209.546H122.716L121.268 207L122.716 204.454H125.657L127.149 207L125.657 209.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.603 227.54H123.813L123.418 226.838L123.813 226.179H124.603L124.998 226.838L124.603 227.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.701 236.098H122.672L121.18 233.465L122.672 230.832H125.701L127.237 233.465L125.701 236.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.701 242.726H122.672L121.136 240.092L122.672 237.459H125.701L127.237 240.092L125.701 242.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.683 364.868H162.918L161.514 362.454L162.918 360.041H165.683L167.044 362.454L165.683 364.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 368.423H168.492L166.956 365.746L168.492 363.113H171.564L173.101 365.746L171.564 368.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 371.715H174.242L172.706 369.082L174.242 366.404H177.27L178.806 369.082L177.27 371.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.421 338.447H506.568L505.164 335.989L506.568 333.576H509.421L510.826 335.989L509.421 338.447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 331.996H506.481L504.988 329.362L506.481 326.773H509.509L511.001 329.362L509.509 331.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.719 324.008H507.271L506.568 322.779L507.271 321.506H508.719L509.421 322.779L508.719 324.008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.246 291.881H506.744L505.471 289.687L506.744 287.536H509.246L510.518 289.687L509.246 291.881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.509 283.109H502.481L500.944 280.476L502.481 277.799H505.509L507.045 280.476L505.509 283.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 272.482H506.481L504.944 269.849L506.481 267.216H509.509L511.045 269.849L509.509 272.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.368 263.836H507.622L507.271 263.222L507.622 262.607H508.368L508.719 263.222L508.368 263.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 226.179H506.481L504.944 223.546L506.481 220.913H509.509L511.045 223.546L509.509 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 219.596H506.481L504.944 216.919L506.481 214.286H509.509L511.045 216.919L509.509 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 212.969H506.481L504.944 210.336L506.481 207.658H509.509L511.045 210.336L509.509 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 206.342H506.481L504.944 203.708L506.481 201.075H509.509L511.045 203.708L509.509 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 199.714H506.481L504.944 197.081L506.481 194.448H509.509L511.045 197.081L509.509 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 193.131H506.481L504.944 190.498L506.481 187.821H509.509L511.045 190.498L509.509 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 186.504H506.481L504.944 183.871L506.481 181.237H509.509L511.045 183.871L509.509 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 179.877H506.481L504.944 177.243L506.481 174.61H509.509L511.045 177.243L509.509 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 173.293H506.481L504.944 170.616L506.481 167.983H509.509L511.045 170.616L509.509 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 166.666H506.481L504.944 164.033L506.481 161.356H509.509L511.045 164.033L509.509 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 160.039H506.481L504.944 157.406L506.481 154.772H509.509L511.045 157.406L509.509 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 153.456H506.481L504.944 150.778L506.481 148.145H509.509L511.045 150.778L509.509 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 146.828H506.481L504.944 144.195L506.481 141.518H509.509L511.045 144.195L509.509 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 140.201H506.481L504.944 137.568L506.481 134.934H509.509L511.045 137.568L509.509 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 133.574H506.481L504.944 130.941L506.481 128.307H509.509L511.045 130.941L509.509 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 126.991H506.481L504.944 124.313L506.481 121.68H509.509L511.045 124.313L509.509 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 120.363H506.481L504.944 117.73L506.481 115.053H509.509L511.045 117.73L509.509 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 113.736H506.481L504.944 111.103L506.481 108.469H509.509L511.045 111.103L509.509 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 110.444H500.731L499.195 107.811L500.731 105.134H503.803L505.339 107.811L503.803 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 107.153H495.026L493.489 104.476L495.026 101.842H498.054L499.59 104.476L498.054 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 103.817H489.276L487.74 101.184L489.276 98.5506H492.348L493.884 101.184L492.348 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 100.526H483.571L482.034 97.8922L483.571 95.215H486.599L488.135 97.8922L486.599 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.893 97.2339H477.821L476.285 94.5567L477.821 91.9233H480.893L482.386 94.5567L480.893 97.2339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 93.8983H472.116L470.579 91.265L472.116 88.6317H475.144L476.68 91.265L475.144 93.8983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 90.6067H466.366L464.83 87.9733L466.366 85.2961H469.438L470.931 87.9733L469.438 90.6067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 87.2711H460.661L459.124 84.6378L460.661 82.0044H463.689L465.225 84.6378L463.689 87.2711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.939 83.9356H454.911L453.419 81.3461L454.911 78.7128H457.939L459.476 81.3461L457.939 83.9356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.137 78.7567H450.259L449.864 78.0106L450.259 77.2644H451.137L451.576 78.0106L451.137 78.7567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.24 60.1039H209.046L207.948 58.1728L209.046 56.2856H211.24L212.337 58.1728L211.24 60.1039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.842 64.01H202.945L201.497 61.5083L202.945 59.0067H205.842L207.29 61.5083L205.842 64.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18 67.4333H197.152L195.616 64.8L197.152 62.1667H200.18L201.716 64.8L200.18 67.4333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.421 68.9694H192.456L191.973 68.0917L192.456 67.2578H193.421L193.904 68.0917L193.421 68.9694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.286 73.3144H186.136L185.038 71.4272L186.136 69.54H188.286L189.383 71.4272L188.286 73.3144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.213 83.365H168.843L167.658 81.3461L168.843 79.2833H171.213L172.354 81.3461L171.213 83.365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.639 86.92H162.962L161.646 84.6378L162.962 82.3556H165.639L166.956 84.6378L165.639 86.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.495 89.5972H157.608L156.686 87.9733L157.608 86.3056H159.495L160.461 87.9733L159.495 89.5972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.316 93.8106H151.376L149.883 91.265L151.376 88.7194H154.316L155.808 91.265L154.316 93.8106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.861 100.438H139.921L138.428 97.8922L139.921 95.3467H142.861L144.309 97.8922L142.861 100.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.397 105.266H129.475L129.036 104.476L129.475 103.729H130.397L130.836 104.476L130.397 105.266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.744 110.444H122.672L121.136 107.811L122.672 105.134H125.744L127.237 107.811L125.744 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 113.736H116.923L115.431 111.103L116.923 108.469H119.995L121.531 111.103L119.995 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 120.363H116.923L115.431 117.73L116.923 115.053H119.995L121.531 117.73L119.995 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 126.991H116.923L115.431 124.313L116.923 121.68H119.995L121.531 124.313L119.995 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 133.574H116.923L115.431 130.941L116.923 128.307H119.995L121.531 130.941L119.995 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 140.201H116.923L115.431 137.568L116.923 134.934H119.995L121.531 137.568L119.995 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 146.828H116.923L115.431 144.195L116.923 141.518H119.995L121.531 144.195L119.995 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 153.456H116.923L115.431 150.778L116.923 148.145H119.995L121.531 150.778L119.995 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 160.039H116.923L115.431 157.406L116.923 154.772H119.995L121.531 157.406L119.995 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 166.666H116.923L115.431 164.033L116.923 161.356H119.995L121.531 164.033L119.995 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 173.293H116.923L115.431 170.616L116.923 167.983H119.995L121.531 170.616L119.995 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 179.877H116.923L115.431 177.243L116.923 174.61H119.995L121.531 177.243L119.995 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 186.504H116.923L115.431 183.871L116.923 181.237H119.995L121.531 183.871L119.995 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 193.131H116.923L115.431 190.498L116.923 187.821H119.995L121.531 190.498L119.995 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 199.714H116.923L115.431 197.081L116.923 194.448H119.995L121.531 197.081L119.995 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 206.342H116.923L115.431 203.708L116.923 201.075H119.995L121.531 203.708L119.995 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.6 212.311H117.318L116.177 210.336L117.318 208.317H119.6L120.741 210.336L119.6 212.311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.854 230.832H118.108L117.713 230.173L118.108 229.515H118.854L119.205 230.173L118.854 230.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 239.39H116.967L115.431 236.757L116.967 234.167H119.995L121.487 236.757L119.995 239.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 371.715H162.787L161.251 369.082L162.787 366.404H165.815L167.351 369.082L165.815 371.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 375.007H168.492L166.956 372.373L168.492 369.74H171.564L173.101 372.373L171.564 375.007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 378.298H174.242L172.706 375.665L174.242 373.032H177.27L178.806 375.665L177.27 378.298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.763 343.933H507.227L506.437 342.617L507.227 341.256H508.763L509.553 342.617L508.763 343.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 341.958H512.186L510.65 339.281L512.186 336.648H515.258L516.794 339.281L515.258 341.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 335.331H512.186L510.65 332.698L512.186 330.021H515.258L516.794 332.698L515.258 335.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 328.704H512.186L510.65 326.071L512.186 323.437H515.258L516.794 326.071L515.258 328.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.819 321.374H512.625L511.528 319.443L512.625 317.556H514.819L515.917 319.443L514.819 321.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.171 286.269H508.274L506.826 283.768L508.274 281.266H511.171L512.619 283.768L511.171 286.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.258 279.818H508.186L506.65 277.141L508.186 274.507H511.258L512.794 277.141L511.258 279.818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 269.191H512.186L510.65 266.557L512.186 263.88H515.258L516.794 266.557L515.258 269.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.995 262.124H512.449L511.221 259.93L512.449 257.736H514.995L516.224 259.93L514.995 262.124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.127 222.624H512.318L510.957 220.254L512.318 217.841H515.127L516.487 220.254L515.127 222.624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 216.261H512.186L510.65 213.627L512.186 210.994H515.258L516.794 213.627L515.258 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 209.677H512.186L510.65 207L512.186 204.367H515.258L516.794 207L515.258 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 203.05H512.186L510.65 200.417L512.186 197.739H515.258L516.794 200.417L515.258 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 196.423H512.186L510.65 193.789L512.186 191.156H515.258L516.794 193.789L515.258 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.556 188.611H512.888L512.054 187.162L512.888 185.758H514.556L515.39 187.162L514.556 188.611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 183.212H512.186L510.65 180.535L512.186 177.902H515.258L516.794 180.535L515.258 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 176.585H512.186L510.65 173.952L512.186 171.274H515.258L516.794 173.952L515.258 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 169.958H512.186L510.65 167.324L512.186 164.691H515.258L516.794 167.324L515.258 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 163.374H512.186L510.65 160.697L512.186 158.064H515.258L516.794 160.697L515.258 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 156.747H512.186L510.65 154.114L512.186 151.437H515.258L516.794 154.114L515.258 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 150.12H512.186L510.65 147.487L512.186 144.853H515.258L516.794 147.487L515.258 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 143.493H512.186L510.65 140.859L512.186 138.226H515.258L516.794 140.859L515.258 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 136.909H512.186L510.65 134.232L512.186 131.599H515.258L516.794 134.232L515.258 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 130.282H512.186L510.65 127.649L512.186 124.972H515.258L516.794 127.649L515.258 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 123.655H512.186L510.65 121.022L512.186 118.388H515.258L516.794 121.022L515.258 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 117.072H512.186L510.65 114.394L512.186 111.761H515.258L516.794 114.394L515.258 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 110.444H512.186L510.65 107.811L512.186 105.134H515.258L516.794 107.811L515.258 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 107.153H506.481L504.944 104.476L506.481 101.842H509.509L511.045 104.476L509.509 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 103.817H500.731L499.195 101.184L500.731 98.5506H503.803L505.339 101.184L503.803 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 100.526H495.026L493.489 97.8922L495.026 95.215H498.054L499.59 97.8922L498.054 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.348 97.2339H489.276L487.74 94.5567L489.276 91.9233H492.348L493.884 94.5567L492.348 97.2339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.599 93.8983H483.571L482.034 91.265L483.571 88.6317H486.599L488.135 91.265L486.599 93.8983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.849 90.5628H477.865L476.373 87.9733L477.865 85.34H480.849L482.342 87.9733L480.849 90.5628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 87.2711H472.116L470.623 84.6378L472.116 82.0483H475.144L476.636 84.6378L475.144 87.2711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.438 83.9794H466.366L464.83 81.3461L466.366 78.7128H469.438L470.931 81.3461L469.438 83.9794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.689 80.6878H460.661L459.124 78.0106L460.661 75.3772H463.689L465.225 78.0106L463.689 80.6878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.089 70.0228H443.851L442.754 68.0917L443.851 66.1606H446.089L447.231 68.0917L446.089 70.0228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.989 66.0289H438.541L437.794 64.8L438.541 63.5711H439.989L440.691 64.8L439.989 66.0289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.741 60.0161H197.634L196.537 58.1728L197.634 56.3733H199.741L200.794 58.1728L199.741 60.0161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.772 62.9567H192.104L191.271 61.5083L192.104 60.0161H193.772L194.65 61.5083L193.772 62.9567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.549 67.1261H185.872L184.512 64.8L185.872 62.4739H188.549L189.91 64.8L188.549 67.1261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.405 69.6717H180.562L179.684 68.0917L180.562 66.5556H182.405L183.283 68.0917L182.405 69.6717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.226 73.9289H174.286L172.837 71.4272L174.286 68.8817H177.226L178.674 71.4272L177.226 73.9289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 77.3522H168.492L166.956 74.7189L168.492 72.0856H171.564L173.101 74.7189L171.564 77.3522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 80.6878H162.787L161.251 78.0106L162.787 75.3772H165.815L167.351 78.0106L165.815 80.6878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.232 82.4433H157.915L157.301 81.3461L157.915 80.2489H159.232L159.846 81.3461L159.232 82.4433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.57 85.9106H152.078L151.376 84.6378L152.078 83.365H153.57L154.316 84.6378L153.57 85.9106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.366 95.8294H134.917L134.215 94.5567L134.917 93.3278H136.366L137.112 94.5567L136.366 95.8294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.836 99.4722H128.992L128.071 97.8922L128.992 96.2683H130.836L131.757 97.8922L130.836 99.4722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.13 102.808H123.243L122.321 101.184L123.243 99.56H125.13L126.096 101.184L125.13 102.808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.898 105.222H118.02L117.625 104.476L118.02 103.729H118.898L119.337 104.476L118.898 105.222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 110.444H111.217L109.681 107.811L111.217 105.134H114.289L115.782 107.811L114.289 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 117.072H111.217L109.681 114.394L111.217 111.761H114.289L115.782 114.394L114.289 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 123.655H111.217L109.681 121.022L111.217 118.388H114.289L115.782 121.022L114.289 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 130.282H111.217L109.681 127.649L111.217 124.972H114.289L115.782 127.649L114.289 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 136.909H111.217L109.681 134.232L111.217 131.599H114.289L115.782 134.232L114.289 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 143.493H111.217L109.681 140.859L111.217 138.226H114.289L115.782 140.859L114.289 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 150.12H111.217L109.681 147.487L111.217 144.853H114.289L115.782 147.487L114.289 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 156.747H111.217L109.681 154.114L111.217 151.437H114.289L115.782 154.114L114.289 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 163.374H111.217L109.681 160.697L111.217 158.064H114.289L115.782 160.697L114.289 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 169.958H111.217L109.681 167.324L111.217 164.691H114.289L115.782 167.324L114.289 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 176.585H111.217L109.681 173.952L111.217 171.274H114.289L115.782 173.952L114.289 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 183.212H111.217L109.681 180.535L111.217 177.902H114.289L115.782 180.535L114.289 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 189.796H111.217L109.681 187.162L111.217 184.529H114.289L115.782 187.162L114.289 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 196.423H111.217L109.681 193.789L111.217 191.156H114.289L115.782 193.789L114.289 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 203.05H111.217L109.681 200.417L111.217 197.739H114.289L115.782 200.417L114.289 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 209.677H111.217L109.681 207L111.217 204.367H114.289L115.782 207L114.289 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 216.261H111.217L109.681 213.627L111.217 210.994H114.289L115.782 213.627L114.289 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 222.888H111.217L109.681 220.254L111.217 217.577H114.289L115.782 220.254L114.289 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 229.515H111.217L109.681 226.838L111.217 224.204H114.289L115.782 226.838L114.289 229.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 236.098H111.217L109.681 233.465L111.217 230.832H114.289L115.782 233.465L114.289 236.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.061 240.663H112.402L112.095 240.092L112.402 239.522H113.061L113.412 240.092L113.061 240.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 378.298H162.787L161.251 375.665L162.787 373.032H165.815L167.351 375.665L165.815 378.298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 381.634H168.492L166.956 379.001L168.492 376.323H171.564L173.101 379.001L171.564 381.634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 384.882H174.242L172.749 382.292L174.242 379.703H177.27L178.762 382.292L177.27 384.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.499 350.078H507.49L507.007 349.2L507.49 348.366H508.499L508.982 349.2L508.499 350.078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 348.542H512.186L510.65 345.908L512.186 343.275H515.258L516.794 345.908L515.258 348.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.964 345.25H517.936L516.399 342.617L517.936 339.983H520.964L522.5 342.617L520.964 345.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.964 338.623H517.936L516.399 335.989L517.936 333.356H520.964L522.5 335.989L520.964 338.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.964 332.039H517.936L516.399 329.362L517.936 326.729H520.964L522.5 329.362L520.964 332.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.964 325.412H517.936L516.399 322.779L517.936 320.102H520.964L522.5 322.779L520.964 325.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.92 318.697H517.979L516.531 316.152L517.979 313.606H520.92L522.368 316.152L520.92 318.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.735 310.007H519.164L518.901 309.524L519.164 309.086H519.735L519.998 309.524L519.735 310.007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.393 278.1H518.506L517.584 276.476L518.506 274.852H520.393L521.315 276.476L520.393 278.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.954 270.683H518.945L518.462 269.849L518.945 269.015H519.954L520.437 269.849L519.954 270.683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.393 264.846H518.506L517.584 263.222L518.506 261.598H520.393L521.315 263.222L520.393 264.846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.218 224.863H518.682L517.936 223.546L518.682 222.229H520.218L520.964 223.546L520.218 224.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.911 217.753H518.989L518.506 216.919L518.989 216.129H519.911L520.393 216.919L519.911 217.753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.832 212.706H518.067L516.663 210.336L518.067 207.922H520.832L522.237 210.336L520.832 212.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.92 206.254H517.979L516.487 203.708L517.979 201.163H520.92L522.412 203.708L520.92 206.254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.691 197.52H519.208L518.945 197.081L519.208 196.642H519.691L519.954 197.081L519.691 197.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.086 191.551H518.813L518.199 190.498L518.813 189.401H520.086L520.701 190.498L520.086 191.551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.788 186.197H518.111L516.794 183.871L518.111 181.544H520.788L522.105 183.871L520.788 186.197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.964 179.877H517.936L516.399 177.243L517.936 174.61H520.964L522.5 177.243L520.964 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.964 173.293H517.936L516.399 170.616L517.936 167.983H520.964L522.5 170.616L520.964 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.964 166.666H517.936L516.399 164.033L517.936 161.356H520.964L522.5 164.033L520.964 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.964 160.039H517.936L516.399 157.406L517.936 154.772H520.964L522.5 157.406L520.964 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.964 153.456H517.936L516.399 150.778L517.936 148.145H520.964L522.5 150.778L520.964 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.964 146.828H517.936L516.399 144.195L517.936 141.518H520.964L522.5 144.195L520.964 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.964 140.201H517.936L516.399 137.568L517.936 134.934H520.964L522.5 137.568L520.964 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.964 133.574H517.936L516.399 130.941L517.936 128.307H520.964L522.5 130.941L520.964 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.964 126.991H517.936L516.399 124.313L517.936 121.68H520.964L522.5 124.313L520.964 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.964 120.363H517.936L516.399 117.73L517.936 115.053H520.964L522.5 117.73L520.964 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.964 113.736H517.936L516.399 111.103L517.936 108.469H520.964L522.5 111.103L520.964 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.964 107.153H517.936L516.399 104.476L517.936 101.842H520.964L522.5 104.476L520.964 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 103.817H512.186L510.65 101.184L512.186 98.5506H515.258L516.794 101.184L515.258 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.509 100.526H506.481L504.944 97.8922L506.481 95.215H509.509L511.045 97.8922L509.509 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.803 97.2339H500.731L499.195 94.5567L500.731 91.9233H503.803L505.339 94.5567L503.803 97.2339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.054 93.8983H495.026L493.489 91.265L495.026 88.6317H498.054L499.546 91.265L498.054 93.8983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.471 89.1145H490.11L489.452 87.9733L490.11 86.7883H491.471L492.173 87.9733L491.471 89.1145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.059 82.5311H478.655L477.953 81.3461L478.655 80.1172H480.059L480.762 81.3461L480.059 82.5311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.144 80.6439H472.116L470.579 78.0106L472.116 75.4211H475.144L476.636 78.0106L475.144 80.6439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.444 66.0289H449.996L449.293 64.8L449.996 63.5711H451.444L452.146 64.8L451.444 66.0289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.992 56.7244H191.885L190.788 54.8811L191.885 53.0378H193.992L195.089 54.8811L193.992 56.7244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 60.85H185.697L184.161 58.1728L185.697 55.5394H188.725L190.261 58.1728L188.725 60.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.019 64.1417H179.947L178.411 61.5083L179.947 58.8311H183.019L184.556 61.5083L183.019 64.1417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 67.4333H174.242L172.706 64.8L174.242 62.1667H177.27L178.806 64.8L177.27 67.4333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 70.7689H168.492L166.956 68.0917L168.492 65.4583H171.564L173.101 68.0917L171.564 70.7689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 74.0606H162.787L161.251 71.4272L162.787 68.75H165.815L167.351 71.4272L165.815 74.0606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.89 77.0011H157.257L155.94 74.7189L157.257 72.4367H159.89L161.207 74.7189L159.89 77.0011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.053 80.1611H151.639L150.41 78.0105L151.639 75.9039H154.053L155.282 78.0105L154.053 80.1611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.513 82.0044H146.723L146.328 81.3461L146.723 80.6878H147.513L147.864 81.3461L147.513 82.0044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.199 90.6067H134.127L132.591 87.9733L134.127 85.2961H137.199L138.692 87.9733L137.199 90.6067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.441 92.0989H129.431L128.948 91.265L129.431 90.3872H130.441L130.923 91.265L130.441 92.0989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.744 97.2339H122.672L121.136 94.5567L122.672 91.9233H125.744L127.237 94.5567L125.744 97.2339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 100.526H116.923L115.431 97.8922L116.923 95.215H119.995L121.531 97.8922L119.995 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.07 103.422H111.437L110.12 101.184L111.437 98.9017H114.07L115.343 101.184L114.07 103.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.408 106.889H105.643L104.239 104.476L105.643 102.062H108.408L109.813 104.476L108.408 106.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 113.736H105.468L103.976 111.103L105.468 108.469H108.54L110.076 111.103L108.54 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 120.363H105.468L103.976 117.73L105.468 115.053H108.54L110.076 117.73L108.54 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 126.991H105.468L103.976 124.313L105.468 121.68H108.54L110.076 124.313L108.54 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 133.574H105.468L103.976 130.941L105.468 128.307H108.54L110.076 130.941L108.54 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 140.201H105.468L103.976 137.568L105.468 134.934H108.54L110.076 137.568L108.54 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 146.828H105.468L103.976 144.195L105.468 141.518H108.54L110.076 144.195L108.54 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 153.456H105.468L103.976 150.778L105.468 148.145H108.54L110.076 150.778L108.54 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 160.039H105.468L103.976 157.406L105.468 154.772H108.54L110.076 157.406L108.54 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 166.666H105.468L103.976 164.033L105.468 161.356H108.54L110.076 164.033L108.54 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 173.293H105.468L103.976 170.616L105.468 167.983H108.54L110.076 170.616L108.54 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 179.877H105.468L103.976 177.243L105.468 174.61H108.54L110.076 177.243L108.54 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 186.504H105.468L103.976 183.871L105.468 181.237H108.54L110.076 183.871L108.54 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 193.131H105.468L103.976 190.498L105.468 187.821H108.54L110.076 190.498L108.54 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 199.714H105.468L103.976 197.081L105.468 194.448H108.54L110.076 197.081L108.54 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 206.342H105.468L103.976 203.708L105.468 201.075H108.54L110.076 203.708L108.54 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 212.969H105.468L103.976 210.336L105.468 207.658H108.54L110.076 210.336L108.54 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 219.596H105.468L103.976 216.919L105.468 214.286H108.54L110.076 216.919L108.54 219.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 226.179H105.468L103.976 223.546L105.468 220.913H108.54L110.076 223.546L108.54 226.179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 232.807H105.468L103.976 230.173L105.468 227.496H108.54L110.076 230.173L108.54 232.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.75 238.029H106.302L105.556 236.757L106.302 235.528H107.75L108.452 236.757L107.75 238.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.639 384.574H162.962L161.646 382.292L162.962 380.01H165.639L166.956 382.292L165.639 384.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 388.261H168.492L166.956 385.584L168.492 382.951H171.564L173.101 385.584L171.564 388.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.217 389.666H175.295L174.856 388.919L175.295 388.129H176.217L176.656 388.919L176.217 389.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.923 347.225H524.431L523.641 345.908L524.431 344.592H525.923L526.713 345.908L525.923 347.225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 341.958H523.641L522.105 339.281L523.641 336.648H526.713L528.249 339.281L526.713 341.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 335.331H523.641L522.105 332.698L523.641 330.021H526.713L528.249 332.698L526.713 335.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 328.704H523.641L522.105 326.071L523.641 323.437H526.713L528.249 326.071L526.713 328.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 322.121H523.641L522.105 319.443L523.641 316.81H526.713L528.249 319.443L526.713 322.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 315.493H523.641L522.105 312.86L523.641 310.183H526.713L528.249 312.86L526.713 315.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.792 280.865H524.563L523.948 279.768L524.563 278.671H525.792L526.406 279.768L525.792 280.865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.582 275.642H523.773L522.324 273.141L523.773 270.683H526.582L528.03 273.141L526.582 275.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 236.098H523.641L522.105 233.465L523.641 230.832H526.713L528.249 233.465L526.713 236.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.231 189.006H524.124L523.071 187.162L524.124 185.363H526.231L527.284 187.162L526.231 189.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 183.212H523.641L522.105 180.535L523.641 177.902H526.713L528.249 180.535L526.713 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 176.585H523.641L522.105 173.952L523.641 171.274H526.713L528.249 173.952L526.713 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 169.958H523.641L522.105 167.324L523.641 164.691H526.713L528.249 167.324L526.713 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 163.374H523.641L522.105 160.697L523.641 158.064H526.713L528.249 160.697L526.713 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 156.747H523.641L522.105 154.114L523.641 151.437H526.713L528.249 154.114L526.713 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 150.12H523.641L522.105 147.487L523.641 144.853H526.713L528.249 147.487L526.713 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 143.493H523.641L522.105 140.859L523.641 138.226H526.713L528.249 140.859L526.713 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 136.909H523.641L522.105 134.232L523.641 131.599H526.713L528.249 134.232L526.713 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 130.282H523.641L522.105 127.649L523.641 124.972H526.713L528.249 127.649L526.713 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 123.655H523.641L522.105 121.022L523.641 118.388H526.713L528.249 121.022L526.713 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 117.072H523.641L522.105 114.394L523.641 111.761H526.713L528.249 114.394L526.713 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 110.444H523.641L522.105 107.811L523.641 105.134H526.713L528.249 107.811L526.713 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 103.817H523.641L522.105 101.184L523.641 98.5506H526.713L528.249 101.184L526.713 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.964 100.526H517.936L516.399 97.8922L517.936 95.215H520.964L522.5 97.8922L520.964 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.258 97.2339H512.186L510.65 94.5567L512.186 91.9233H515.258L516.794 94.5567L515.258 97.2339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.851 92.7133H507.139L506.305 91.265L507.139 89.8167H508.851L509.684 91.265L508.851 92.7133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.668 56.9439H180.298L179.069 54.8811L180.298 52.8183H182.668L183.897 54.8811L182.668 56.9439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.27 60.85H174.242L172.706 58.1728L174.242 55.5394H177.27L178.806 58.1728L177.27 60.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 64.1417H168.492L166.956 61.5083L168.492 58.8311H171.564L173.101 61.5083L171.564 64.1417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 67.4333H162.787L161.251 64.8L162.787 62.1667H165.815L167.351 64.8L165.815 67.4333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.495 69.6717H157.652L156.774 68.0917L157.652 66.5556H159.495L160.373 68.0917L159.495 69.6717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.053 73.5339H151.639L150.41 71.4272L151.639 69.3206H154.053L155.282 71.4272L154.053 73.5339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.808 78.7567H140.974L140.579 78.0106L140.974 77.3083H141.808L142.203 78.0106L141.808 78.7567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.936 83.5406H134.391L133.074 81.3461L134.391 79.1078H136.936L138.209 81.3461L136.936 83.5406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.572 85.735H129.299L128.641 84.6378L129.299 83.5406H130.572L131.231 84.6378L130.572 85.735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.481 90.2117H122.892L121.619 87.9733L122.892 85.6911H125.481L126.798 87.9733L125.481 90.2117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.995 93.8983H116.967L115.431 91.265L116.967 88.6317H119.995L121.487 91.265L119.995 93.8983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.289 97.2339H111.217L109.681 94.5567L111.217 91.9233H114.289L115.782 94.5567L114.289 97.2339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.364 100.218H105.643L104.327 97.8922L105.643 95.5222H108.364L109.725 97.8922L108.364 100.218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.649 101.798H100.947L100.596 101.184L100.947 100.569H101.649L102.001 101.184L101.649 101.798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 110.444H99.7622L98.2261 107.811L99.7622 105.134H102.834L104.327 107.811L102.834 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 117.072H99.7622L98.2261 114.394L99.7622 111.761H102.834L104.327 114.394L102.834 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 123.655H99.7622L98.2261 121.022L99.7622 118.388H102.834L104.327 121.022L102.834 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 130.282H99.7622L98.2261 127.649L99.7622 124.972H102.834L104.327 127.649L102.834 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 136.909H99.7622L98.2261 134.232L99.7622 131.599H102.834L104.327 134.232L102.834 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 143.493H99.7622L98.2261 140.859L99.7622 138.226H102.834L104.327 140.859L102.834 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 150.12H99.7622L98.2261 147.487L99.7622 144.853H102.834L104.327 147.487L102.834 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 156.747H99.7622L98.2261 154.114L99.7622 151.437H102.834L104.327 154.114L102.834 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 163.374H99.7622L98.2261 160.697L99.7622 158.064H102.834L104.327 160.697L102.834 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 169.958H99.7622L98.2261 167.324L99.7622 164.691H102.834L104.327 167.324L102.834 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 176.585H99.7622L98.2261 173.952L99.7622 171.274H102.834L104.327 173.952L102.834 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 183.212H99.7622L98.2261 180.535L99.7622 177.902H102.834L104.327 180.535L102.834 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 189.796H99.7622L98.2261 187.162L99.7622 184.529H102.834L104.327 187.162L102.834 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 196.423H99.7622L98.2261 193.789L99.7622 191.156H102.834L104.327 193.789L102.834 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 203.05H99.7622L98.2261 200.417L99.7622 197.739H102.834L104.327 200.417L102.834 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 209.677H99.7622L98.2261 207L99.7622 204.367H102.834L104.327 207L102.834 209.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 216.261H99.7622L98.2261 213.627L99.7622 210.994H102.834L104.327 213.627L102.834 216.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 222.888H99.7622L98.2261 220.254L99.7622 217.577H102.834L104.327 220.254L102.834 222.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.791 229.471H99.7622L98.27 226.838L99.7622 224.248H102.791L104.283 226.838L102.791 229.471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.913 234.562H100.684L100.026 233.465L100.684 232.412H101.913L102.527 233.465L101.913 234.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.113 390.368H163.445L162.611 388.919L163.445 387.471H165.113L165.947 388.919L165.113 390.368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.564 394.844H168.492L166.956 392.211L168.492 389.578H171.564L173.101 392.211L171.564 394.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.182 397.961H174.329L172.925 395.503L174.329 393.045H177.182L178.587 395.503L177.182 397.961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.142 399.979H180.825L180.123 398.838L180.825 397.653H182.142L182.844 398.838L182.142 399.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.068 344.636H529.742L528.557 342.617L529.742 340.598H532.068L533.253 342.617L532.068 344.636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 338.623H529.391L527.854 335.989L529.391 333.356H532.419L533.955 335.989L532.419 338.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 332.039H529.391L527.854 329.362L529.391 326.729H532.419L533.955 329.362L532.419 332.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 325.412H529.391L527.854 322.779L529.391 320.102H532.419L533.955 322.779L532.419 325.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 318.785H529.391L527.854 316.152L529.391 313.518H532.419L533.955 316.152L532.419 318.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 312.202H529.391L527.854 309.524L529.391 306.891H532.419L533.955 309.524L532.419 312.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.024 304.872H529.786L528.644 302.941L529.786 300.966H532.024L533.165 302.941L532.024 304.872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.497 251.021H530.312L529.742 250.011L530.312 249.002H531.497L532.068 250.011L531.497 251.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.366 244.218H530.444L529.961 243.384L530.444 242.55H531.366L531.848 243.384L531.366 244.218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.375 192.999H529.478L527.986 190.498L529.478 187.952H532.375L533.823 190.498L532.375 192.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.024 185.802H529.786L528.644 183.871L529.786 181.896H532.024L533.165 183.871L532.024 185.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 179.877H529.391L527.854 177.243L529.391 174.61H532.419L533.955 177.243L532.419 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 173.293H529.391L527.854 170.616L529.391 167.983H532.419L533.955 170.616L532.419 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 166.666H529.391L527.854 164.033L529.391 161.356H532.419L533.955 164.033L532.419 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 160.039H529.391L527.854 157.406L529.391 154.772H532.419L533.955 157.406L532.419 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 153.456H529.391L527.854 150.778L529.391 148.145H532.419L533.955 150.778L532.419 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 146.828H529.391L527.854 144.195L529.391 141.518H532.419L533.955 144.195L532.419 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 140.201H529.391L527.854 137.568L529.391 134.934H532.419L533.955 137.568L532.419 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 133.574H529.391L527.854 130.941L529.391 128.307H532.419L533.955 130.941L532.419 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 126.991H529.391L527.854 124.313L529.391 121.68H532.419L533.955 124.313L532.419 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 120.363H529.391L527.854 117.73L529.391 115.053H532.419L533.955 117.73L532.419 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 113.736H529.391L527.854 111.103L529.391 108.469H532.419L533.955 111.103L532.419 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 107.153H529.391L527.854 104.476L529.391 101.842H532.419L533.955 104.476L532.419 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 100.526H529.391L527.854 97.8922L529.391 95.215H532.419L533.955 97.8922L532.419 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.713 97.2339H523.641L522.105 94.5567L523.641 91.9233H526.713L528.249 94.5567L526.713 97.2339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.306 92.7133H518.594L517.76 91.265L518.594 89.8167H520.306L521.139 91.265L520.306 92.7133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.95 56.4611H169.107L168.185 54.8811L169.107 53.3011H170.95L171.872 54.8811L170.95 56.4611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.815 60.85H162.787L161.251 58.1728L162.787 55.5394H165.815L167.351 58.1728L165.815 60.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.671 63.3956H157.476L156.335 61.5083L157.476 59.5772H159.671L160.768 61.5083L159.671 63.3956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.36 67.4333H151.332L149.796 64.8L151.332 62.1667H154.36L155.896 64.8L154.36 67.4333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.397 78.8883H129.431L128.948 78.0106L129.431 77.1767H130.397L130.879 78.0106L130.397 78.8883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.657 83.8478H122.76L121.312 81.3461L122.76 78.8444H125.657L127.061 81.3461L125.657 83.8478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.556 86.4811H117.406L116.352 84.6378L117.406 82.7944H119.556L120.609 84.6378L119.556 86.4811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.246 90.6067H111.217L109.681 87.9733L111.217 85.2961H114.246L115.782 87.9733L114.246 90.6067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 93.8983H105.468L103.976 91.265L105.468 88.6317H108.54L110.076 91.265L108.54 93.8983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.649 95.215H100.903L100.508 94.5567L100.903 93.8983H101.649L102.044 94.5567L101.649 95.215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 107.153H94.0128L92.5205 104.476L94.0128 101.842H97.085L98.6211 104.476L97.085 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 113.736H94.0128L92.5205 111.103L94.0128 108.469H97.085L98.6211 111.103L97.085 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 120.363H94.0128L92.5205 117.73L94.0128 115.053H97.085L98.6211 117.73L97.085 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 126.991H94.0128L92.5205 124.313L94.0128 121.68H97.085L98.6211 124.313L97.085 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 133.574H94.0128L92.5205 130.941L94.0128 128.307H97.085L98.6211 130.941L97.085 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 140.201H94.0128L92.5205 137.568L94.0128 134.934H97.085L98.6211 137.568L97.085 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 146.828H94.0128L92.5205 144.195L94.0128 141.518H97.085L98.6211 144.195L97.085 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 153.456H94.0128L92.5205 150.778L94.0128 148.145H97.085L98.6211 150.778L97.085 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 160.039H94.0128L92.5205 157.406L94.0128 154.772H97.085L98.6211 157.406L97.085 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 166.666H94.0128L92.5205 164.033L94.0128 161.356H97.085L98.6211 164.033L97.085 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 173.293H94.0128L92.5205 170.616L94.0128 167.983H97.085L98.6211 170.616L97.085 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 179.877H94.0128L92.5205 177.243L94.0128 174.61H97.085L98.6211 177.243L97.085 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 186.504H94.0128L92.5205 183.871L94.0128 181.237H97.085L98.6211 183.871L97.085 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 193.131H94.0128L92.5205 190.498L94.0128 187.821H97.085L98.6211 190.498L97.085 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 199.714H94.0128L92.5205 197.081L94.0128 194.448H97.085L98.6211 197.081L97.085 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 206.342H94.0128L92.5205 203.708L94.0128 201.075H97.085L98.6211 203.708L97.085 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 212.969H94.0128L92.5205 210.336L94.0128 207.658H97.085L98.6211 210.336L97.085 212.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9972 219.421H94.1444L92.6961 216.919L94.1444 214.461H96.9972L98.4017 216.919L96.9972 219.421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.168 341.958H535.096L533.56 339.281L535.096 336.648H538.168L539.704 339.281L538.168 341.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.168 335.331H535.096L533.56 332.698L535.096 330.021H538.168L539.704 332.698L538.168 335.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.168 328.704H535.096L533.56 326.071L535.096 323.437H538.168L539.704 326.071L538.168 328.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.168 322.121H535.096L533.56 319.443L535.096 316.81H538.168L539.704 319.443L538.168 322.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.168 315.493H535.096L533.56 312.86L535.096 310.183H538.168L539.704 312.86L538.168 315.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.168 308.866H535.096L533.56 306.233L535.096 303.599H538.168L539.704 306.233L538.168 308.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.071 300.396H536.193L535.711 299.606L536.193 298.816H537.071L537.554 299.606L537.071 300.396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.124 249.265H535.14L533.692 246.719L535.14 244.13H538.124L539.573 246.719L538.124 249.265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.773 202.392H535.491L534.35 200.417L535.491 198.398H537.773L538.914 200.417L537.773 202.392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.852 194.184H536.413L536.149 193.789L536.413 193.394H536.852L537.115 193.789L536.852 194.184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.081 176.453H535.184L533.736 173.952L535.184 171.45H538.081L539.529 173.952L538.081 176.453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.168 169.958H535.096L533.56 167.324L535.096 164.691H538.168L539.704 167.324L538.168 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.168 163.374H535.096L533.56 160.697L535.096 158.064H538.168L539.704 160.697L538.168 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.168 156.747H535.096L533.56 154.114L535.096 151.437H538.168L539.704 154.114L538.168 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.124 150.076H535.14L533.648 147.487L535.14 144.897H538.124L539.617 147.487L538.124 150.076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.642 142.615H535.623L534.613 140.859L535.623 139.148H537.642L538.651 140.859L537.642 142.615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.168 136.909H535.096L533.56 134.232L535.096 131.599H538.168L539.704 134.232L538.168 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.168 130.282H535.096L533.56 127.649L535.096 124.972H538.168L539.704 127.649L538.168 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.168 123.655H535.096L533.56 121.022L535.096 118.388H538.168L539.704 121.022L538.168 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.168 117.072H535.096L533.56 114.394L535.096 111.761H538.168L539.704 114.394L538.168 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.168 110.444H535.096L533.56 107.811L535.096 105.134H538.168L539.704 107.811L538.168 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.168 103.817H535.096L533.56 101.184L535.096 98.5506H538.168L539.704 101.184L538.168 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.168 97.2339H535.096L533.56 94.5567L535.096 91.9233H538.168L539.704 94.5567L538.168 97.2339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.419 93.8983H529.391L527.854 91.265L529.391 88.6317H532.419L533.955 91.265L532.419 93.8983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.923 89.2461H524.431L523.685 87.9733L524.431 86.6567H525.923L526.669 87.9733L525.923 89.2461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.837 55.32H158.31L158.047 54.8811L158.31 54.4422H158.837L159.1 54.8811L158.837 55.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.087 58.6556H152.604L152.341 58.1728L152.604 57.7339H153.087L153.351 58.1728L153.087 58.6556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.779 75.7283H123.638L123.023 74.7189L123.638 73.7094H124.779L125.349 74.7189L124.779 75.7283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.854 78.6689H118.108L117.713 78.0106L118.108 77.3961H118.854L119.205 78.0106L118.854 78.6689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.412 82.4872H112.095L111.393 81.3461L112.095 80.205H113.412L114.07 81.3461L113.412 82.4872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.496 87.1833H105.556L104.107 84.6378L105.556 82.0922H108.496L109.944 84.6378L108.496 87.1833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 90.6067H99.7622L98.2261 87.9733L99.7622 85.2961H102.834L104.327 87.9733L102.834 90.6067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.085 93.8983H94.0128L92.5205 91.265L94.0128 88.6317H97.085L98.6211 91.265L97.085 93.8983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7211 102.72H88.9655L88.0439 101.184L88.9655 99.6478H90.7211L91.5989 101.184L90.7211 102.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3795 110.444H88.3072L86.7711 107.811L88.3072 105.134H91.3795L92.8717 107.811L91.3795 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3795 117.072H88.3072L86.7711 114.394L88.3072 111.761H91.3795L92.8717 114.394L91.3795 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3795 123.655H88.3072L86.7711 121.022L88.3072 118.388H91.3795L92.8717 121.022L91.3795 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3795 130.282H88.3072L86.7711 127.649L88.3072 124.972H91.3795L92.8717 127.649L91.3795 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3795 136.909H88.3072L86.7711 134.232L88.3072 131.599H91.3795L92.8717 134.232L91.3795 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3795 143.493H88.3072L86.7711 140.859L88.3072 138.226H91.3795L92.8717 140.859L91.3795 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3795 150.12H88.3072L86.7711 147.487L88.3072 144.853H91.3795L92.8717 147.487L91.3795 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3795 156.747H88.3072L86.7711 154.114L88.3072 151.437H91.3795L92.8717 154.114L91.3795 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3795 163.374H88.3072L86.7711 160.697L88.3072 158.064H91.3795L92.8717 160.697L91.3795 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3795 169.958H88.3072L86.7711 167.324L88.3072 164.691H91.3795L92.8717 167.324L91.3795 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3795 176.585H88.3072L86.7711 173.952L88.3072 171.274H91.3795L92.8717 173.952L91.3795 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3795 183.212H88.3072L86.7711 180.535L88.3072 177.902H91.3795L92.8717 180.535L91.3795 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3795 189.796H88.3072L86.7711 187.162L88.3072 184.529H91.3795L92.8717 187.162L91.3795 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3795 196.423H88.3072L86.7711 193.789L88.3072 191.156H91.3795L92.8717 193.789L91.3795 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3795 203.05H88.3072L86.7711 200.417L88.3072 197.739H91.3795L92.8717 200.417L91.3795 203.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3356 209.589H88.3511L86.8589 207L88.3511 204.411H91.3356L92.8278 207L91.3356 209.589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.16 215.909H88.5267L87.21 213.627L88.5267 211.345H91.16L92.4328 213.627L91.16 215.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9406 222.186H88.7022L87.5611 220.254L88.7022 218.279H90.9406L92.0817 220.254L90.9406 222.186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.952 350.253H541.767L541.197 349.2L541.767 348.191H542.952L543.523 349.2L542.952 350.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.874 345.25H540.846L539.309 342.617L540.846 339.983H543.874L545.41 342.617L543.874 345.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.874 338.623H540.846L539.309 335.989L540.846 333.356H543.874L545.41 335.989L543.874 338.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.874 332.039H540.846L539.309 329.362L540.846 326.729H543.874L545.41 329.362L543.874 332.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.874 325.412H540.846L539.309 322.779L540.846 320.102H543.874L545.41 322.779L543.874 325.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.874 318.785H540.846L539.309 316.152L540.846 313.518H543.874L545.41 316.152L543.874 318.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.874 312.202H540.846L539.309 309.524L540.846 306.891H543.874L545.41 309.524L543.874 312.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.874 305.574H540.846L539.309 302.941L540.846 300.264H543.874L545.41 302.941L543.874 305.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.084 297.543H541.636L540.933 296.314L541.636 295.085H543.084L543.786 296.314L543.084 297.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.216 277.924H541.504L540.67 276.476L541.504 274.984H543.216L544.049 276.476L543.216 277.924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.83 272.351H540.889L539.441 269.849L540.889 267.347H543.83L545.278 269.849L543.83 272.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.786 199.539H540.933L539.529 197.081L540.933 194.623H543.786L545.191 197.081L543.786 199.539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.645 171.143H542.074L541.767 170.616L542.074 170.133H542.645L542.952 170.616L542.645 171.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.874 166.622H540.846L539.353 164.033L540.846 161.399H543.874L545.41 164.033L543.874 166.622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.874 160.039H540.846L539.309 157.406L540.846 154.772H543.874L545.41 157.406L543.874 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.874 153.412H540.846L539.353 150.778L540.846 148.189H543.874L545.366 150.778L543.874 153.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.996 145.292H541.723L541.065 144.195L541.723 143.054H542.996L543.654 144.195L542.996 145.292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.83 133.486H540.889L539.397 130.941L540.889 128.395H543.83L545.322 130.941L543.83 133.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.874 126.991H540.846L539.309 124.313L540.846 121.68H543.874L545.41 124.313L543.874 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.874 120.363H540.846L539.309 117.73L540.846 115.053H543.874L545.41 117.73L543.874 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.874 113.736H540.846L539.309 111.103L540.846 108.469H543.874L545.41 111.103L543.874 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.874 107.153H540.846L539.309 104.476L540.846 101.842H543.874L545.41 104.476L543.874 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.874 100.526H540.846L539.309 97.8922L540.846 95.215H543.874L545.41 97.8922L543.874 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.538 83.6722H523.817L522.456 81.3461L523.817 78.9761H526.538L527.898 81.3461L526.538 83.6722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.657 80.1172H518.243L517.014 78.0106L518.243 75.9478H520.657L521.886 78.0106L520.657 80.1172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.825 82.2678H100.728L100.201 81.3461L100.728 80.3806H101.825L102.396 81.3461L101.825 82.2678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3389 85.9544H94.8028L94.0128 84.6378L94.8028 83.3211H96.3389L97.085 84.6378L96.3389 85.9544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63 107.153H82.5578L81.0656 104.476L82.5578 101.842H85.63L87.1661 104.476L85.63 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63 113.736H82.5578L81.0656 111.103L82.5578 108.469H85.63L87.1661 111.103L85.63 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63 120.363H82.5578L81.0656 117.73L82.5578 115.053H85.63L87.1661 117.73L85.63 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63 126.991H82.5578L81.0656 124.313L82.5578 121.68H85.63L87.1661 124.313L85.63 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63 133.574H82.5578L81.0656 130.941L82.5578 128.307H85.63L87.1661 130.941L85.63 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63 140.201H82.5578L81.0656 137.568L82.5578 134.934H85.63L87.1661 137.568L85.63 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63 146.828H82.5578L81.0656 144.195L82.5578 141.518H85.63L87.1661 144.195L85.63 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63 153.456H82.5578L81.0656 150.778L82.5578 148.145H85.63L87.1661 150.778L85.63 153.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63 160.039H82.5578L81.0656 157.406L82.5578 154.772H85.63L87.1661 157.406L85.63 160.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63 166.666H82.5578L81.0656 164.033L82.5578 161.356H85.63L87.1661 164.033L85.63 166.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63 173.293H82.5578L81.0656 170.616L82.5578 167.983H85.63L87.1661 170.616L85.63 173.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63 179.877H82.5578L81.0656 177.243L82.5578 174.61H85.63L87.1661 177.243L85.63 179.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63 186.504H82.5578L81.0656 183.871L82.5578 181.237H85.63L87.1661 183.871L85.63 186.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63 193.131H82.5578L81.0656 190.498L82.5578 187.821H85.63L87.1661 190.498L85.63 193.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63 199.714H82.5578L81.0656 197.081L82.5578 194.448H85.63L87.1661 197.081L85.63 199.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63 206.342H82.5578L81.0656 203.708L82.5578 201.075H85.63L87.1661 203.708L85.63 206.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5422 212.793H82.6894L81.2411 210.336L82.6894 207.834H85.5422L86.9466 210.336L85.5422 212.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.526 353.282H547.648L547.253 352.536L547.648 351.789H548.526L548.921 352.536L548.526 353.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.623 348.542H546.551L545.015 345.908L546.551 343.275H549.623L551.159 345.908L549.623 348.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.623 341.958H546.551L545.015 339.281L546.551 336.648H549.623L551.159 339.281L549.623 341.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.623 335.331H546.551L545.015 332.698L546.551 330.021H549.623L551.159 332.698L549.623 335.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.623 328.704H546.551L545.015 326.071L546.551 323.437H549.623L551.159 326.071L549.623 328.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.623 322.121H546.551L545.015 319.443L546.551 316.81H549.623L551.159 319.443L549.623 322.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.623 315.493H546.551L545.015 312.86L546.551 310.183H549.623L551.159 312.86L549.623 315.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.623 308.866H546.551L545.015 306.233L546.551 303.599H549.623L551.159 306.233L549.623 308.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.623 302.239H546.551L545.015 299.606L546.551 296.972H549.623L551.159 299.606L549.623 302.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.623 196.423H546.551L545.015 193.789L546.551 191.156H549.623L551.159 193.789L549.623 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.877 175.312H547.297L546.507 173.952L547.297 172.547H548.877L549.667 173.952L548.877 175.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.57 161.531H547.604L547.122 160.697L547.604 159.863H548.57L549.053 160.697L548.57 161.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.053 155.782H547.122L546.112 154.114L547.122 152.402H549.053L550.062 154.114L549.053 155.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.228 149.506H546.946L545.761 147.487L546.946 145.468H549.228L550.413 147.487L549.228 149.506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.623 130.282H546.551L545.015 127.649L546.551 124.972H549.623L551.159 127.649L549.623 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.623 123.655H546.551L545.015 121.022L546.551 118.388H549.623L551.159 121.022L549.623 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.623 117.072H546.551L545.015 114.394L546.551 111.761H549.623L551.159 114.394L549.623 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.623 110.444H546.551L545.015 107.811L546.551 105.134H549.623L551.159 107.811L549.623 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.623 103.817H546.551L545.015 101.184L546.551 98.5506H549.623L551.159 101.184L549.623 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.482 95.2589H547.692L547.297 94.5567L547.692 93.8983H548.482L548.877 94.5567L548.482 95.2589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3539 102.896H77.3789L76.4133 101.184L77.3789 99.4722H79.3539L80.3633 101.184L79.3539 102.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8805 110.444H76.8522L75.3161 107.811L76.8522 105.134H79.8805L81.4167 107.811L79.8805 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8805 117.072H76.8522L75.3161 114.394L76.8522 111.761H79.8805L81.4167 114.394L79.8805 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8805 123.655H76.8522L75.3161 121.022L76.8522 118.388H79.8805L81.4167 121.022L79.8805 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8805 130.282H76.8522L75.3161 127.649L76.8522 124.972H79.8805L81.4167 127.649L79.8805 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8805 136.909H76.8522L75.3161 134.232L76.8522 131.599H79.8805L81.4167 134.232L79.8805 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8805 143.493H76.8522L75.3161 140.859L76.8522 138.226H79.8805L81.4167 140.859L79.8805 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8805 150.12H76.8522L75.3161 147.487L76.8522 144.853H79.8805L81.4167 147.487L79.8805 150.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8805 156.747H76.8522L75.3161 154.114L76.8522 151.437H79.8805L81.4167 154.114L79.8805 156.747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8805 163.374H76.8522L75.3161 160.697L76.8522 158.064H79.8805L81.4167 160.697L79.8805 163.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8805 169.958H76.8522L75.3161 167.324L76.8522 164.691H79.8805L81.4167 167.324L79.8805 169.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8805 176.585H76.8522L75.3161 173.952L76.8522 171.274H79.8805L81.4167 173.952L79.8805 176.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8805 183.212H76.8522L75.3161 180.535L76.8522 177.902H79.8805L81.4167 180.535L79.8805 183.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8805 189.796H76.8522L75.3161 187.162L76.8522 184.529H79.8805L81.4167 187.162L79.8805 189.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8805 196.423H76.8522L75.3161 193.789L76.8522 191.156H79.8805L81.4167 193.789L79.8805 196.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8272 201.207H77.9056L77.4228 200.417L77.9056 199.583H78.8272L79.31 200.417L78.8272 201.207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.758 364.122H552.871L551.906 362.454L552.871 360.787H554.758L555.724 362.454L554.758 364.122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.329 358.461H552.301L550.764 355.827L552.301 353.194H555.329L556.865 355.827L555.329 358.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.329 351.877H552.301L550.764 349.2L552.301 346.567H555.329L556.865 349.2L555.329 351.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.329 345.25H552.301L550.764 342.617L552.301 339.983H555.329L556.865 342.617L555.329 345.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.329 338.623H552.301L550.764 335.989L552.301 333.356H555.329L556.865 335.989L555.329 338.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.329 332.039H552.301L550.764 329.362L552.301 326.729H555.329L556.865 329.362L555.329 332.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.329 325.412H552.301L550.764 322.779L552.301 320.102H555.329L556.865 322.779L555.329 325.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.329 318.785H552.301L550.764 316.152L552.301 313.518H555.329L556.865 316.152L555.329 318.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.329 312.202H552.301L550.764 309.524L552.301 306.891H555.329L556.865 309.524L555.329 312.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.188 283.718H553.442L553.091 283.059L553.442 282.445H554.188L554.539 283.059L554.188 283.718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.329 279.109H552.301L550.764 276.476L552.301 273.799H555.329L556.865 276.476L555.329 279.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.153 192.824H552.476L551.116 190.498L552.476 188.128H555.153L556.514 190.498L555.153 192.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.714 185.407H552.915L552.037 183.871L552.915 182.334H554.714L555.592 183.871L554.714 185.407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.363 178.165H553.31L552.783 177.243L553.31 176.322H554.363L554.89 177.243L554.363 178.165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.197 173.03H552.432L551.072 170.616L552.432 168.246H555.197L556.558 170.616L555.197 173.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.451 158.503H553.178L552.564 157.406L553.178 156.308H554.451L555.066 157.406L554.451 158.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.285 133.486H552.344L550.852 130.941L552.344 128.395H555.285L556.777 130.941L555.285 133.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.329 126.991H552.301L550.764 124.313L552.301 121.68H555.329L556.865 124.313L555.329 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.329 120.363H552.301L550.764 117.73L552.301 115.053H555.329L556.865 117.73L555.329 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.329 113.736H552.301L550.764 111.103L552.301 108.469H555.329L556.865 111.103L555.329 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.329 107.153H552.301L550.764 104.476L552.301 101.842H555.329L556.865 104.476L555.329 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.329 100.526H552.301L550.764 97.8922L552.301 95.215H555.329L556.865 97.8922L555.329 100.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.175 107.153H71.1028L69.6105 104.476L71.1028 101.842H74.175L75.7111 104.476L74.175 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.175 113.736H71.1028L69.6105 111.103L71.1028 108.469H74.175L75.7111 111.103L74.175 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.175 120.363H71.1028L69.6105 117.73L71.1028 115.053H74.175L75.7111 117.73L74.175 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.175 126.991H71.1028L69.6105 124.313L71.1028 121.68H74.175L75.7111 124.313L74.175 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.175 133.574H71.1028L69.6105 130.941L71.1028 128.307H74.175L75.7111 130.941L74.175 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.175 140.201H71.1028L69.6105 137.568L71.1028 134.934H74.175L75.7111 137.568L74.175 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0872 146.697H71.1906L69.7422 144.195L71.1906 141.649H74.0872L75.5356 144.195L74.0872 146.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.78 152.709H71.5417L70.4006 150.778L71.5417 148.847H73.78L74.8772 150.778L73.78 152.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2094 158.371H72.1122L71.5417 157.406L72.1122 156.44H73.2094L73.7361 157.406L73.2094 158.371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.99 164.603H72.3317L71.9806 164.033L72.3317 163.462H72.99L73.2972 164.033L72.99 164.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1217 171.494H72.1561L71.6295 170.616L72.1561 169.782H73.1217L73.6483 170.616L73.1217 171.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2094 178.209H72.1122L71.5417 177.243L72.1122 176.278H73.2094L73.7361 177.243L73.2094 178.209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7361 185.802H71.5417L70.4444 183.871L71.5417 181.939H73.7361L74.8772 183.871L73.7361 185.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2094 191.419H72.1122L71.5417 190.498L72.1122 189.532H73.2094L73.7361 190.498L73.2094 191.419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.078 368.379H558.006L556.514 365.746L558.006 363.113H561.078L562.571 365.746L561.078 368.379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.288 360.436H558.796L558.05 359.163L558.796 357.846H560.288L561.034 359.163L560.288 360.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.078 355.169H558.006L556.514 352.536L558.006 349.902H561.078L562.614 352.536L561.078 355.169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.078 348.542H558.006L556.514 345.908L558.006 343.275H561.078L562.614 345.908L561.078 348.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.078 341.958H558.006L556.514 339.281L558.006 336.648H561.078L562.614 339.281L561.078 341.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.078 335.331H558.006L556.514 332.698L558.006 330.021H561.078L562.614 332.698L561.078 335.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.078 328.704H558.006L556.514 326.071L558.006 323.437H561.078L562.614 326.071L561.078 328.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.078 322.121H558.006L556.514 319.443L558.006 316.81H561.078L562.614 319.443L561.078 322.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.078 315.493H558.006L556.514 312.86L558.006 310.183H561.078L562.614 312.86L561.078 315.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.157 307.286H558.928L558.357 306.233L558.928 305.179H560.157L560.771 306.233L560.157 307.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.034 288.941H558.05L556.602 286.395L558.05 283.806H561.034L562.527 286.395L561.034 288.941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.078 282.401H558.006L556.514 279.768L558.006 277.134H561.078L562.614 279.768L561.078 282.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.893 273.799H559.191L558.796 273.141L559.191 272.526H559.893L560.288 273.141L559.893 273.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.508 135.944H558.577L557.611 134.232L558.577 132.564H560.508L561.473 134.232L560.508 135.944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.078 130.282H558.006L556.514 127.649L558.006 124.972H561.078L562.614 127.649L561.078 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.078 123.655H558.006L556.514 121.022L558.006 118.388H561.078L562.614 121.022L561.078 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.078 117.072H558.006L556.514 114.394L558.006 111.761H561.078L562.614 114.394L561.078 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.078 110.444H558.006L556.514 107.811L558.006 105.134H561.078L562.614 107.811L561.078 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.034 103.773H558.05L556.558 101.184L558.05 98.5944H561.034L562.527 101.184L561.034 103.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0306 103.071H65.8361L64.7389 101.184L65.8361 99.2967H68.0306L69.1278 101.184L68.0306 103.071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4256 110.444H65.3972L63.8611 107.811L65.3972 105.134H68.4256L69.9617 107.811L68.4256 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4256 117.072H65.3972L63.8611 114.394L65.3972 111.761H68.4256L69.9617 114.394L68.4256 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4256 123.655H65.3972L63.8611 121.022L65.3972 118.388H68.4256L69.9617 121.022L68.4256 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4256 130.282H65.3972L63.8611 127.649L65.3972 124.972H68.4256L69.9617 127.649L68.4256 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4256 136.909H65.3972L63.8611 134.232L65.3972 131.599H68.4256L69.9617 134.232L68.4256 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1183 142.922H65.7044L64.5194 140.859L65.7044 138.797H68.1183L69.3033 140.859L68.1183 142.922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.643 363.069H564.941L564.589 362.454L564.941 361.84H565.643L565.994 362.454L565.643 363.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.74 358.329H563.843L562.395 355.827L563.843 353.326H566.74L568.144 355.827L566.74 358.329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.784 351.877H563.756L562.219 349.2L563.756 346.567H566.784L568.32 349.2L566.784 351.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.784 345.25H563.756L562.219 342.617L563.756 339.983H566.784L568.32 342.617L566.784 345.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.784 338.623H563.756L562.219 335.989L563.756 333.356H566.784L568.32 335.989L566.784 338.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.784 332.039H563.756L562.219 329.362L563.756 326.729H566.784L568.32 329.362L566.784 332.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.784 325.412H563.756L562.219 322.779L563.756 320.102H566.784L568.32 322.779L566.784 325.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.784 318.785H563.756L562.219 316.152L563.756 313.518H566.784L568.32 316.152L566.784 318.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.784 312.202H563.756L562.219 309.524L563.756 306.891H566.784L568.32 309.524L566.784 312.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.652 305.267H563.931L562.527 302.941L563.931 300.571H566.652L568.013 302.941L566.652 305.267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.774 297.148H564.765L564.282 296.314L564.765 295.436H565.774L566.257 296.314L565.774 297.148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.696 292.144H563.887L562.439 289.687L563.887 287.273H566.696L568.101 289.687L566.696 292.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.784 285.737H563.756L562.219 283.059L563.756 280.426H566.784L568.32 283.059L566.784 285.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.784 126.947H563.756L562.219 124.313L563.756 121.68H566.784L568.32 124.313L566.784 126.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.784 120.363H563.756L562.219 117.73L563.756 115.053H566.784L568.32 117.73L566.784 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.784 113.736H563.756L562.219 111.103L563.756 108.469H566.784L568.32 111.103L566.784 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.784 107.153H563.756L562.219 104.476L563.756 101.842H566.784L568.32 104.476L566.784 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4911 98.375H60.9206L60.6133 97.8922L60.9206 97.3656H61.4911L61.7544 97.8922L61.4911 98.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.72 107.153H59.6478L58.1555 104.476L59.6478 101.842H62.72L64.2561 104.476L62.72 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.72 113.736H59.6478L58.1555 111.103L59.6478 108.469H62.72L64.2561 111.103L62.72 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.72 120.363H59.6478L58.1555 117.73L59.6478 115.053H62.72L64.2561 117.73L62.72 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.72 126.991H59.6478L58.1555 124.313L59.6478 121.68H62.72L64.2561 124.313L62.72 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.72 133.574H59.6478L58.1555 130.941L59.6478 128.307H62.72L64.2561 130.941L62.72 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2811 139.455H60.0867L58.9895 137.568L60.0867 135.681H62.2811L63.3783 137.568L62.2811 139.455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.919 354.116H570.076L569.154 352.536L570.076 350.956H571.919L572.841 352.536L571.919 354.116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.533 348.542H569.461L567.969 345.908L569.461 343.275H572.533L574.069 345.908L572.533 348.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.533 341.958H569.461L567.969 339.281L569.461 336.648H572.533L574.069 339.281L572.533 341.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.533 335.331H569.461L567.969 332.698L569.461 330.021H572.533L574.069 332.698L572.533 335.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.533 328.704H569.461L567.969 326.071L569.461 323.437H572.533L574.069 326.071L572.533 328.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.533 322.121H569.461L567.969 319.443L569.461 316.81H572.533L574.069 319.443L572.533 322.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.314 315.142H569.681L568.364 312.86L569.681 310.534H572.314L573.631 312.86L572.314 315.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.489 288.941H569.505L568.013 286.395L569.505 283.806H572.489L573.982 286.395L572.489 288.941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.304 154.597H570.734L570.427 154.114L570.734 153.587H571.304L571.568 154.114L571.304 154.597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.402 149.944H569.593L568.144 147.487L569.593 145.029H572.402L573.85 147.487L572.402 149.944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.533 143.493H569.461L567.969 140.859L569.461 138.226H572.533L574.069 140.859L572.533 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.489 136.822H569.505L568.057 134.232L569.505 131.687H572.489L573.982 134.232L572.489 136.822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.743 128.922H570.251L569.549 127.649L570.251 126.376H571.743L572.489 127.649L571.743 128.922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.533 123.655H569.461L567.969 121.022L569.461 118.388H572.533L574.069 121.022L572.533 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.533 117.072H569.461L567.969 114.394L569.461 111.761H572.533L574.069 114.394L572.533 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.533 110.444H569.461L567.969 107.811L569.461 105.134H572.533L574.069 107.811L572.533 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.489 103.729H569.549L568.057 101.184L569.549 98.6383H572.489L573.938 101.184L572.489 103.729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9706 103.817H53.9422L52.4061 101.184L53.9422 98.5506H56.9706L58.5067 101.184L56.9706 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9706 110.444H53.9422L52.4061 107.811L53.9422 105.134H56.9706L58.5067 107.811L56.9706 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9706 117.072H53.9422L52.4061 114.394L53.9422 111.761H56.9706L58.5067 114.394L56.9706 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9706 123.655H53.9422L52.4061 121.022L53.9422 118.388H56.9706L58.5067 121.022L56.9706 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9706 130.282H53.9422L52.4061 127.649L53.9422 124.972H56.9706L58.5067 127.649L56.9706 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8733 134.934H55.0833L54.6883 134.232L55.0833 133.574H55.8733L56.2683 134.232L55.8733 134.934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.888 344.636H575.562L574.421 342.617L575.562 340.598H577.888L579.073 342.617L577.888 344.636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.239 338.623H575.211L573.674 335.989L575.211 333.356H578.239L579.775 335.989L578.239 338.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.239 331.952H575.254L573.718 329.362L575.254 326.773H578.239L579.731 329.362L578.239 331.952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.756 324.491H575.737L574.728 322.779L575.737 321.023H577.756L578.766 322.779L577.756 324.491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.317 290.696H576.132L575.562 289.687L576.132 288.677H577.317L577.888 289.687L577.317 290.696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.195 146.697H575.298L573.85 144.195L575.298 141.649H578.195L579.643 144.195L578.195 146.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.239 140.157H575.254L573.762 137.568L575.254 134.978H578.239L579.731 137.568L578.239 140.157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.239 133.574H575.211L573.718 130.941L575.211 128.351H578.239L579.731 130.941L578.239 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.239 126.991H575.211L573.674 124.313L575.211 121.68H578.239L579.775 124.313L578.239 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.239 120.363H575.211L573.674 117.73L575.211 115.053H578.239L579.775 117.73L578.239 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.239 113.736H575.211L573.674 111.103L575.211 108.469H578.239L579.775 111.103L578.239 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.239 107.153H575.211L573.674 104.476L575.211 101.842H578.239L579.775 104.476L578.239 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.405 99.0333H576.044L575.386 97.8922L576.044 96.7072H577.405L578.063 97.8922L577.405 99.0333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5189 99.2528H48.9389L48.1489 97.8922L48.9389 96.4878H50.5189L51.3528 97.8922L50.5189 99.2528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.265 107.153H48.1928L46.6567 104.476L48.1928 101.842H51.265L52.8011 104.476L51.265 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.265 113.736H48.1928L46.6567 111.103L48.1928 108.469H51.265L52.8011 111.103L51.265 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.265 120.363H48.1928L46.6567 117.73L48.1928 115.053H51.265L52.8011 117.73L51.265 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.265 126.991H48.1928L46.6567 124.313L48.1928 121.68H51.265L52.8011 124.313L51.265 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.265 133.574H48.1928L46.6567 130.941L48.1928 128.307H51.265L52.8011 130.941L51.265 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.023 320.453H581.882L581.355 319.443L581.882 318.478H583.023L583.593 319.443L583.023 320.453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.847 313.518H582.057L581.662 312.86L582.057 312.158H582.847L583.242 312.86L582.847 313.518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.988 130.282H580.96L579.424 127.649L580.96 125.016H583.988L585.524 127.649L583.988 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.988 123.655H580.916L579.424 121.022L580.916 118.388H583.988L585.524 121.022L583.988 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.988 117.072H580.916L579.424 114.394L580.916 111.761H583.988L585.524 114.394L583.988 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.988 110.444H580.916L579.424 107.811L580.916 105.134H583.988L585.524 107.811L583.988 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.988 103.817H580.96L579.424 101.184L580.96 98.5506H583.988L585.524 101.184L583.988 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3744 95.1711H43.6722L43.2772 94.5567L43.6722 93.9422H44.3744L44.7255 94.5567L44.3744 95.1711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5156 103.817H42.4872L40.9511 101.184L42.4872 98.5506H45.5156L47.0517 101.184L45.5156 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5156 110.444H42.4872L40.9511 107.811L42.4872 105.134H45.5156L47.0517 107.811L45.5156 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5156 117.072H42.4872L40.9511 114.394L42.4872 111.761H45.5156L47.0517 114.394L45.5156 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5156 123.655H42.4872L40.9511 121.022L42.4872 118.388H45.5156L47.0517 121.022L45.5156 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5156 130.282H42.4872L40.9511 127.649L42.4872 124.972H45.5156L47.0517 127.649L45.5156 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5156 136.909H42.4872L40.9511 134.232L42.4872 131.599H45.5156L47.0517 134.232L45.5156 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5156 143.493H42.4872L40.9511 140.859L42.4872 138.226H45.5156L47.0517 140.859L45.5156 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.641 131.731H587.763L587.324 130.941L587.763 130.194H588.641L589.079 130.941L588.641 131.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.738 126.991H586.666L585.129 124.313L586.666 121.68H589.738L591.23 124.313L589.738 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.738 120.363H586.666L585.129 117.73L586.666 115.053H589.738L591.23 117.73L589.738 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.738 113.736H586.666L585.129 111.103L586.666 108.469H589.738L591.23 111.103L589.738 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.738 107.153H586.666L585.129 104.476L586.666 101.842H589.738L591.23 104.476L589.738 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5905 100.131H36.9572L35.6844 97.8922L36.9572 95.61H39.5905L40.8633 97.8922L39.5905 100.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.81 107.153H36.7378L35.2017 104.476L36.7378 101.842H39.81L41.3461 104.476L39.81 107.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.81 113.736H36.7378L35.2017 111.103L36.7378 108.469H39.81L41.3461 111.103L39.81 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.81 120.363H36.7378L35.2017 117.73L36.7378 115.053H39.81L41.3461 117.73L39.81 120.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.81 126.991H36.7378L35.2017 124.313L36.7378 121.68H39.81L41.3461 124.313L39.81 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.81 133.574H36.7378L35.2017 130.941L36.7378 128.307H39.81L41.3461 130.941L39.81 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7661 140.157H36.7817L35.2455 137.568L36.7817 134.934H39.7661L41.3022 137.568L39.7661 140.157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6783 146.609H36.8694L35.465 144.195L36.8694 141.737H39.6783L41.0828 144.195L39.6783 146.609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.171 379.483H593.644L593.381 379.001L593.644 378.518H594.171L594.478 379.001L594.171 379.483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.443 123.655H592.371L590.879 121.022L592.371 118.388H595.443L596.979 121.022L595.443 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.443 117.072H592.371L590.879 114.394L592.371 111.761H595.443L596.979 114.394L595.443 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.443 110.444H592.371L590.879 107.811L592.371 105.134H595.443L596.979 107.811L595.443 110.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.258 101.798H593.556L593.205 101.184L593.556 100.569H594.258L594.609 101.184L594.258 101.798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0606 103.817H31.0322L29.4961 101.184L31.0322 98.5506H34.0606L35.5967 101.184L34.0606 103.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.885 110.137H31.2078L29.8472 107.811L31.2078 105.485H33.885L35.2456 107.811L33.885 110.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0606 117.072H31.0322L29.4961 114.394L31.0322 111.761H34.0606L35.5967 114.394L34.0606 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0606 123.655H31.0322L29.4961 121.022L31.0322 118.388H34.0606L35.5967 121.022L34.0606 123.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0606 130.282H31.0322L29.4961 127.649L31.0322 124.972H34.0606L35.5967 127.649L34.0606 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0606 136.909H31.0322L29.4961 134.232L31.0322 131.599H34.0606L35.5967 134.232L34.0606 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0606 143.493H31.0322L29.4961 140.859L31.0322 138.226H34.0606L35.5967 140.859L34.0606 143.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.105 378.211H598.164L596.716 375.665L598.164 373.119H601.105L602.597 375.665L601.105 378.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.139 369.916H599.13L598.647 369.082L599.13 368.204H600.139L600.666 369.082L600.139 369.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.096 125.059H599.218L598.779 124.313L599.218 123.567H600.096L600.491 124.313L600.096 125.059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.578 119.31H598.735L597.769 117.73L598.735 116.106H600.578L601.5 117.73L600.578 119.31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.193 113.736H598.121L596.584 111.103L598.121 108.469H601.193L602.685 111.103L601.193 113.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.886 106.626H598.384L597.155 104.476L598.384 102.325H600.886L602.114 104.476L600.886 106.626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0822 98.3311H26.5556L26.2922 97.8922L26.5556 97.4094H27.0822L27.3456 97.8922L27.0822 98.3311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5211 105.704H26.1167L25.4145 104.476L26.1167 103.247H27.5211L28.2672 104.476L27.5211 105.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3111 113.692H25.3267L23.8344 111.103L25.3267 108.513H28.3111L29.8472 111.103L28.3111 113.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0039 119.793H25.6339L24.405 117.73L25.6339 115.623H28.0039L29.2328 117.73L28.0039 119.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.355 126.991H25.2828L23.7467 124.313L25.2828 121.68H28.355L29.8911 124.313L28.355 126.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.355 133.574H25.2828L23.7467 130.941L25.2828 128.307H28.355L29.8911 130.941L28.355 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.355 140.201H25.2828L23.7467 137.568L25.2828 134.934H28.355L29.8911 137.568L28.355 140.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.355 146.828H25.2828L23.7906 144.195L25.2828 141.518H28.355L29.8472 144.195L28.355 146.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.284 373.953H604.484L603.563 372.373L604.484 370.793H606.284L607.162 372.373L606.284 373.953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.767 368.204H603.958L602.553 365.746L603.958 363.332H606.767L608.171 365.746L606.767 368.204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.416 116.238H604.309L603.256 114.394L604.309 112.595H606.416L607.513 114.394L606.416 116.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.372 109.523H604.397L603.387 107.811L604.397 106.099H606.372L607.337 107.811L606.372 109.523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5961 108.645H20.5867L20.1039 107.811L20.5867 106.933H21.5961L22.0789 107.811L21.5961 108.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6056 117.072H19.5772L18.0411 114.394L19.5772 111.761H22.6056L24.1417 114.394L22.6056 117.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3328 121.461H20.85L20.5867 121.022L20.85 120.583H21.3328L21.5961 121.022L21.3328 121.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6056 130.282H19.5772L18.0411 127.649L19.5772 124.972H22.6056L24.1417 127.649L22.6056 130.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6056 136.909H19.5772L18.0411 134.232L19.5772 131.599H22.6056L24.1417 134.232L22.6056 136.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7717 142.044H20.4111L19.7089 140.859L20.4111 139.674H21.7717L22.4739 140.859L21.7717 142.044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9472 148.935H20.2356L19.4017 147.487L20.2356 146.038H21.9472L22.7811 147.487L21.9472 148.935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2983 156.221H19.8844L18.6555 154.114L19.8844 152.007H22.2983L23.5272 154.114L22.2983 156.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.419 369.608H610.804L610.497 369.082L610.804 368.555H611.419L611.726 369.082L611.419 369.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.033 364.078H610.146L609.224 362.454L610.146 360.831H612.033L612.999 362.454L612.033 364.078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.594 356.705H610.585L610.102 355.827L610.585 354.993H611.594L612.077 355.827L611.594 356.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.946 119.178H610.278L609.4 117.73L610.278 116.238H611.946L612.779 117.73L611.946 119.178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.989 112.639H610.234L609.312 111.103L610.234 109.567H611.989L612.867 111.103L611.989 112.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3294 112.771H14.3983L13.4328 111.103L14.3983 109.435H16.3294L17.295 111.103L16.3294 112.771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5489 126.42H14.1789L12.95 124.313L14.1789 122.251H16.5489L17.7778 124.313L16.5489 126.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9 133.574H13.8278L12.2917 130.941L13.8278 128.307H16.9L18.4361 130.941L16.9 133.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5489 139.631H14.1789L12.95 137.568L14.1789 135.505H16.5489L17.7778 137.568L16.5489 139.631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.715 151.393H15.0128L14.6617 150.778L15.0128 150.208H15.715L16.0661 150.778L15.715 151.393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2856 158.986H14.4422L13.5206 157.406L14.4422 155.826H16.2856L17.2072 157.406L16.2856 158.986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.09 361.357H615.544L614.272 359.163L615.544 356.924H618.09L619.407 359.163L618.09 361.357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.353 355.125H615.325L613.833 352.536L615.325 349.902H618.353L619.846 352.536L618.353 355.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.124 346.435H616.51L616.247 345.908L616.51 345.382H617.124L617.432 345.908L617.124 346.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96556 128.176H9.30722L9 127.649L9.30722 127.078H9.96556L10.2728 127.649L9.96556 128.176Z",
    fill: "#EBECF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96556 154.641H9.30722L9 154.114L9.30722 153.543H9.96556L10.2728 154.114L9.96556 154.641Z",
    fill: "#EBECF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92166 161.224H9.35111L9.04388 160.697L9.35111 160.214H9.92166L10.2289 160.697L9.92166 161.224Z",
    fill: "#EBECF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.006 349.99H622.128L621.689 349.2L622.128 348.454H623.006L623.444 349.2L623.006 349.99Z",
    fill: "#EBECF7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M427 210.5H447V214.875H427V210.5Z",
    fill: "#E6E7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M443.875 205.812H430.125C428.054 205.812 427 207.352 427 209.25V210.5H447V209.25C447 207.352 445.946 205.812 443.875 205.812Z",
    fill: "#FF9933"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M427 216.125C427 218.023 428.054 219.562 430.125 219.562H443.875C445.946 219.562 447 218.023 447 216.125V214.875H427V216.125Z",
    fill: "#128807"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.097 210.682C437.496 210.682 437.886 210.801 438.218 211.023C438.55 211.244 438.809 211.56 438.962 211.929C439.114 212.298 439.154 212.704 439.076 213.095C438.998 213.487 438.805 213.846 438.523 214.128C438.24 214.411 437.88 214.603 437.489 214.68C437.097 214.758 436.691 214.717 436.322 214.564C435.954 214.411 435.639 214.152 435.417 213.819C435.196 213.487 435.078 213.096 435.079 212.697C435.08 212.163 435.293 211.65 435.671 211.272C436.049 210.894 436.562 210.682 437.097 210.682ZM435.752 211.556C435.786 211.595 435.793 211.637 435.769 211.673C435.76 211.689 435.744 211.701 435.727 211.708C435.713 211.713 435.698 211.714 435.684 211.712C435.669 211.711 435.655 211.705 435.643 211.697C435.589 211.775 435.541 211.857 435.5 211.943C435.548 211.973 435.563 212.012 435.548 212.055C435.539 212.077 435.523 212.094 435.501 212.104C435.48 212.114 435.456 212.115 435.434 212.108C435.412 212.153 435.362 212.343 435.361 212.383C435.382 212.386 435.401 212.398 435.414 212.414C435.428 212.43 435.435 212.451 435.434 212.473C435.428 212.532 435.392 212.557 435.336 212.559C435.328 212.615 435.328 212.805 435.337 212.842C435.396 212.848 435.427 212.874 435.432 212.918C435.439 212.967 435.416 212.998 435.359 213.02C435.376 213.113 435.4 213.204 435.432 213.293C435.454 213.286 435.478 213.287 435.499 213.295C435.52 213.304 435.537 213.32 435.545 213.342C435.553 213.358 435.555 213.376 435.551 213.394C435.548 213.408 435.542 213.421 435.533 213.432C435.524 213.443 435.513 213.452 435.5 213.458C435.542 213.544 435.588 213.626 435.643 213.703C435.692 213.679 435.734 213.685 435.763 213.719C435.776 213.733 435.783 213.751 435.783 213.77C435.784 213.784 435.782 213.798 435.776 213.811C435.771 213.824 435.762 213.835 435.751 213.844C435.813 213.917 435.88 213.984 435.953 214.046C435.993 214.01 436.036 214.004 436.073 214.03C436.089 214.041 436.101 214.057 436.106 214.075C436.11 214.089 436.111 214.103 436.108 214.116C436.106 214.13 436.101 214.143 436.093 214.154C436.172 214.208 436.253 214.255 436.339 214.296C436.372 214.249 436.41 214.234 436.451 214.249C436.468 214.256 436.484 214.267 436.495 214.283C436.511 214.308 436.513 214.335 436.504 214.365C436.594 214.397 436.684 214.421 436.778 214.438C436.797 214.385 436.828 214.36 436.871 214.363C436.891 214.365 436.908 214.371 436.924 214.384C436.946 214.404 436.956 214.429 436.954 214.461C437.051 214.468 437.145 214.468 437.238 214.461C437.245 214.4 437.269 214.37 437.318 214.363C437.336 214.361 437.355 214.364 437.371 214.374C437.382 214.38 437.392 214.39 437.4 214.401C437.408 214.412 437.413 214.424 437.415 214.438C437.509 214.42 437.601 214.396 437.689 214.364C437.682 214.305 437.696 214.27 437.736 214.252C437.75 214.245 437.766 214.243 437.782 214.244C437.798 214.246 437.813 214.251 437.824 214.261C437.836 214.271 437.846 214.283 437.857 214.295C437.942 214.255 438.024 214.208 438.101 214.154C438.069 214.104 438.088 214.056 438.114 214.035C438.123 214.027 438.134 214.021 438.145 214.018C438.156 214.014 438.168 214.013 438.18 214.014C438.192 214.015 438.204 214.018 438.214 214.024C438.225 214.029 438.234 214.037 438.242 214.046C438.314 213.984 438.382 213.917 438.442 213.845C438.407 213.804 438.4 213.762 438.426 213.725C438.436 213.709 438.453 213.697 438.471 213.692C438.485 213.687 438.499 213.686 438.513 213.688C438.526 213.69 438.539 213.696 438.551 213.704C438.606 213.625 438.653 213.543 438.694 213.458C438.648 213.427 438.632 213.391 438.645 213.35C438.65 213.332 438.661 213.316 438.677 213.305C438.689 213.297 438.703 213.291 438.717 213.289C438.732 213.287 438.747 213.288 438.761 213.293C438.781 213.248 438.832 213.063 438.835 213.018C438.813 213.014 438.794 213.002 438.78 212.985C438.772 212.977 438.767 212.967 438.764 212.956C438.76 212.946 438.759 212.935 438.761 212.923C438.762 212.904 438.77 212.885 438.784 212.871C438.793 212.861 438.805 212.853 438.817 212.848C438.83 212.843 438.844 212.841 438.858 212.843C438.865 212.748 438.865 212.653 438.858 212.558C438.798 212.553 438.769 212.529 438.762 212.482C438.758 212.464 438.761 212.446 438.769 212.43C438.776 212.417 438.785 212.406 438.796 212.398C438.807 212.39 438.821 212.384 438.834 212.382C438.818 212.289 438.794 212.197 438.762 212.108C438.704 212.117 438.668 212.102 438.649 212.062C438.644 212.051 438.641 212.039 438.641 212.028C438.64 212.016 438.642 212.004 438.647 211.993C438.651 211.982 438.657 211.972 438.665 211.963C438.673 211.955 438.683 211.948 438.694 211.943C438.653 211.857 438.605 211.775 438.551 211.697C438.501 211.721 438.46 211.716 438.431 211.681C438.418 211.667 438.411 211.648 438.411 211.629C438.41 211.615 438.413 211.601 438.419 211.589C438.424 211.576 438.433 211.565 438.443 211.557C438.382 211.484 438.315 211.417 438.243 211.355C438.199 211.392 438.158 211.397 438.122 211.371C438.106 211.36 438.094 211.344 438.088 211.325C438.085 211.312 438.084 211.298 438.086 211.285C438.088 211.271 438.094 211.259 438.102 211.248C438.024 211.193 437.941 211.145 437.856 211.105C437.823 211.151 437.787 211.166 437.746 211.153C437.728 211.147 437.712 211.135 437.701 211.12C437.693 211.108 437.687 211.094 437.686 211.079C437.684 211.065 437.685 211.05 437.69 211.036C437.601 211.004 437.509 210.979 437.416 210.963C437.398 211.014 437.366 211.04 437.324 211.038C437.305 211.037 437.286 211.03 437.271 211.018C437.26 211.008 437.251 210.996 437.246 210.983C437.24 210.969 437.238 210.955 437.24 210.94C437.145 210.932 437.05 210.932 436.956 210.94C436.949 210.997 436.925 211.029 436.883 211.036C436.865 211.04 436.845 211.037 436.828 211.029C436.815 211.022 436.804 211.013 436.796 211.002C436.787 210.99 436.782 210.977 436.779 210.963C436.686 210.98 436.594 211.004 436.505 211.036C436.515 211.092 436.499 211.128 436.461 211.148C436.444 211.156 436.427 211.159 436.408 211.156C436.393 211.154 436.379 211.148 436.367 211.139C436.356 211.13 436.347 211.119 436.341 211.105C436.288 211.125 436.118 211.223 436.095 211.248C436.118 211.294 436.113 211.335 436.081 211.365C436.072 211.373 436.061 211.379 436.05 211.383C436.039 211.386 436.027 211.388 436.015 211.387C436.003 211.386 435.991 211.383 435.98 211.377C435.97 211.372 435.96 211.364 435.953 211.355C435.88 211.416 435.813 211.484 435.752 211.556Z",
    fill: "#010088"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.963 214.196C437.959 214.192 437.955 214.189 437.952 214.185C437.771 213.907 437.588 213.63 437.406 213.353C437.402 213.345 437.397 213.337 437.393 213.328C437.351 213.229 437.309 213.13 437.266 213.031C437.264 213.026 437.262 213.021 437.26 213.017C437.242 213.023 437.226 213.031 437.208 213.038L437.214 213.054C437.253 213.15 437.29 213.246 437.33 213.342C437.341 213.368 437.345 213.394 437.351 213.421C437.381 213.565 437.41 213.709 437.441 213.853L437.547 214.366C437.547 214.367 437.547 214.369 437.547 214.37C437.547 214.371 437.546 214.372 437.546 214.373L437.541 214.363C437.456 214.1 437.368 213.838 437.282 213.576C437.265 213.525 437.249 213.474 437.231 213.423C437.222 213.398 437.219 213.371 437.215 213.345C437.204 213.27 437.195 213.195 437.183 213.121C437.181 213.103 437.178 213.086 437.176 213.068C437.175 213.061 437.174 213.054 437.172 213.047C437.153 213.049 437.136 213.052 437.118 213.054C437.118 213.061 437.118 213.069 437.119 213.077C437.13 213.168 437.139 213.26 437.152 213.352C437.159 213.402 437.156 213.451 437.153 213.501C437.151 213.543 437.148 213.585 437.146 213.628C437.141 213.713 437.136 213.798 437.13 213.884L437.121 214.06C437.116 214.16 437.109 214.26 437.104 214.359C437.102 214.387 437.101 214.416 437.098 214.443L437.091 214.349L437.081 214.144L437.07 213.961C437.067 213.898 437.063 213.836 437.059 213.774C437.056 213.733 437.055 213.692 437.052 213.652C437.049 213.587 437.045 213.522 437.042 213.458C437.038 213.424 437.039 213.39 437.044 213.356C437.051 213.309 437.056 213.262 437.061 213.215C437.068 213.169 437.073 213.123 437.078 213.077C437.079 213.07 437.079 213.062 437.08 213.054L437.025 213.047C437.024 213.059 437.021 213.071 437.019 213.084C437.006 213.179 436.992 213.275 436.979 213.37C436.975 213.407 436.96 213.442 436.948 213.476C436.852 213.769 436.755 214.063 436.658 214.356C436.655 214.361 436.654 214.366 436.65 214.371C436.65 214.367 436.65 214.364 436.652 214.361C436.692 214.163 436.733 213.966 436.775 213.768C436.802 213.637 436.829 213.506 436.856 213.375L436.863 213.353C436.904 213.254 436.943 213.154 436.984 213.055C436.985 213.049 436.987 213.044 436.99 213.038C436.973 213.031 436.955 213.024 436.938 213.017C436.936 213.023 436.933 213.027 436.931 213.033C436.888 213.132 436.845 213.232 436.802 213.331C436.799 213.339 436.796 213.346 436.792 213.353C436.608 213.632 436.424 213.912 436.241 214.192C436.238 214.196 436.235 214.2 436.231 214.203C436.233 214.198 436.235 214.194 436.237 214.189L436.689 213.293C436.693 213.285 436.698 213.278 436.703 213.271L436.897 213.012C436.901 213.007 436.903 213.003 436.907 212.998C436.891 212.987 436.878 212.976 436.862 212.964C436.859 212.968 436.856 212.972 436.853 212.976C436.785 213.06 436.719 213.146 436.653 213.23C436.645 213.238 436.638 213.246 436.63 213.253C436.384 213.473 436.138 213.693 435.89 213.913C435.885 213.917 435.88 213.922 435.874 213.924C435.877 213.922 435.878 213.918 435.88 213.916C436.083 213.689 436.284 213.463 436.486 213.237C436.498 213.224 436.509 213.212 436.52 213.198C436.543 213.171 436.569 213.148 436.598 213.126L436.822 212.95C436.827 212.946 436.831 212.942 436.836 212.938C436.825 212.923 436.814 212.908 436.802 212.894C436.797 212.897 436.793 212.9 436.788 212.904C436.702 212.968 436.616 213.032 436.53 213.097C436.52 213.104 436.51 213.11 436.499 213.116C436.206 213.264 435.911 213.412 435.617 213.56C435.611 213.563 435.606 213.566 435.599 213.566L435.611 213.557L436.16 213.198C436.256 213.135 436.352 213.072 436.447 213.009C436.455 213.004 436.463 213 436.47 212.997C436.57 212.954 436.669 212.912 436.768 212.869C436.773 212.868 436.778 212.866 436.783 212.863L436.762 212.811C436.756 212.813 436.753 212.814 436.748 212.816C436.647 212.856 436.546 212.897 436.444 212.937C436.423 212.945 436.401 212.949 436.378 212.953L435.696 213.095C435.61 213.114 435.522 213.132 435.436 213.15C435.432 213.151 435.429 213.15 435.426 213.148C435.449 213.141 435.473 213.133 435.497 213.125C435.792 213.028 436.086 212.931 436.38 212.833C436.403 212.825 436.428 212.823 436.452 212.819C436.547 212.806 436.641 212.792 436.735 212.779C436.741 212.778 436.747 212.776 436.753 212.775C436.751 212.757 436.748 212.739 436.746 212.72L436.701 212.725L436.512 212.748C436.477 212.753 436.442 212.756 436.407 212.761C436.398 212.762 436.39 212.762 436.382 212.762L436.183 212.75L436.066 212.743L435.863 212.732L435.568 212.715C435.497 212.712 435.428 212.707 435.357 212.702C435.368 212.701 435.38 212.699 435.393 212.699L435.635 212.685L435.955 212.667L436.22 212.652L436.386 212.642C436.393 212.642 436.4 212.643 436.407 212.643L436.598 212.666L436.733 212.683H436.746C436.748 212.665 436.751 212.648 436.753 212.628C436.741 212.626 436.728 212.624 436.716 212.622C436.633 212.61 436.55 212.598 436.467 212.586C436.449 212.584 436.432 212.582 436.415 212.579C436.405 212.578 436.396 212.576 436.387 212.573C436.138 212.491 435.891 212.409 435.643 212.327C435.574 212.305 435.505 212.282 435.436 212.258C435.43 212.257 435.425 212.254 435.42 212.251L435.463 212.259L435.993 212.37C436.135 212.399 436.279 212.429 436.421 212.459C436.43 212.461 436.438 212.463 436.446 212.467C436.546 212.506 436.645 212.547 436.746 212.587L436.761 212.593C436.768 212.575 436.776 212.559 436.783 212.541C436.778 212.538 436.773 212.535 436.767 212.533C436.668 212.491 436.569 212.448 436.47 212.406C436.462 212.402 436.454 212.398 436.447 212.394C436.167 212.211 435.888 212.026 435.607 211.843C435.603 211.84 435.601 211.837 435.599 211.833L435.61 211.84C435.889 211.98 436.169 212.121 436.449 212.261C436.495 212.284 436.54 212.312 436.582 212.344C436.65 212.397 436.719 212.447 436.788 212.499C436.793 212.503 436.797 212.506 436.802 212.509L436.837 212.465L436.824 212.455L436.57 212.255C436.562 212.248 436.555 212.241 436.547 212.233C436.326 211.986 436.104 211.738 435.884 211.49C435.881 211.487 435.878 211.484 435.877 211.48C435.883 211.481 435.886 211.485 435.888 211.488C436.023 211.607 436.155 211.725 436.288 211.844L436.633 212.151C436.639 212.157 436.645 212.163 436.651 212.17L436.848 212.42C436.853 212.426 436.857 212.432 436.862 212.439L436.908 212.405C436.905 212.4 436.901 212.397 436.899 212.393C436.834 212.307 436.77 212.221 436.705 212.135C436.699 212.125 436.692 212.114 436.687 212.104C436.537 211.808 436.388 211.512 436.239 211.216C436.236 211.211 436.233 211.206 436.233 211.2C436.236 211.203 436.238 211.206 436.24 211.209L436.56 211.697L436.786 212.041C436.793 212.054 436.802 212.068 436.807 212.082C436.849 212.178 436.89 212.275 436.931 212.371C436.934 212.376 436.936 212.38 436.938 212.386L436.99 212.364L436.985 212.351C436.946 212.254 436.908 212.156 436.868 212.059C436.857 212.035 436.853 212.009 436.848 211.983C436.813 211.821 436.781 211.658 436.747 211.494C436.713 211.338 436.681 211.182 436.648 211.024C436.648 211.023 436.648 211.022 436.65 211.019L436.677 211.103C436.775 211.397 436.873 211.693 436.969 211.988C436.977 212.011 436.98 212.036 436.983 212.06C436.995 212.142 437.006 212.225 437.019 212.307C437.022 212.323 437.023 212.338 437.026 212.356L437.08 212.349V212.328C437.072 212.263 437.064 212.197 437.056 212.132C437.052 212.094 437.048 212.057 437.043 212.02C437.04 211.995 437.04 211.969 437.043 211.944C437.045 211.902 437.048 211.86 437.05 211.818L437.065 211.563C437.068 211.517 437.069 211.471 437.072 211.425C437.076 211.366 437.079 211.306 437.083 211.246C437.085 211.202 437.088 211.158 437.089 211.115C437.092 211.063 437.096 211.012 437.1 210.961C437.102 210.975 437.102 210.989 437.103 211.004C437.107 211.067 437.11 211.13 437.114 211.193L437.13 211.479L437.14 211.64C437.145 211.733 437.149 211.826 437.155 211.918C437.156 211.933 437.157 211.946 437.158 211.959C437.162 211.996 437.155 212.032 437.152 212.068L437.132 212.231C437.128 212.262 437.124 212.293 437.12 212.324C437.119 212.332 437.119 212.34 437.117 212.349C437.137 212.352 437.154 212.354 437.173 212.356C437.176 212.343 437.178 212.33 437.18 212.317C437.195 212.216 437.209 212.114 437.223 212.012C437.225 212.004 437.228 211.997 437.23 211.989C437.332 211.683 437.432 211.377 437.533 211.071C437.538 211.057 437.542 211.043 437.549 211.03C437.549 211.037 437.547 211.044 437.546 211.051C437.5 211.273 437.453 211.493 437.408 211.714C437.387 211.817 437.366 211.921 437.344 212.024C437.343 212.033 437.34 212.041 437.336 212.049L437.215 212.351C437.213 212.355 437.212 212.36 437.209 212.365C437.228 212.373 437.243 212.38 437.262 212.387L437.269 212.372L437.395 212.076C437.4 212.066 437.403 212.056 437.41 212.048L437.955 211.216C437.959 211.212 437.962 211.208 437.967 211.204C437.965 211.209 437.963 211.213 437.96 211.218L437.512 212.108C437.507 212.117 437.503 212.125 437.497 212.133C437.432 212.219 437.367 212.306 437.303 212.392C437.299 212.396 437.296 212.401 437.292 212.406L437.337 212.44C437.34 212.437 437.343 212.433 437.346 212.428C437.413 212.344 437.478 212.259 437.546 212.175C437.553 212.166 437.561 212.157 437.57 212.149C437.817 211.928 438.064 211.708 438.312 211.488C438.316 211.484 438.318 211.481 438.325 211.479L438.317 211.489C438.216 211.603 438.115 211.717 438.013 211.83C437.891 211.966 437.77 212.102 437.649 212.238C437.643 212.244 437.636 212.25 437.629 212.256L437.375 212.456L437.363 212.466C437.374 212.481 437.385 212.495 437.398 212.51L437.411 212.5L437.671 212.305C437.678 212.3 437.685 212.296 437.692 212.292C437.992 212.141 438.29 211.991 438.588 211.841C438.593 211.838 438.597 211.837 438.603 211.837C438.589 211.846 438.576 211.854 438.562 211.863C438.293 212.04 438.023 212.217 437.752 212.394C437.745 212.399 437.738 212.403 437.73 212.407C437.63 212.45 437.529 212.492 437.431 212.535L437.415 212.541C437.423 212.559 437.429 212.575 437.437 212.593L437.451 212.588C437.551 212.548 437.651 212.507 437.752 212.468C437.777 212.458 437.805 212.454 437.832 212.448L438.292 212.353C438.435 212.323 438.577 212.293 438.721 212.264C438.734 212.261 438.746 212.258 438.76 212.256C438.763 212.256 438.766 212.255 438.771 212.257L438.728 212.271C438.422 212.372 438.118 212.473 437.813 212.573C437.789 212.581 437.764 212.583 437.74 212.587C437.671 212.597 437.604 212.606 437.537 212.616C437.513 212.619 437.489 212.623 437.464 212.626L437.447 212.629C437.448 212.648 437.451 212.665 437.453 212.685L437.5 212.68L437.668 212.66C437.711 212.654 437.755 212.648 437.799 212.644C437.818 212.643 437.838 212.645 437.859 212.646C437.902 212.648 437.944 212.651 437.989 212.653L438.242 212.668C438.279 212.67 438.317 212.672 438.355 212.674L438.613 212.689C438.674 212.693 438.737 212.696 438.797 212.699C438.812 212.7 438.827 212.702 438.842 212.703L438.797 212.707L438.608 212.718L438.373 212.731L438.197 212.741C438.116 212.746 438.033 212.75 437.951 212.756C437.906 212.758 437.86 212.762 437.814 212.762C437.788 212.763 437.761 212.758 437.736 212.755C437.68 212.748 437.625 212.742 437.569 212.735L437.463 212.722H437.453C437.451 212.74 437.448 212.758 437.447 212.777C437.557 212.794 437.667 212.809 437.777 212.825C437.81 212.829 437.838 212.842 437.869 212.852L438.758 213.145C438.763 213.146 438.769 213.149 438.773 213.152C438.766 213.151 438.759 213.15 438.751 213.149L437.979 212.988L437.776 212.946C437.769 212.944 437.76 212.941 437.753 212.938C437.653 212.898 437.552 212.858 437.451 212.817L437.438 212.813C437.431 212.83 437.423 212.847 437.415 212.863L437.432 212.871C437.531 212.914 437.63 212.956 437.729 212.999C437.737 213.002 437.745 213.006 437.753 213.012L438.585 213.557C438.589 213.56 438.594 213.564 438.598 213.57C438.594 213.567 438.589 213.566 438.586 213.563L438.152 213.346C438.001 213.269 437.848 213.193 437.696 213.116C437.686 213.111 437.677 213.105 437.668 213.098C437.583 213.034 437.496 212.969 437.41 212.905C437.406 212.901 437.402 212.899 437.398 212.896C437.386 212.91 437.375 212.924 437.363 212.939L437.374 212.949C437.458 213.016 437.543 213.083 437.628 213.149C437.637 213.156 437.646 213.164 437.653 213.173L438.316 213.914C438.318 213.917 438.32 213.922 438.322 213.926C438.318 213.922 438.314 213.92 438.31 213.917C438.062 213.695 437.813 213.474 437.564 213.252C437.558 213.247 437.553 213.241 437.549 213.235L437.347 212.977C437.344 212.973 437.34 212.969 437.337 212.965C437.323 212.977 437.308 212.988 437.294 213C437.295 213.004 437.298 213.008 437.301 213.012L437.497 213.273C437.503 213.281 437.508 213.289 437.512 213.298C437.661 213.593 437.81 213.889 437.959 214.185C437.961 214.189 437.963 214.194 437.963 214.198H437.963V214.196Z",
    fill: "#010088"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.959 214.196C437.963 214.199 437.964 214.203 437.967 214.205C437.965 214.206 437.965 214.207 437.963 214.207C437.963 214.203 437.961 214.2 437.96 214.196H437.959Z",
    fill: "#010088"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M495 183.438C495 185.336 493.946 186.875 491.875 186.875H478.125C476.054 186.875 475 185.336 475 183.438V176.562C475 174.664 476.054 173.125 478.125 173.125H491.875C493.946 173.125 495 174.664 495 176.562V183.438Z",
    fill: "#137A08"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M482.169 183.897C484.351 183.897 486.12 182.128 486.12 179.947C486.12 177.765 484.351 175.996 482.169 175.996C479.988 175.996 478.219 177.765 478.219 179.947C478.219 182.128 479.988 183.897 482.169 183.897Z",
    fill: "#C32129"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M497.875 240.188H484.125C482.054 240.188 481 238.648 481 236.75V233.312H501V236.75C501 238.648 499.946 240.188 497.875 240.188Z",
    fill: "#E6E7E8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M481 229.875C481 227.977 482.054 226.438 484.125 226.438H497.875C499.946 226.438 501 227.977 501 229.875V233.312H481V229.875Z",
    fill: "#EC1C24"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M484.383 229.913C484.383 229.282 484.627 228.675 485.064 228.22C485.5 227.765 486.096 227.497 486.726 227.471C486.336 227.334 485.919 227.293 485.51 227.351C485.101 227.409 484.712 227.564 484.375 227.803C484.039 228.042 483.764 228.358 483.574 228.725C483.385 229.092 483.286 229.499 483.286 229.913C483.286 230.252 483.353 230.589 483.483 230.903C483.613 231.216 483.803 231.502 484.043 231.742C484.284 231.982 484.569 232.173 484.883 232.303C485.196 232.433 485.533 232.5 485.873 232.5C486.172 232.5 486.459 232.449 486.726 232.355C486.096 232.329 485.5 232.061 485.063 231.605C484.627 231.15 484.383 230.543 484.383 229.913Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M487.853 228.235L487.371 228.236L487.221 227.747L487.073 228.236L486.589 228.235L486.981 228.532L486.829 229.017L487.222 228.716L487.616 229.017L487.463 228.532L487.853 228.235ZM489.231 229.259H488.748L488.598 228.771L488.45 229.259H487.967L488.358 229.556L488.206 230.04L488.599 229.739L488.992 230.04L488.841 229.556L489.231 229.259ZM488.715 230.897H488.231L488.083 230.408L487.934 230.897H487.451L487.843 231.194L487.691 231.678L488.083 231.377L488.477 231.678L488.324 231.194L488.715 230.897ZM486.988 230.897H486.507L486.356 230.408L486.208 230.897H485.725L486.116 231.194L485.965 231.678L486.356 231.377L486.75 231.678L486.598 231.194L486.988 230.897ZM486.473 229.259H485.991L485.841 228.771L485.694 229.259H485.209L485.601 229.556L485.449 230.04L485.842 229.739L486.235 230.04L486.083 229.556L486.473 229.259Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M510.875 279.875H497.125C495.054 279.875 494 278.336 494 276.438V273H514V276.438C514 278.336 512.946 279.875 510.875 279.875Z",
    fill: "#E6E7E8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M494 269.562C494 267.664 495.054 266.125 497.125 266.125H510.875C512.946 266.125 514 267.664 514 269.562V273H494V269.562Z",
    fill: "#EC1C24"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M554.875 318.438H548V319.911L546.558 320.625H548V322.812H546.558L548 323.561V325H547.94L543.938 323.016V325H542.062V323.016L538.073 325H538V328.75C538 330.648 539.054 332.188 541.125 332.188H554.875C556.946 332.188 558 330.648 558 328.75V321.875C558 319.977 556.946 318.438 554.875 318.438Z",
    fill: "#2B3990"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M548 319.17V319.162L545.134 320.625L548 319.17Z",
    fill: "#4189DD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M538 322.812V323.572L539.464 322.812H538ZM538.379 320.088C538.296 320.261 538.227 320.441 538.173 320.625H539.464L538.379 320.088ZM548 318.441V318.438H543.938V320.531L548 318.441ZM542.062 320.531V318.438H541.125C540.306 318.438 539.649 318.681 539.151 319.089L542.062 320.531Z",
    fill: "#2B3990"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M548 320.938V320.625H546.558L548 319.911V319.17L545.134 320.625H544.185L548 318.677V318.441L543.938 320.531V318.438H543.625V320.938H548ZM543.625 325H543.938V323.016L547.94 325H548V324.287L545.134 322.812H546.084L548 323.803V323.561L546.558 322.812H548V322.5H543.625V325ZM542.062 323.016V325H542.375V322.5H538V322.812H539.464L538 323.572V324.291L540.888 322.812H541.838L538 324.775V325H538.073L542.062 323.016ZM539.151 319.091C538.986 319.225 538.84 319.378 538.71 319.547L540.888 320.627H539.938L538.471 319.907C538.439 319.967 538.408 320.028 538.379 320.089L539.464 320.627H538.173C538.143 320.728 538.117 320.832 538.095 320.939H542.375V318.439H542.062V320.533L539.151 319.091Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M542.375 325H543.625V322.5H548V321.042L543.625 321.25V318.438H542.375V321.25L538.071 321.065C538.024 321.333 538 321.604 538 321.875V322.5H542.375V325Z",
    fill: "#FF0000"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M543.625 321.25L548 321.042V320.937H543.625V321.25ZM538.071 321.065L542.375 321.25V320.937H538.095C538.086 320.98 538.079 321.022 538.071 321.065ZM540.888 320.625L538.708 319.547C538.621 319.661 538.541 319.781 538.471 319.906L539.938 320.625H540.888ZM538.71 319.545L538.708 319.547L540.888 320.625L538.71 319.545ZM545.134 320.625L548 319.162V318.677L544.185 320.625H545.134ZM545.134 322.812L548 324.276V323.803L546.084 322.812H545.134Z",
    fill: "#FF0000"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M548 324.287V324.276L545.134 322.812L548 324.287ZM540.888 322.812L538 324.298V324.775L541.838 322.812H540.888Z",
    fill: "#FF0000"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M538 324.291V324.298L540.888 322.812L538 324.291Z",
    fill: "#FF0000"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M542.607 327.925L543 326.725L543.384 327.925L544.551 327.475L543.861 328.519L544.947 329.159L543.691 329.269L543.862 330.517L543 329.606L542.134 330.517L542.301 329.269L541.054 329.166L542.13 328.522L541.437 327.475L542.607 327.925ZM552.674 328.346L552.828 327.872L552.981 328.346L553.441 328.169L553.169 328.581L553.598 328.834L553.103 328.878L553.169 329.37L552.828 329.011L552.488 329.37L552.553 328.878L552.06 328.834L552.484 328.581L552.213 328.169L552.674 328.346ZM550.03 324.174L550.185 323.7L550.337 324.174L550.798 323.997L550.525 324.409L550.954 324.662L550.458 324.706L550.525 325.199L550.185 324.839L549.843 325.199L549.909 324.706L549.416 324.664L549.842 324.409L549.569 323.997L550.03 324.174ZM555.025 323.475L555.179 323.001L555.331 323.475L555.792 323.297L555.519 323.71L555.95 323.963L555.452 324.006L555.519 324.499L555.179 324.141L554.837 324.499L554.903 324.006L554.409 323.964L554.836 323.711L554.562 323.297L555.025 323.475ZM553.963 325.501L554.038 325.265L554.114 325.501L554.344 325.412L554.209 325.619L554.422 325.745L554.175 325.767L554.209 326.012L554.038 325.833L553.868 326.012L553.901 325.767L553.653 325.746L553.867 325.619L553.731 325.412L553.963 325.501ZM552.674 321.297L552.828 320.823L552.981 321.297L553.441 321.119L553.169 321.532L553.598 321.785L553.103 321.828L553.169 322.322L552.828 321.962L552.488 322.322L552.553 321.828L552.06 321.787L552.484 321.533L552.213 321.119L552.674 321.297Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M96 146.438H106V160.188H96V146.438Z",
    fill: "#E6E7E8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M94.125 146.438C92.0541 146.438 91 147.977 91 149.875V156.75C91 158.648 92.0541 160.188 94.125 160.188H96V146.438H94.125ZM107.875 146.438H106V160.188H107.875C109.946 160.188 111 158.648 111 156.75V149.875C111 147.977 109.946 146.438 107.875 146.438Z",
    fill: "#EC1C24"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.831 153.2C104.688 153.136 104.664 153.09 104.707 152.932C104.813 152.538 104.922 152.144 105.029 151.75C105.038 151.718 105.046 151.685 105.058 151.638C104.926 151.664 104.802 151.688 104.678 151.715C104.428 151.768 104.179 151.822 103.93 151.875C103.767 151.909 103.692 151.863 103.646 151.702C103.602 151.55 103.559 151.397 103.49 151.223C103.474 151.249 103.462 151.279 103.442 151.301C103.156 151.624 102.868 151.946 102.581 152.269C102.492 152.367 102.392 152.41 102.322 152.371C102.22 152.313 102.223 152.21 102.24 152.114C102.316 151.695 102.395 151.277 102.473 150.858C102.53 150.554 102.587 150.251 102.646 149.934C102.617 149.946 102.597 149.951 102.579 149.96C102.417 150.044 102.257 150.129 102.095 150.211C101.896 150.311 101.796 150.278 101.692 150.086C101.472 149.678 101.255 149.271 101.036 148.863C101.024 148.843 101.017 148.823 101 148.798L100.964 148.863C100.745 149.271 100.527 149.678 100.308 150.086C100.204 150.278 100.103 150.311 99.9047 150.211C99.7425 150.129 99.5825 150.044 99.4206 149.96C99.4028 149.951 99.3828 149.946 99.3531 149.934C99.4119 150.251 99.4691 150.554 99.5262 150.858C99.6044 151.276 99.6834 151.694 99.7587 152.114C99.7762 152.21 99.7797 152.313 99.6769 152.371C99.6066 152.41 99.5078 152.367 99.4191 152.269C99.1309 151.946 98.8434 151.624 98.5575 151.301C98.5372 151.279 98.5253 151.249 98.5097 151.223C98.44 151.397 98.3972 151.55 98.3537 151.702C98.3075 151.863 98.2322 151.909 98.0697 151.875C97.82 151.822 97.5709 151.768 97.3209 151.715C97.1972 151.688 97.0734 151.664 96.9409 151.638C96.9531 151.685 96.9609 151.718 96.9703 151.75C97.0775 152.144 97.1866 152.538 97.2925 152.932C97.335 153.09 97.3109 153.136 97.1681 153.2C97.0359 153.26 96.9041 153.324 96.7644 153.389C96.7894 153.412 96.8034 153.425 96.8191 153.438C97.1516 153.708 97.4841 153.978 97.8172 154.249C98.1394 154.511 98.4603 154.772 98.7828 155.033C98.8956 155.124 98.9328 155.235 98.8862 155.373C98.86 155.454 98.8366 155.535 98.8122 155.617C98.7828 155.713 98.7541 155.809 98.7216 155.919C99.0412 155.874 99.3431 155.832 99.6472 155.789C100.004 155.74 100.36 155.69 100.717 155.645C100.84 155.629 100.931 155.723 100.926 155.844C100.899 156.489 100.837 157.217 100.832 157.827H101.167C101.162 157.217 101.101 156.489 101.074 155.844C101.068 155.723 101.159 155.629 101.282 155.645C101.639 155.69 101.996 155.74 102.352 155.789C102.656 155.832 102.958 155.874 103.278 155.919C103.245 155.809 103.217 155.713 103.187 155.617C103.163 155.535 103.139 155.454 103.113 155.373C103.067 155.235 103.104 155.124 103.217 155.033C103.539 154.772 103.86 154.511 104.182 154.249C104.515 153.978 104.848 153.708 105.18 153.438C105.196 153.425 105.21 153.412 105.235 153.389C105.095 153.323 104.964 153.26 104.831 153.2Z",
    fill: "#EC1C24"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 369.179,
    y: 167.75,
    width: 19.6429,
    height: 13.9286,
    rx: 1.25,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.357143
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 369,
    y: 167,
    width: 20,
    height: 15
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 369.179,
    y: 167.75,
    width: 19.6429,
    height: 13.9286,
    rx: 1.25,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.357143
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.714 172.333H389V167.571H374.714V172.333Z",
    fill: "#12833B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.714 181.857H389V177.095H374.714V181.857Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369 181.857H374.714V167.571H369V181.857Z",
    fill: "#FF323E"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 274.571,
    width: 20,
    height: 14.2857,
    rx: 1.42857,
    fill: "#06A86E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 274,
    width: 20,
    height: 15
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 274.571,
    width: 20,
    height: 14.2857,
    rx: 1.42857,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332 276.476L338.667 281.714L332 286.952V276.476Z",
    fill: "#FFBF2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.048 276.714L337.476 281.714L331.048 286.714V276.714Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.571 280.286L333.905 274.571H352V280.286H340.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.81 279.333L335.095 274.571H352V279.333H340.81Z",
    fill: "#F44E46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.905 288.857H352V283.143H340.571L333.905 288.857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.095 288.857H352V284.095H340.81L335.095 288.857Z",
    fill: "#072CB4"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M339 219.812H359V224.188H339V219.812Z",
    fill: "#E6E7E8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M355.875 215.125H342.125C340.054 215.125 339 216.664 339 218.562V219.812H359V218.562C359 216.664 357.946 215.125 355.875 215.125Z",
    fill: "#EC1C24"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M339 225.438C339 227.336 340.054 228.875 342.125 228.875H355.875C357.946 228.875 359 227.336 359 225.438V224.188H339V225.438Z",
    fill: "#25333A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.451 220.878C350.482 221.158 350.481 221.438 350.495 221.719C350.52 222.257 350.54 222.797 350.562 223.336V223.433C350.397 223.278 350.247 223.138 350.097 222.996C350.093 222.982 350.1 222.972 350.11 222.962C350.137 222.932 350.127 222.895 350.125 222.862C350.11 222.629 350.106 222.396 350.093 222.162C350.077 221.824 350.067 221.488 350.047 221.15C350.042 221.047 350.075 220.972 350.164 220.92C350.22 220.887 350.258 220.901 350.26 220.966C350.265 221.092 350.269 221.218 350.276 221.345C350.296 221.709 350.307 222.074 350.324 222.438C350.332 222.607 350.349 222.775 350.343 222.943C350.342 222.994 350.345 223.043 350.352 223.073C350.327 222.968 350.347 222.841 350.337 222.715C350.319 222.5 350.315 222.285 350.306 222.069C350.292 221.701 350.271 221.335 350.261 220.967C350.258 220.85 350.283 220.834 350.398 220.875C350.415 220.878 350.434 220.867 350.451 220.878ZM348.004 223.058C347.875 223.179 347.744 223.299 347.606 223.427C347.606 223.311 347.602 223.211 347.606 223.11C347.634 222.436 347.663 221.761 347.692 221.086C347.695 221.016 347.703 220.947 347.709 220.877C347.727 220.87 347.74 220.897 347.76 220.883C347.778 220.87 347.798 220.86 347.821 220.856C347.872 220.847 347.901 220.872 347.901 220.924C347.901 221.084 347.89 221.243 347.882 221.401C347.877 221.524 347.868 221.648 347.865 221.772C347.857 222.051 347.841 222.329 347.831 222.606C347.824 222.761 347.821 222.917 347.812 223.07C347.824 222.926 347.824 222.778 347.83 222.633C347.85 222.164 347.871 221.695 347.892 221.226C347.895 221.143 347.904 221.058 347.901 220.973C347.899 220.945 347.904 220.916 347.934 220.905C347.96 220.893 347.98 220.912 348.002 220.924C348.085 220.973 348.117 221.044 348.113 221.142C348.094 221.539 348.077 221.936 348.061 222.333C348.053 222.511 348.055 222.691 348.034 222.87C348.028 222.932 348.011 222.994 348.004 223.058Z",
    fill: "#BF9200"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.004 223.058C347.983 223 347.982 222.937 348.002 222.878C348.012 222.876 348.029 222.905 348.034 222.873C348.036 222.845 348.044 222.819 348.044 222.792C348.044 222.61 348.057 222.429 348.066 222.248C348.078 221.991 348.084 221.732 348.102 221.475C348.109 221.389 348.108 221.301 348.11 221.215C348.111 221.168 348.109 221.111 348.165 221.097C348.221 221.084 348.254 221.13 348.285 221.171C348.303 221.196 348.305 221.226 348.303 221.257C348.286 221.502 348.283 221.747 348.271 221.993C348.26 222.231 348.252 222.469 348.24 222.708C348.257 222.356 348.272 222.004 348.286 221.651C348.289 221.54 348.298 221.429 348.301 221.317C348.303 221.228 348.327 221.211 348.417 221.219C348.46 221.224 348.5 221.232 348.543 221.235C348.563 221.242 348.585 221.249 348.591 221.273C348.582 221.305 348.553 221.302 348.531 221.302C348.481 221.306 348.464 221.335 348.478 221.377C348.494 221.422 348.488 221.469 348.49 221.514C348.488 221.556 348.487 221.597 348.483 221.638C348.473 221.729 348.468 221.82 348.467 221.911C348.466 222.076 348.45 222.242 348.446 222.406C348.43 222.467 348.426 222.53 348.435 222.592C348.439 222.612 348.445 222.632 348.45 222.652C348.454 222.682 348.442 222.709 348.426 222.732C348.418 222.741 348.408 222.748 348.397 222.752C348.387 222.757 348.375 222.759 348.363 222.759C348.333 222.754 348.32 222.779 348.302 222.794L348.004 223.058ZM350.112 222.984C350.107 222.989 350.102 222.992 350.097 222.997C350.032 222.937 349.967 222.878 349.903 222.817C349.899 222.803 349.905 222.792 349.912 222.782C349.918 222.77 349.917 222.758 349.917 222.745C349.912 222.377 349.892 222.011 349.874 221.644C349.867 221.511 349.872 221.376 349.857 221.243C349.854 221.22 349.859 221.197 349.872 221.177C349.902 221.135 349.936 221.085 349.995 221.099C350.051 221.113 350.049 221.171 350.05 221.217C350.06 221.624 350.085 222.031 350.103 222.437C350.109 222.583 350.103 222.731 350.125 222.876C350.129 222.911 350.135 222.95 350.112 222.984ZM349.914 223.208C349.921 223.267 349.945 223.281 350.006 223.263C350.102 223.236 350.235 223.301 350.216 223.422C350.212 223.456 350.22 223.477 350.253 223.493C350.302 223.516 350.32 223.58 350.38 223.591C350.389 223.593 350.393 223.611 350.386 223.617C350.329 223.649 350.346 223.728 350.293 223.764C350.286 223.769 350.275 223.779 350.274 223.787C350.271 223.895 350.191 223.914 350.107 223.932C349.713 224.018 349.313 224.026 348.912 224.018C348.617 224.013 348.322 223.997 348.032 223.926C347.956 223.908 347.908 223.88 347.882 223.795C347.861 223.736 347.83 223.681 347.79 223.632C347.767 223.604 347.773 223.601 347.799 223.58C347.864 223.527 347.954 223.494 347.949 223.378C347.945 223.294 348.062 223.232 348.155 223.263C348.215 223.282 348.24 223.268 348.247 223.208C348.267 223.204 348.274 223.218 348.282 223.232C348.292 223.255 348.29 223.277 348.287 223.301C348.283 223.312 348.276 223.321 348.266 223.326C348.237 223.34 348.208 223.332 348.181 223.324C348.161 223.317 348.136 223.308 348.118 223.329C348.096 223.357 348.13 223.365 348.139 223.382C348.144 223.391 348.146 223.401 348.145 223.41C348.141 223.427 348.127 223.435 348.114 223.443C348.069 223.453 348.031 223.473 348.011 223.52C348.002 223.542 347.978 223.554 347.957 223.569C347.895 223.612 347.889 223.646 347.935 223.703C347.943 223.715 347.957 223.726 347.96 223.74C347.978 223.832 348.05 223.847 348.126 223.862C348.382 223.912 348.642 223.933 348.903 223.935C349.137 223.937 349.37 223.942 349.603 223.92C349.769 223.905 349.934 223.888 350.096 223.847C350.143 223.835 350.178 223.817 350.19 223.765C350.195 223.741 350.213 223.721 350.228 223.701C350.269 223.65 350.267 223.612 350.216 223.575C350.181 223.555 350.152 223.526 350.132 223.492C350.112 223.451 350.073 223.457 350.034 223.462C349.929 223.48 349.827 223.51 349.722 223.531C349.709 223.529 349.7 223.521 349.692 223.509C349.685 223.498 349.68 223.485 349.679 223.472C349.679 223.459 349.681 223.445 349.687 223.433C349.692 223.422 349.702 223.414 349.713 223.409C349.826 223.455 349.922 223.381 350.028 223.368C350.043 223.366 350.051 223.355 350.05 223.342C350.044 223.321 350.028 223.316 350.008 223.318C349.972 223.322 349.937 223.344 349.899 223.329C349.889 223.323 349.881 223.314 349.876 223.304C349.87 223.28 349.872 223.256 349.88 223.233C349.887 223.219 349.894 223.204 349.916 223.208",
    fill: "#BF9200"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.918 222.803L349.903 222.815C349.857 222.795 349.835 222.742 349.784 222.729C349.779 222.733 349.773 222.736 349.767 222.737C349.76 222.738 349.754 222.738 349.747 222.735C349.718 222.716 349.708 222.69 349.71 222.657C349.712 222.636 349.721 222.617 349.724 222.596C349.734 222.535 349.731 222.474 349.715 222.415C349.709 222.235 349.692 222.057 349.692 221.876C349.692 221.816 349.7 221.753 349.665 221.698C349.652 221.689 349.642 221.677 349.637 221.663C349.65 221.574 349.668 221.485 349.679 221.394C349.687 221.32 349.69 221.316 349.617 221.302C349.597 221.299 349.577 221.299 349.569 221.275C349.575 221.25 349.598 221.243 349.618 221.235C349.665 221.231 349.711 221.222 349.758 221.217C349.828 221.21 349.855 221.231 349.859 221.302C349.866 221.444 349.87 221.585 349.876 221.727C349.895 222.078 349.903 222.431 349.924 222.782C349.924 222.79 349.92 222.797 349.918 222.803Z",
    fill: "#BF9200"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.755 222.728C349.765 222.728 349.775 222.729 349.784 222.729L349.843 222.966C349.852 222.98 349.851 222.992 349.835 223.001C349.823 223.007 349.808 222.985 349.797 223.007C349.747 223.106 349.766 223.197 349.857 223.267C349.869 223.275 349.882 223.282 349.887 223.298C349.893 223.303 349.899 223.308 349.905 223.312C349.904 223.347 349.875 223.349 349.854 223.355C349.799 223.366 349.747 223.384 349.69 223.38C349.671 223.38 349.651 223.384 349.633 223.392C349.521 223.414 349.408 223.413 349.296 223.409C349.276 223.408 349.253 223.406 349.247 223.432C349.241 223.457 349.262 223.465 349.281 223.471C349.331 223.488 349.383 223.481 349.434 223.484C349.462 223.486 349.493 223.476 349.515 223.504C349.519 223.543 349.488 223.545 349.462 223.55C349.43 223.554 349.398 223.555 349.366 223.552C349.301 223.548 349.243 223.56 349.195 223.608C349.189 223.615 349.181 223.621 349.172 223.624C349.121 223.642 349.078 223.585 349.014 223.623C348.975 223.646 348.915 223.576 348.886 223.523C348.883 223.512 348.882 223.501 348.884 223.49C348.889 223.466 348.929 223.456 348.914 223.427C348.898 223.397 348.864 223.412 348.839 223.409C348.784 223.403 348.725 223.434 348.675 223.391C348.673 223.341 348.723 223.348 348.746 223.323C348.76 223.311 348.777 223.305 348.795 223.303C348.806 223.303 348.816 223.308 348.825 223.314C348.833 223.323 348.843 223.333 348.855 223.332C348.933 223.324 348.996 223.351 349.054 223.398C349.069 223.41 349.086 223.415 349.102 223.401C349.164 223.353 349.233 223.325 349.315 223.331C349.323 223.331 349.33 223.32 349.338 223.314C349.346 223.307 349.356 223.303 349.367 223.302C349.422 223.323 349.46 223.321 349.488 223.255C349.513 223.196 349.546 223.202 349.617 223.265C349.667 223.196 349.667 223.181 349.607 223.093C349.572 223.121 349.573 223.188 349.515 223.188C349.462 223.188 349.45 223.132 349.419 223.103C349.39 223.136 349.413 223.203 349.347 223.212C349.317 223.192 349.314 223.162 349.319 223.13C349.343 223.063 349.339 222.995 349.332 222.927C349.334 222.915 349.339 222.905 349.346 222.896C349.379 222.857 349.371 222.807 349.383 222.762C349.393 222.724 349.392 222.67 349.446 222.665C349.494 222.662 349.516 222.708 349.539 222.743C349.545 222.751 349.549 222.762 349.551 222.773C349.547 222.743 349.561 222.704 349.582 222.67C349.61 222.625 349.662 222.629 349.7 222.677C349.715 222.696 349.722 222.727 349.755 222.728Z",
    fill: "#BF9200"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.781 223.356C348.751 223.384 348.708 223.36 348.676 223.383C348.632 223.435 348.582 223.389 348.535 223.393C348.513 223.389 348.495 223.378 348.473 223.38C348.416 223.384 348.362 223.366 348.307 223.355C348.286 223.349 348.257 223.347 348.255 223.312C348.261 223.308 348.267 223.303 348.273 223.298C348.278 223.282 348.291 223.276 348.303 223.267C348.393 223.197 348.414 223.106 348.364 223.008C348.352 222.987 348.337 223.007 348.325 223.002C348.309 222.993 348.309 222.98 348.317 222.966C348.324 222.895 348.363 222.831 348.363 222.759C348.367 222.751 348.372 222.744 348.38 222.738C348.387 222.733 348.396 222.73 348.405 222.728C348.427 222.728 348.44 222.714 348.45 222.695C348.469 222.661 348.496 222.634 348.538 222.639C348.58 222.645 348.587 222.684 348.6 222.716C348.603 222.724 348.603 222.735 348.611 222.742C348.617 222.743 348.619 222.741 348.623 222.736C348.65 222.706 348.67 222.655 348.719 222.666C348.776 222.679 348.77 222.738 348.78 222.782C348.788 222.818 348.786 222.857 348.82 222.882C348.828 222.889 348.834 222.899 348.836 222.909C348.822 222.987 348.812 223.062 348.849 223.137C348.851 223.166 348.844 223.19 348.82 223.208C348.745 223.211 348.773 223.134 348.741 223.103C348.652 223.22 348.638 223.22 348.557 223.097C348.497 223.164 348.495 223.179 348.537 223.264C348.56 223.265 348.567 223.241 348.582 223.23C348.614 223.208 348.649 223.207 348.665 223.241C348.688 223.298 348.735 223.325 348.781 223.356ZM348.868 220.587C348.882 220.498 348.906 220.411 348.901 220.321C348.9 220.291 348.892 220.261 348.877 220.236C348.862 220.21 348.841 220.188 348.816 220.172C348.801 220.164 348.784 220.159 348.767 220.16C348.74 220.157 348.707 220.216 348.69 220.157C348.683 220.134 348.682 220.11 348.688 220.087C348.695 220.064 348.707 220.043 348.725 220.027C348.734 220.018 348.747 220.01 348.758 220.011C348.907 220.021 349.057 219.963 349.205 220.028C349.283 220.063 349.331 220.113 349.336 220.2C349.342 220.215 349.345 220.229 349.328 220.238C349.304 220.238 349.292 220.221 349.284 220.203C349.258 220.138 349.203 220.133 349.156 220.161C349.059 220.22 348.986 220.181 348.915 220.12C348.886 220.096 348.852 220.078 348.817 220.067C348.882 220.083 348.935 220.128 348.983 220.177C349.017 220.21 349.029 220.248 348.987 220.293C348.938 220.346 348.967 220.421 348.947 220.483C348.931 220.53 348.943 220.59 348.879 220.613C348.867 220.608 348.862 220.599 348.868 220.587ZM349.437 220.878C349.451 220.914 349.483 220.907 349.512 220.906C349.647 220.901 349.766 220.847 349.883 220.786C349.896 220.778 349.903 220.784 349.908 220.796C349.907 220.837 349.874 220.855 349.844 220.872C349.795 220.9 349.742 220.922 349.687 220.936C349.621 220.955 349.557 220.983 349.494 221.001C349.408 221.027 349.309 221.079 349.212 221.016C349.186 221 349.16 220.996 349.129 221.015C349.057 221.06 349.015 221.038 348.995 220.95C348.996 220.945 348.999 220.94 349.002 220.936C349.006 220.932 349.01 220.928 349.015 220.926C349.107 220.924 349.109 220.923 349.108 220.824C349.108 220.799 349.104 220.774 349.107 220.75C349.116 220.702 349.118 220.654 349.118 220.606C349.117 220.579 349.112 220.552 349.138 220.533C349.188 220.531 349.182 220.569 349.185 220.599C349.19 220.683 349.182 220.767 349.201 220.851C349.207 220.885 349.219 220.912 349.264 220.93C349.227 220.83 349.202 220.726 349.19 220.62C349.188 220.598 349.184 220.576 349.185 220.554C349.186 220.523 349.188 220.487 349.227 220.487C349.258 220.486 349.272 220.517 349.274 220.546C349.277 220.585 349.287 220.623 349.292 220.663C349.298 220.73 349.313 220.795 349.341 220.856C349.353 220.882 349.367 220.917 349.407 220.885C349.416 220.878 349.425 220.873 349.437 220.878Z",
    fill: "#BF9200"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.868 220.587C348.873 220.594 348.877 220.601 348.883 220.607C348.915 220.639 348.894 220.673 348.884 220.704C348.862 220.776 348.816 220.837 348.779 220.903C348.829 220.891 348.849 220.852 348.864 220.81C348.892 220.734 348.92 220.657 348.931 220.573C348.932 220.567 348.931 220.559 348.933 220.553C348.949 220.521 348.941 220.464 348.991 220.469C349.047 220.474 349.022 220.526 349.02 220.559C349.012 220.691 348.973 220.819 348.907 220.933C348.898 220.948 348.889 220.962 348.888 220.98C348.871 220.995 348.871 221.014 348.876 221.035C348.848 221.068 348.819 221.08 348.797 221.034C348.782 221.003 348.763 221.012 348.741 221.018C348.697 221.029 348.658 221.023 348.628 220.985C348.607 220.96 348.577 220.956 348.547 220.952C348.468 220.941 348.392 220.914 348.323 220.874C348.291 220.858 348.255 220.841 348.252 220.796C348.257 220.784 348.264 220.777 348.277 220.786C348.391 220.846 348.507 220.897 348.639 220.907C348.683 220.91 348.711 220.898 348.736 220.859C348.79 220.772 348.831 220.681 348.868 220.587Z",
    fill: "#BF9200"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.277 220.784C348.271 220.788 348.265 220.793 348.258 220.798C348.226 220.823 348.197 220.805 348.168 220.792C348.103 220.762 348.033 220.742 347.962 220.733C347.877 220.722 347.815 220.762 347.781 220.841C347.768 220.873 347.752 220.906 347.735 220.935C347.701 220.927 347.731 220.89 347.709 220.876C347.741 220.72 347.833 220.654 347.989 220.676C348.093 220.69 348.189 220.726 348.277 220.784ZM349.902 220.8C349.896 220.795 349.89 220.79 349.883 220.786C349.98 220.722 350.086 220.684 350.2 220.673C350.334 220.66 350.422 220.733 350.451 220.878L350.437 220.926C350.399 220.912 350.393 220.873 350.38 220.843C350.344 220.762 350.279 220.722 350.191 220.735C350.122 220.745 350.055 220.765 349.992 220.794C349.963 220.807 349.934 220.825 349.902 220.8ZM349.437 220.878C349.431 220.883 349.426 220.889 349.422 220.896C349.385 220.895 349.371 220.87 349.361 220.841C349.327 220.761 349.309 220.676 349.307 220.59C349.314 220.561 349.323 220.531 349.352 220.514C349.371 220.637 349.386 220.761 349.437 220.878Z",
    fill: "#BF9200"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.353 220.516C349.347 220.541 349.356 220.57 349.337 220.594C349.292 220.542 349.282 220.29 349.323 220.236C349.327 220.224 349.332 220.213 349.337 220.201C349.367 220.305 349.354 220.41 349.353 220.517M348.317 222.966C348.322 222.975 348.326 222.986 348.33 222.997C348.372 223.054 348.345 223.096 348.301 223.135C348.276 223.137 348.284 223.112 348.275 223.102C348.287 223.056 348.294 223.008 348.317 222.966ZM349.83 222.997C349.834 222.987 349.838 222.976 349.843 222.966C349.866 223.008 349.874 223.056 349.885 223.103C349.876 223.112 349.885 223.137 349.859 223.135C349.815 223.097 349.788 223.054 349.83 222.997Z",
    fill: "#BF9200"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.275 223.103C348.281 223.113 348.285 223.124 348.291 223.136C348.32 223.181 348.317 223.218 348.26 223.238C348.255 223.228 348.251 223.218 348.246 223.208C348.256 223.173 348.266 223.138 348.275 223.103ZM349.87 223.136C349.875 223.124 349.879 223.113 349.885 223.103C349.894 223.138 349.904 223.173 349.914 223.208C349.909 223.218 349.906 223.228 349.901 223.239C349.843 223.218 349.84 223.182 349.87 223.136ZM348.496 221.731C348.477 221.699 348.474 221.663 348.467 221.628C348.444 221.59 348.464 221.554 348.469 221.517C348.483 221.582 348.497 221.648 348.511 221.714C348.506 221.72 348.506 221.731 348.496 221.731ZM348.434 222.533C348.441 222.518 348.446 222.503 348.452 222.488C348.465 222.494 348.457 222.51 348.465 222.518C348.456 222.564 348.447 222.613 348.424 222.655C348.419 222.639 348.416 222.622 348.411 222.605C348.422 222.582 348.407 222.55 348.434 222.533ZM348.677 221.262C348.646 221.266 348.616 221.272 348.587 221.277C348.571 221.272 348.554 221.268 348.539 221.263C348.572 221.25 348.606 221.25 348.641 221.248C348.656 221.245 348.673 221.233 348.677 221.262ZM348.137 223.403C348.195 223.416 348.255 223.422 348.309 223.443C348.399 223.476 348.444 223.433 348.476 223.358C348.495 223.356 348.511 223.358 348.526 223.37C348.547 223.386 348.577 223.39 348.583 223.422C348.591 223.463 348.622 223.473 348.659 223.468C348.733 223.478 348.806 223.488 348.881 223.48C348.885 223.481 348.889 223.482 348.892 223.484C348.895 223.487 348.898 223.489 348.9 223.493V223.518C348.816 223.529 348.731 223.529 348.647 223.519C348.569 223.509 348.517 223.532 348.485 223.618C348.461 223.483 348.362 223.474 348.263 223.458C348.209 223.45 348.155 223.442 348.106 223.416C348.117 223.413 348.127 223.408 348.137 223.403ZM349.684 223.359C349.679 223.39 349.72 223.391 349.722 223.417L349.708 223.433C349.692 223.446 349.66 223.445 349.661 223.474C349.664 223.498 349.693 223.493 349.707 223.505L349.722 223.521C349.707 223.55 349.691 223.579 349.671 223.619C349.644 223.536 349.591 223.506 349.514 223.52C349.459 223.495 349.402 223.513 349.347 223.508C349.317 223.506 349.287 223.513 349.261 223.494C349.309 223.445 349.372 223.47 349.427 223.469C349.495 223.466 349.56 223.481 349.591 223.399C349.596 223.384 349.62 223.382 349.634 223.372C349.648 223.358 349.666 223.356 349.684 223.359ZM349.697 222.518C349.69 222.496 349.684 222.474 349.677 222.452C349.664 222.442 349.65 222.435 349.642 222.42C349.592 222.304 349.558 222.181 349.543 222.055C349.542 222.04 349.545 222.026 349.541 222.011C349.582 221.898 349.639 221.79 349.654 221.668C349.661 221.674 349.669 221.678 349.677 221.683C349.702 221.748 349.69 221.817 349.693 221.885C349.7 222.084 349.702 222.284 349.729 222.481C349.725 222.5 349.722 222.519 349.697 222.518ZM349.575 221.278C349.517 221.278 349.464 221.261 349.409 221.248C349.411 221.218 349.43 221.23 349.445 221.233C349.503 221.243 349.563 221.253 349.621 221.262C349.606 221.268 349.59 221.273 349.575 221.278Z",
    fill: "#BF9200"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.709 222.488C349.715 222.503 349.721 222.518 349.727 222.533C349.755 222.55 349.739 222.582 349.751 222.606C349.746 222.622 349.742 222.639 349.738 222.656C349.714 222.613 349.707 222.566 349.697 222.518C349.7 222.508 349.705 222.499 349.709 222.488ZM349.35 222.534C349.307 222.618 349.258 222.701 349.29 222.801C349.298 222.814 349.289 222.829 349.292 222.842C349.317 222.936 349.343 223.031 349.348 223.13C349.342 223.156 349.343 223.185 349.351 223.211C349.389 223.238 349.401 223.272 349.364 223.31C349.36 223.315 349.355 223.321 349.351 223.326C349.326 223.329 349.304 223.343 349.279 223.341C349.229 223.334 349.184 223.316 349.18 223.26C349.173 223.183 349.162 223.105 349.155 223.028C349.155 222.981 349.146 222.935 349.144 222.888C349.139 222.871 349.142 222.852 349.135 222.837C349.137 222.842 349.138 222.847 349.139 222.852C349.139 222.872 349.146 222.889 349.147 222.909C349.156 222.974 349.146 223.043 349.168 223.108C349.167 223.157 349.179 223.206 349.177 223.257C349.176 223.323 349.13 223.373 349.077 223.371C349.026 223.369 348.984 223.319 348.983 223.257C348.982 223.203 348.991 223.148 348.995 223.095C349.012 223.034 349.007 222.971 349.013 222.909C349.016 222.876 349.031 222.844 349.027 222.81C349.029 222.841 349.02 222.87 349.014 222.899C349.017 222.942 349.004 222.984 349.006 223.027C348.996 223.102 348.987 223.177 348.982 223.253C348.978 223.307 348.931 223.342 348.874 223.341C348.851 223.34 348.832 223.328 348.81 223.327L348.796 223.31C348.76 223.272 348.771 223.239 348.809 223.211C348.815 223.186 348.82 223.158 348.827 223.132C348.821 223.066 348.818 222.999 348.845 222.935C348.851 222.917 348.845 222.907 348.824 222.908C348.82 222.903 348.815 222.897 348.812 222.892C348.837 222.852 348.862 222.812 348.888 222.774C348.9 222.745 348.907 222.714 348.908 222.683C348.909 222.63 348.915 222.577 348.936 222.527C348.944 222.508 348.959 222.493 348.977 222.485C349.08 222.56 349.08 222.56 349.184 222.483C349.201 222.493 349.215 222.506 349.224 222.523C349.239 222.561 349.248 222.601 349.251 222.641C349.251 222.585 349.269 222.53 349.301 222.483C349.309 222.474 349.319 222.469 349.331 222.467C349.358 222.472 349.372 222.487 349.373 222.515C349.37 222.527 349.364 222.537 349.35 222.534Z",
    fill: "#BF9200"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.347 222.925C349.322 222.893 349.298 222.862 349.273 222.831C349.279 222.82 349.284 222.811 349.29 222.801C349.319 222.834 349.342 222.87 349.361 222.908L349.347 222.925ZM348.96 220.933C349.02 220.866 349.02 220.779 349.033 220.697C349.047 220.619 349.052 220.541 349.06 220.459C349.092 220.47 349.083 220.489 349.082 220.503C349.074 220.63 349.062 220.756 349.025 220.878C349.02 220.897 349.012 220.916 349.02 220.936C349.014 220.942 349.01 220.947 349.005 220.952H348.976C348.96 220.956 348.956 220.949 348.96 220.933ZM349.139 220.781C349.117 220.68 349.129 220.579 349.124 220.469C349.165 220.491 349.151 220.515 349.152 220.535C349.126 220.616 349.147 220.7 349.139 220.781Z",
    fill: "#BF9200"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.96 220.933C348.965 220.94 348.971 220.946 348.977 220.952C348.946 220.983 348.911 221.007 348.87 221.024C348.851 221.01 348.852 220.996 348.87 220.983C348.908 220.98 348.931 220.951 348.96 220.933ZM348.677 221.262C348.665 221.258 348.653 221.253 348.641 221.248C348.731 221.223 348.82 221.198 348.911 221.173C348.926 221.167 348.931 221.173 348.931 221.188C348.849 221.222 348.764 221.247 348.677 221.262ZM349.284 221.208C349.225 221.196 349.17 221.169 349.123 221.131C349.125 221.121 349.133 221.121 349.14 221.118L349.304 221.191C349.305 221.207 349.301 221.215 349.284 221.208Z",
    fill: "#BF9200"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.931 221.187C348.924 221.182 348.917 221.177 348.911 221.173L349.051 221.102C349.054 221.103 349.057 221.105 349.06 221.107C349.062 221.109 349.065 221.112 349.066 221.116C349.027 221.153 348.979 221.171 348.931 221.187ZM349.284 221.208L349.304 221.192C349.35 221.205 349.398 221.22 349.444 221.233C349.433 221.238 349.421 221.243 349.409 221.248C349.366 221.238 349.322 221.23 349.284 221.208Z",
    fill: "#BF9200"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.066 221.116C349.06 221.111 349.056 221.106 349.051 221.102C349.092 221.045 349.111 221.1 349.139 221.118L349.123 221.131C349.105 221.125 349.091 221.1 349.066 221.116ZM349.274 222.334C349.289 222.287 349.292 222.24 349.292 222.191C349.291 221.909 349.292 221.628 349.291 221.346C349.291 221.318 349.304 221.287 349.274 221.263C349.27 221.261 349.269 221.259 349.27 221.256C349.272 221.253 349.273 221.252 349.274 221.252C349.393 221.276 349.509 221.316 349.632 221.316C349.665 221.316 349.666 221.337 349.665 221.361C349.65 221.732 349.528 222.06 349.274 222.334ZM348.884 221.262C348.849 221.269 348.855 221.298 348.855 221.32C348.855 221.625 348.856 221.93 348.853 222.234C348.853 222.265 348.875 222.289 348.872 222.319C348.672 222.103 348.562 221.844 348.513 221.558C348.502 221.493 348.501 221.425 348.495 221.358C348.492 221.327 348.503 221.314 348.536 221.314C348.651 221.311 348.76 221.277 348.87 221.249C348.886 221.241 348.887 221.25 348.884 221.262ZM348.466 222.518C348.462 222.508 348.458 222.498 348.453 222.488C348.503 222.238 348.498 221.984 348.497 221.731L348.512 221.714C348.548 221.813 348.584 221.911 348.62 222.009C348.628 222.024 348.62 222.038 348.622 222.053C348.604 222.18 348.572 222.303 348.521 222.42C348.514 222.435 348.499 222.442 348.487 222.451C348.479 222.474 348.473 222.497 348.466 222.518ZM349.35 222.534C349.355 222.529 349.359 222.523 349.364 222.518C349.424 222.498 349.405 222.449 349.405 222.408C349.403 222.365 349.371 222.367 349.341 222.364C349.336 222.363 349.331 222.36 349.328 222.356C349.324 222.351 349.322 222.346 349.322 222.341C349.401 222.236 349.475 222.126 349.539 222.011C349.545 222.02 349.551 222.03 349.558 222.04C349.537 222.118 349.523 222.199 349.516 222.28C349.508 222.388 349.557 222.43 349.659 222.411C349.665 222.423 349.67 222.438 349.675 222.452C349.62 222.543 349.62 222.543 349.538 222.463C349.52 222.446 349.502 222.43 349.474 222.404L349.44 222.659L349.35 222.534Z",
    fill: "#BF9200"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.485 222.451L348.501 222.411C348.57 222.439 348.612 222.402 348.647 222.35C348.664 222.329 348.671 222.301 348.697 222.288C348.716 222.285 348.737 222.286 348.752 222.268C348.756 222.265 348.761 222.264 348.766 222.263C348.771 222.263 348.776 222.264 348.78 222.267C348.796 222.286 348.817 222.3 348.822 222.327C348.822 222.333 348.82 222.34 348.815 222.345C348.793 222.361 348.759 222.362 348.749 222.393C348.732 222.412 348.731 222.447 348.695 222.444C348.687 222.434 348.699 222.393 348.665 222.424C348.638 222.446 348.613 222.47 348.59 222.496C348.552 222.541 348.523 222.549 348.504 222.481C348.5 222.47 348.492 222.461 348.485 222.451Z",
    fill: "#BF9200"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.703 222.296C348.695 222.321 348.687 222.345 348.679 222.37C348.656 222.361 348.648 222.34 348.647 222.317C348.638 222.224 348.623 222.132 348.602 222.041C348.607 222.03 348.613 222.02 348.619 222.008C348.653 222.069 348.688 222.128 348.723 222.188C348.726 222.193 348.728 222.2 348.728 222.206C348.72 222.228 348.721 222.25 348.722 222.273C348.719 222.283 348.715 222.292 348.703 222.296ZM348.812 222.331C348.815 222.328 348.818 222.328 348.822 222.326C348.874 222.379 348.926 222.431 348.977 222.484C348.978 222.502 348.973 222.519 348.964 222.534C348.926 222.519 348.902 222.473 348.852 222.484C348.843 222.481 348.835 222.473 348.83 222.464C348.839 222.418 348.783 222.38 348.812 222.331ZM349.322 222.341C349.326 222.343 349.329 222.346 349.332 222.35C349.351 222.392 349.341 222.433 349.331 222.475L349.316 222.492C349.268 222.479 349.233 222.512 349.196 222.535C349.184 222.519 349.183 222.501 349.182 222.483C349.228 222.436 349.276 222.388 349.322 222.341ZM348.886 222.341C348.951 222.357 348.985 222.405 349.014 222.461C348.962 222.431 348.924 222.386 348.886 222.341ZM349.122 221.189C349.077 221.156 349.045 221.212 349.004 221.205C349.042 221.185 349.069 221.098 349.122 221.189ZM349.028 222.459C349.067 222.501 349.105 222.477 349.142 222.456C349.132 222.489 349.109 222.515 349.077 222.515C349.053 222.514 349.029 222.491 349.028 222.459Z",
    fill: "#BF9200"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.719 222.213C348.719 222.204 348.721 222.196 348.722 222.188C348.741 222.214 348.759 222.24 348.779 222.267C348.774 222.272 348.769 222.278 348.764 222.283C348.727 222.286 348.721 222.256 348.711 222.231C348.711 222.224 348.714 222.218 348.719 222.213ZM349.184 222.416C349.202 222.387 349.212 222.348 349.259 222.357C349.238 222.382 349.22 222.41 349.184 222.416ZM349.274 221.251V221.262C349.248 221.254 349.216 221.255 349.202 221.221C349.229 221.223 349.254 221.233 349.274 221.251ZM348.884 221.262C348.88 221.258 348.875 221.253 348.87 221.249C348.892 221.23 348.917 221.221 348.945 221.237C348.929 221.256 348.906 221.258 348.884 221.262ZM348.841 222.458L348.855 222.474C348.896 222.518 348.899 222.576 348.909 222.63C348.914 222.653 348.912 222.677 348.929 222.697C348.928 222.73 348.906 222.75 348.887 222.774C348.87 222.691 348.857 222.608 348.81 222.534C348.796 222.538 348.79 222.529 348.785 222.517C348.785 222.479 348.798 222.455 348.841 222.458Z",
    fill: "#BF9200"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.795 222.517L348.81 222.534C348.786 222.57 348.76 222.635 348.728 222.629C348.683 222.618 348.713 222.551 348.701 222.51C348.694 222.489 348.697 222.466 348.694 222.444C348.702 222.419 348.711 222.394 348.719 222.371C348.756 222.387 348.752 222.421 348.752 222.452C348.752 222.484 348.761 222.507 348.795 222.517ZM349.628 223.806C349.607 223.81 349.581 223.82 349.577 223.785C349.575 223.753 349.596 223.734 349.619 223.719C349.663 223.693 349.657 223.751 349.687 223.765C349.692 223.713 349.75 223.688 349.732 223.631C349.731 223.628 349.744 223.617 349.752 223.613C349.754 223.612 349.767 223.619 349.767 223.623C349.771 223.68 349.838 223.674 349.854 223.717C349.858 223.728 349.875 223.732 349.878 223.724C349.909 223.666 349.956 223.69 350.004 223.704C349.996 223.663 349.988 223.63 349.982 223.598C349.975 223.565 349.964 223.538 349.922 223.554C349.904 223.562 349.891 223.554 349.889 223.538C349.885 223.517 349.906 223.518 349.919 223.514C349.98 223.499 350.005 223.531 350.017 223.585C350.026 223.635 350.016 223.706 350.107 223.671C350.112 223.669 350.125 223.68 350.129 223.688C350.135 223.701 350.119 223.707 350.113 223.707C350.033 223.702 349.982 223.798 349.894 223.769C349.879 223.765 349.873 223.774 349.868 223.788C349.846 223.84 349.821 223.847 349.774 223.808C349.732 223.772 349.692 223.793 349.663 223.834C349.635 223.843 349.646 223.807 349.628 223.806ZM348.719 223.884C348.779 223.863 348.817 223.838 348.784 223.778C348.773 223.759 348.78 223.741 348.799 223.735C348.817 223.729 348.82 223.748 348.827 223.762C348.833 223.775 348.837 223.792 348.856 223.787C348.876 223.782 348.869 223.763 348.868 223.749C348.867 223.733 348.859 223.712 348.88 223.703C348.904 223.693 348.904 223.721 348.916 223.73C348.952 223.754 348.994 223.739 349.032 223.743C349.067 223.748 349.108 223.739 349.095 223.798C349.127 223.793 349.125 223.766 349.143 223.756C349.163 223.746 349.188 223.729 349.203 223.746C349.217 223.762 349.216 223.792 349.216 223.817C349.217 223.844 349.193 223.844 349.173 223.845C349.137 223.846 349.101 223.839 349.077 223.882C349.065 223.902 349.04 223.901 349.018 223.883C348.942 223.823 348.879 223.821 348.806 223.875C348.785 223.891 348.762 223.895 348.719 223.884ZM348.626 223.83C348.639 223.754 348.653 223.696 348.649 223.635C348.648 223.614 348.655 223.598 348.673 223.598C348.705 223.598 348.69 223.623 348.688 223.637C348.68 223.698 348.671 223.759 348.661 223.821C348.657 223.842 348.641 223.856 348.621 223.862C348.601 223.868 348.588 223.857 348.577 223.842C348.53 223.778 348.458 223.761 348.391 223.801C348.368 223.814 348.347 223.824 348.314 223.813C348.359 223.788 348.392 223.759 348.371 223.704C348.367 223.694 348.376 223.677 348.389 223.675C348.405 223.671 348.407 223.688 348.409 223.7C348.412 223.722 348.416 223.744 348.443 223.75C348.457 223.752 348.469 223.752 348.478 223.743C348.485 223.733 348.474 223.726 348.469 223.718C348.427 223.653 348.513 223.672 348.526 223.638C348.536 223.612 348.57 223.637 348.57 223.659C348.572 223.688 348.656 223.717 348.573 223.745C348.587 223.769 348.602 223.792 348.626 223.83ZM348.084 223.521C348.118 223.499 348.157 223.493 348.181 223.506C348.2 223.517 348.176 223.55 348.17 223.574C348.169 223.579 348.167 223.583 348.167 223.589C348.162 223.619 348.124 223.663 348.16 223.68C348.213 223.702 348.185 223.635 348.206 223.618C348.214 223.612 348.226 223.61 348.243 223.603C348.241 223.619 348.242 223.629 348.241 223.638C348.235 223.664 348.208 223.698 348.257 223.708C348.302 223.719 348.294 223.69 348.294 223.661C348.295 223.639 348.321 223.637 348.341 223.636C348.342 223.639 348.345 223.642 348.344 223.644C348.312 223.776 348.333 223.763 348.203 223.732C348.167 223.724 348.132 223.713 348.096 223.702C348.077 223.697 348.051 223.7 348.049 223.673C348.048 223.646 348.066 223.628 348.092 223.618C348.106 223.614 348.119 223.608 348.13 223.598C348.161 223.563 348.145 223.531 348.084 223.521ZM349.301 223.847C349.241 223.831 349.265 223.788 349.286 223.769C349.327 223.736 349.328 223.7 349.311 223.658C349.302 223.634 349.312 223.622 349.33 223.619C349.351 223.617 349.347 223.638 349.349 223.652C349.354 223.689 349.357 223.726 349.362 223.763C349.364 223.783 349.365 223.807 349.395 223.798C349.417 223.793 349.421 223.778 349.412 223.758C349.405 223.741 349.396 223.723 349.42 223.716C349.452 223.708 349.445 223.738 349.451 223.755C349.47 223.819 349.44 223.84 349.38 223.837C349.357 223.865 349.327 223.842 349.301 223.847ZM349.457 223.884C349.503 223.839 349.536 223.805 349.487 223.759C349.472 223.747 349.485 223.724 349.502 223.717C349.519 223.71 349.524 223.73 349.532 223.742C349.573 223.81 349.557 223.855 349.457 223.884ZM348.725 223.6C348.748 223.612 348.768 223.618 348.758 223.644C348.74 223.688 348.74 223.736 348.736 223.781C348.734 223.797 348.736 223.821 348.711 223.816C348.685 223.812 348.698 223.789 348.7 223.774C348.702 223.744 348.707 223.716 348.711 223.687C348.715 223.66 348.719 223.633 348.725 223.6Z",
    fill: "#BF9200"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.378 223.851C349.393 223.857 349.408 223.869 349.397 223.883C349.378 223.905 349.348 223.888 349.323 223.891C349.307 223.895 349.304 223.874 349.317 223.859C349.335 223.846 349.357 223.849 349.378 223.851ZM349.628 223.806C349.64 223.815 349.65 223.825 349.662 223.833C349.649 223.865 349.625 223.868 349.594 223.863C349.601 223.839 349.645 223.84 349.628 223.806ZM349.283 223.653C349.279 223.667 349.272 223.67 349.262 223.667C349.257 223.666 349.25 223.658 349.25 223.654C349.251 223.642 349.26 223.637 349.271 223.641C349.276 223.643 349.28 223.649 349.283 223.653ZM349.287 223.712C349.281 223.719 349.274 223.728 349.264 223.722C349.256 223.717 349.248 223.709 349.255 223.699C349.26 223.689 349.267 223.682 349.277 223.689C349.286 223.693 349.292 223.701 349.287 223.712ZM350.08 223.761C350.076 223.774 350.067 223.777 350.056 223.776C350.047 223.775 350.035 223.771 350.042 223.758C350.045 223.751 350.055 223.746 350.063 223.744C350.075 223.743 350.079 223.752 350.08 223.761ZM348.116 223.743C348.11 223.754 348.103 223.761 348.092 223.755C348.087 223.752 348.082 223.744 348.083 223.738C348.085 223.729 348.095 223.723 348.105 223.729C348.11 223.731 348.113 223.738 348.116 223.743ZM348.262 223.784C348.255 223.788 348.25 223.795 348.245 223.796C348.233 223.798 348.226 223.789 348.23 223.78C348.232 223.775 348.241 223.77 348.246 223.77C348.25 223.771 348.255 223.778 348.262 223.784ZM348.284 223.372C348.305 223.367 348.328 223.367 348.349 223.372C348.37 223.378 348.39 223.388 348.406 223.403C348.361 223.411 348.322 223.395 348.284 223.372ZM348.106 223.319C348.126 223.313 348.147 223.313 348.167 223.319C348.187 223.325 348.204 223.336 348.218 223.352C348.179 223.359 348.146 223.344 348.106 223.319ZM349.755 223.399C349.789 223.372 349.832 223.366 349.874 223.364C349.875 223.37 349.877 223.376 349.879 223.382L349.761 223.417L349.755 223.399ZM349.933 223.356C349.968 223.32 350.003 223.312 350.054 223.315C350.038 223.33 350.019 223.342 349.998 223.349C349.977 223.356 349.955 223.359 349.933 223.356ZM348.647 223.493H348.886C348.808 223.514 348.725 223.514 348.647 223.493ZM349.019 222.893C349.015 222.893 349.011 222.894 349.007 222.895L349.026 222.762C349.036 222.82 349.041 222.858 349.019 222.893ZM349.127 222.847V222.779C349.146 222.798 349.138 222.816 349.141 222.833C349.148 222.848 349.14 222.85 349.127 222.847Z",
    fill: "#BF9200"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.128 222.847C349.132 222.842 349.137 222.837 349.141 222.833C349.147 222.839 349.15 222.847 349.152 222.855C349.154 222.864 349.154 222.872 349.152 222.881C349.147 222.885 349.143 222.889 349.138 222.893C349.126 222.881 349.125 222.864 349.128 222.847ZM348.716 223.44C348.672 223.45 348.626 223.451 348.582 223.443C348.629 223.406 348.667 223.405 348.716 223.44ZM348.875 223.448C348.843 223.463 348.809 223.46 348.773 223.463C348.778 223.433 348.796 223.435 348.813 223.435C348.832 223.445 348.857 223.428 348.875 223.448Z",
    fill: "#BF9200"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.875 223.448C348.854 223.444 348.831 223.448 348.813 223.435C348.838 223.433 348.862 223.432 348.886 223.432C348.892 223.432 348.901 223.438 348.889 223.445C348.886 223.448 348.88 223.446 348.875 223.448ZM349.567 223.435C349.528 223.449 349.486 223.452 349.446 223.442C349.489 223.401 349.527 223.417 349.567 223.435ZM349.35 223.435C349.365 223.432 349.377 223.438 349.395 223.456C349.359 223.465 349.321 223.462 349.286 223.448C349.305 223.428 349.33 223.445 349.35 223.435Z",
    fill: "#BF9200"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.35 223.435C349.33 223.447 349.308 223.444 349.286 223.447C349.28 223.444 349.253 223.446 349.274 223.435C349.293 223.423 349.323 223.433 349.35 223.435ZM348.719 222.222C348.702 222.235 348.709 222.253 348.704 222.268C348.693 222.248 348.686 222.227 348.696 222.206C348.7 222.196 348.712 222.207 348.719 222.212V222.222ZM348.531 223.681C348.537 223.688 348.544 223.692 348.545 223.698C348.552 223.713 348.538 223.713 348.53 223.712C348.525 223.712 348.517 223.703 348.517 223.699C348.518 223.693 348.525 223.688 348.531 223.681Z",
    fill: "#BF9200"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 284,
    y: 130,
    width: 20,
    height: 16
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M284 130.5H304V145.5H284V130.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_2)"
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284 130.5V145.5H304V130.5H284Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 284,
    y: 130,
    width: 20,
    height: 16
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284 130.5V145.5H304V130.5H284Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 284,
    y: 130,
    width: 20,
    height: 16
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M284 130.5H304V145.5H284V130.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_2)"
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M281.773 144.428L286.174 146.29L304.099 132.524L306.421 129.758L301.715 129.136L294.404 135.068L288.519 139.065L281.773 144.428Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M282.375 145.733L284.618 146.813L305.587 129.501H302.439L282.376 145.732L282.375 145.733Z",
    fill: "#F50100"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M306.227 144.428L301.826 146.29L283.901 132.524L281.579 129.758L286.285 129.136L293.596 135.068L299.481 139.065L306.227 144.428Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M306.077 145.364L303.834 146.444L294.906 139.032L292.258 138.204L281.355 129.767H284.504L295.4 138.004L298.294 138.997L306.077 145.364Z",
    fill: "#F50100"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.361 129.25H291.639V135.5H282.768V140.5H291.639V146.75H296.361V140.5H305.268V135.5H296.361V129.25Z",
    fill: "#F50100"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 282,
    y: 129,
    width: 24,
    height: 18
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.361 129.25H291.639V135.5H282.768V140.5H291.639V146.75H296.361V140.5H305.268V135.5H296.361V129.25Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.639 129.25V128H290.389V129.25H291.639ZM296.361 129.25H297.611V128H296.361V129.25ZM291.639 135.5V136.75H292.889V135.5H291.639ZM282.768 135.5V134.25H281.518V135.5H282.768ZM282.768 140.5H281.518V141.75H282.768V140.5ZM291.639 140.5H292.889V139.25H291.639V140.5ZM291.639 146.75H290.389V148H291.639V146.75ZM296.361 146.75V148H297.611V146.75H296.361ZM296.361 140.5V139.25H295.111V140.5H296.361ZM305.268 140.5V141.75H306.518V140.5H305.268ZM305.268 135.5H306.518V134.25H305.268V135.5ZM296.361 135.5H295.111V136.75H296.361V135.5ZM291.639 130.5H296.361V128H291.639V130.5ZM292.889 135.5V129.25H290.389V135.5H292.889ZM282.768 136.75H291.639V134.25H282.768V136.75ZM284.018 140.5V135.5H281.518V140.5H284.018ZM291.639 139.25H282.768V141.75H291.639V139.25ZM292.889 146.75V140.5H290.389V146.75H292.889ZM296.361 145.5H291.639V148H296.361V145.5ZM295.111 140.5V146.75H297.611V140.5H295.111ZM305.268 139.25H296.361V141.75H305.268V139.25ZM304.018 135.5V140.5H306.518V135.5H304.018ZM296.361 136.75H305.268V134.25H296.361V136.75ZM295.111 129.25V135.5H297.611V129.25H295.111Z",
    fill: "white"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_1_2",
    x: -26.1111,
    y: 43.6425,
    width: 684.667,
    height: 443.676,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.36529
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.223842
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0313726 0 0 0 0 0.262745 0 0 0 0.0414311 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.53973
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4666
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.252036 0 0 0 0 0.19566 0 0 0 0 0.670833 0 0 0 0.0458509 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1_2",
    result: "effect2_dropShadow_1_2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.7451
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5513
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.209938 0 0 0 0 0.141163 0 0 0 0 0.720833 0 0 0 0.0469633 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1_2",
    result: "effect3_dropShadow_1_2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 52.2278
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5556
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.220859 0 0 0 0 0.148507 0 0 0 0 0.758333 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1_2",
    result: "effect4_dropShadow_1_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_1_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 632,
    height: 462,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    fill: "white",
    transform: "translate(284 130.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldMap);
export default __webpack_public_path__ + "static/media/WorldMap.fb628115d22dcf8a69768c6e86de2d01.svg";
export { ForwardRef as ReactComponent };